var _path, _path2, _path3, _path4, _path5, _path6, _g, _path7, _path8, _path9, _path10, _g2, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _use, _use2, _g3, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _use3, _use4, _g4, _path44, _path45, _path46, _path47, _use5, _use6, _g5, _path48, _path49, _path50, _path51, _use7, _use8, _g6, _path52, _path53, _path54, _path55, _use9, _use10, _g7, _path56, _path57, _path58, _path59, _use11, _use12, _g8, _path60, _path61, _path62, _path63, _use13, _use14, _g9, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _g10, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _use15, _g11, _use16, _g12, _use17, _g13, _use18, _g14, _use19, _g15, _use20, _g16, _path89, _path90, _path91, _path92, _g17, _path93, _path94, _g18, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _use21, _g19, _use22, _g20, _use23, _g21, _use24, _g22, _use25, _g23, _use26, _g24, _use27, _g25, _use28, _g26, _use29, _g27, _use30, _g28, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTourGraphic3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    viewBox: "0 0 450 253",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    width: 450,
    height: 253,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M450 0H0v253h450z"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0b0b0b",
    d: "M450 0H0v253h450z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "c",
    width: 25,
    height: 7,
    x: 3,
    y: 3,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M27.2 3.7H3.8v6.1h23.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#c)"
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    fillRule: "evenodd",
    d: "M6.8 3.7a3 3 0 0 0 0 6.1H14a3 3 0 0 1 0-6z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "e",
    width: 4,
    height: 4,
    x: 6,
    y: 5,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9.7 5.1H6.4v3.4h3.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#e)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "f",
    width: 4,
    height: 3,
    x: 6,
    y: 6,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6.5 6.6h3.1v1.2q0 .6-.6.7H7a1 1 0 0 1-.6-.7z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    mask: "url(#f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.4 6.5h3.2v.7H6.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 9V5.8h.6V9zM6.4 9V5.8h.7V9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.4 7.8h3.2v.7H6.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.1 7.7v.8h-.7v-.8zm-.7-.5h.7v-.7h-.7zm3.2 1.3v-.8H9v.8z",
    clipRule: "evenodd"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m9.6 5.9-3.1.6v-.1q0-.5.2-.5l2.4-.5q.3 0 .4.3z"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#g)",
    d: "M14 3.8h10.2a3 3 0 0 1 0 6H14a3 3 0 0 1 0-6Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M25 6.7v.6l-.3.4-.3.2-.4.1h-.4l-.4-.3-.2-.4V6.2l.2-.3q.1-.2.4-.3h.8l.3.3.2.3zm-.5.1v-.4l-.1-.3L24 6h-.2l-.2.2-.1.3v1l.3.2h.4l.2-.2v-.2zM22 5.6V8h-.4V5.6zm.8 0V6h-2v-.4zm-2.2 0V8H20V5.6zM18.8 7h-.6v-.4h.8v-.2l.1-.1V6h-.7v2h-.5V5.6H19l.3.1.2.2v.6l-.3.2H19zm0 1h-.7l.2-.4h.7l.1-.2V7h-.7v-.4h.6v.1h.4l.2.3v.7l-.3.2zm-3.1-2.4h1.4l.3.3.1.4v.3l-.2.3-.3.1h-1v-.3h.7l.2-.2v-.4l-.2-.1h-.6v2h-.5zM17.1 8l-.6-1.1h.5l.6 1zm-1.7-1.3-.1.5-.2.4-.3.2-.4.1h-.5l-.3-.3-.2-.4v-1l.2-.3.3-.3h.9l.3.3.2.3zm-.5.1v-.4l-.2-.3-.3-.2H14l-.1.2-.1.3v1l.2.2h.5l.1-.2.1-.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#h)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "i",
    width: 25,
    height: 14,
    x: 3,
    y: 19,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M23.4 19.2H7.5c-2 0-3.7 1.7-3.7 3.7v5.7c0 2 1.6 3.7 3.7 3.7h16c2 0 3.7-1.7 3.7-3.7v-5.7c0-2-1.7-3.7-3.8-3.7"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#i)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#c1e7fe",
    d: "M23.4 19.2H7.5c-2 0-3.7 1.7-3.7 3.7v5.7c0 2 1.6 3.7 3.7 3.7h16c2 0 3.7-1.7 3.7-3.7v-5.7c0-2-1.7-3.7-3.8-3.7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1c1c1c",
    fillOpacity: 0.8,
    d: "M27.2 19.2H3.8v13.1h23.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13.2 26h-1.4v1.4h-.4V26H10v-.5h1.4v-1.4h.4v1.4h1.4zm3.4-1.4v2.3h-.3L15 25.1V27h-.3v-2.3h.3l1.2 1.8v-1.8zm1.2 2.4-.3-.1-.4-.4v-.8l.2-.3.8-.2.2.2.2.3v.4h-1.3V26h1v-.2l-.2-.2h-.5l-.1.3v.7l.2.2h.5l.2-.2.2.1-.2.2-.2.1zm1.5-.4.5-1.4h.1v.3l-.4 1.4h-.2zm-.3-1.4.4 1.4v.3h-.2l-.5-1.7zm1.4 1.4.3-1.4h.3l-.5 1.7h-.2zm-.4-1.4.4 1.4v.3h-.1l-.5-1.4v-.3z"
  })))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    d: "M41.3 38H8.4a4.7 4.7 0 1 0 0 9.3h32.9a4.7 4.7 0 1 0 0-9.4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#e1e1e1",
    d: "M9.3 41.3v.4h-.7v-.4zm-2 0v1.1h-.7v-1.1zm2 1.5V44h-.7v-1.2zm-2 .8v.4h-.7v-.4zm2.4-2.7H8.2V42h1.5zm-2 0H6.3v2h1.6zm2 1.5H8.2v2h1.5zm-2 .8H6.3v1.2h1.6zm5.5.6h-.5v-.3h.5l.5-.1.3-.3V42l-.1-.3-.3-.2h-1V41h.7l.4.1q.3 0 .4.3l.2.4.1.5v.7a1 1 0 0 1-.7.6zm-.4-2.7v2.7h-.3v-2.7zm3.3 2.4v-1.3l-.2-.1h-.5l-.1.1v.2h-.4v-.2l.2-.2.3-.2h.7l.2.3.1.3v1.4h-.3zm0-.9v.2h-.6l-.2.1v.1l-.1.2v.2h.2l.2.1.4-.2.1-.2.2.2-.1.2-.4.3h-.6l-.3-.3V43l.2-.2.3-.2zm2 .7V43h-.2l-.3-.2h-.3l-.2-.2-.1-.1V42l.1-.1.3-.2h.7l.2.3.1.3h-.3v-.2h-.2l-.2-.1h-.3v.1l-.1.2v.1h.2l.2.2h.4l.3.3v.2l-.2.5H18l-.3.1h-.5l-.2-.3-.1-.3h.3v.2l.3.1h.5zm1.1-2.3v2.8H19V41zm0 1.7H19v-.3l.2-.4.6-.2h.3l.2.1.1.3v1.6h-.3v-1.6h-.2l-.2-.1-.4.2zm1.7-1.7h.4v2.8h-.4zm1.7 1.8v.4q0 .3-.2.3l-.2.3h-.7l-.2-.2-.2-.3v-1l.2-.3.2-.2h.7l.2.3.2.3zm-.3 0v-.3l-.1-.2-.4-.2h-.3l-.1.1-.1.2v.9l.2.2h.5l.2-.2v-.5m.7 0v-.4l.2-.3.3-.2.4-.1h.3l.3.3.2.3v.8l-.2.3-.6.3h-.4l-.5-.6zm.3 0v.3l.1.2.2.2h.5l.2-.2v-.2l.1-.3v-.3l-.1-.2-.2-.2h-.5l-.2.2v.2zm3 .7v-1.3l-.1-.1h-.5l-.1.1v.2h-.4v-.2l.2-.2.2-.2h.7l.3.3.1.3v1.4h-.3zm.1-.9v.2h-.6l-.2.1v.1l-.1.2v.2h.1l.3.1.4-.2v-.2l.2.2v.2l-.4.3h-.6l-.3-.3V43l.2-.2.3-.2zm1.2-.5v1.7h-.4v-2h.4zm.6-.3v.3h-.4l-.1.1-.1.2v.2h-.2v-.3l.2-.3.2-.1zm1.5 1.6V41h.4v2.8h-.4zm-1.3-.6v-.4l.2-.3.6-.3h.3l.2.2.2.3v1l-.2.3-.2.2h-.7l-.2-.3-.2-.3zm.3 0v.3l.1.2.2.2h.2l.5-.2.1-.3v-.6l-.2-.2h-.1l-.2-.1H29l-.2.2v.5m-19.3 8H8l-.4-.4H6.4q-.3 0-.4.4v2.4q0 .4.4.4h3.3l.2-.3v-2q0-.5-.4-.5m0 2.4h-3v-2.4h1l.3.4h1.7zM9.1 52H6.8v-.4h2.3zm-.7.8H6.8v-.4h1.6zm5.1-.7h-.7v-.3h1l.2-.2V51l-.2-.2-.3-.1h-.7v2.4h-.3v-2.7h1l.5.1.3.3.1.4v.5l-.4.2zm1.6-.6v1.7h-.3v-2h.3zm.7-.3v.3h-.4l-.2.1v.2l-.1.2H15v-.3l.1-.3.2-.2zm.2 1v-.4l.2-.4.3-.2h.7l.3.2.2.4v.8l-.2.3-.6.3h-.4l-.5-.6zm.3 0v.3l.1.2.2.2h.5l.2-.2v-.2l.1-.3v-.3l-.1-.3-.2-.1h-.2l-.5.1v.3zm1.9-1h.3v2.5l-.2.2h-.5v-.2h.2l.2-.1zm0-.5v-.2h.3v.3zm1.7 2.5h-.4l-.4-.6-.1-.4v-.5l.3-.3a1 1 0 0 1 1-.2l.2.2.1.3v.6h-1.4V52h1.1v-.3l-.2-.2H20l-.4.1-.1.3v.8l.5.2h.3l.2-.2.2.1-.1.2-.3.1zm2-.3h.2l.2-.2v-.2h.4q0 .3-.2.4l-.6.3h-.4l-.3-.3-.2-.3v-.8l.2-.4.3-.2h.8l.2.3.2.4h-.4v-.3l-.2-.1h-.5l-.2.2v1l.2.2zm2-1.7v.2h-1.1v-.2zm-.7-.5h.3v2.1l.1.1h.3v.3h-.5l-.2-.2zm2.2 2v-.2l-.2-.1-.2-.1h-.3l-.3-.2-.1-.2v-.4l.1-.2.3-.1h.7l.2.3.1.3h-.3v-.2l-.2-.1h-.5l-.1.3v.1h.2l.2.1.4.2.3.1v.3l-.2.4-.2.2h-.8l-.2-.3-.1-.3h.3l.1.2z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#9a9ca5",
    d: "M6.7 61.2v2h-.4v-2zm.6 0v.4H5.7v-.4zm.8 2h-.3l-.5-.7v-.3l.2-.3.2-.1h.6l.2.1.1.3v.4h-1v-.2h.7v-.2l-.1-.1h-.4v.7l.1.1h.4l.2-.1.2.2-.2.1zm1.2-1.1v1.1H9v-1.4h.4zm0 .3H9v-.2l.2-.3.4-.2h.2l.1.2.1.1v1.3h-.3V62h-.4l-.1.2zm.8 0v-.3l.1-.2.2-.1h.6l.1.2v1.3h-.4V62h-.4v.3m1.6-.4v1.8h-.4v-2h.4zm1 .5v.3l-.2.3-.1.1H12l-.2-.1-.1-.3v-.6l.1-.3.2-.1h.5l.1.1.1.3zm-.4 0v-.3a.2.2 0 0 0-.3-.2H12l-.1.1v.2l-.1.1v.4l.1.1h.4v-.4m1-1.4v2.1H13v-2zm1.2 1.8v-.7l-.1-.2H14v.2h-.5V62l.2-.1.2-.1h.6l.2.2v1l.1.1h-.4V63m0-.6v.3H14v.4h.3V63l.1-.1.1.1-.2.2v.1h-.5l-.2-.1v-.6l.3-.1zm1.4-.5v.2H15V62zm-.6-.4h.4V63h.2v.3h-.4l-.2-.1zm1.5 1.9h-.3a1 1 0 0 1-.4-.8v-.3l.2-.3.2-.1h.6l.2.1v.3l.1.3v.1h-1.2v-.2h.8V62h-.4l-.1.2v.5l.2.1h.3l.2-.1.2.2-.1.1zm1.7-.5-.2-.1H18l-.2-.1-.1-.1-.1-.1V62l.3-.1h.5q.2 0 .3.2v.2h-.4v-.1l-.2-.1H18l-.1.2.1.1h.2l.3.1.2.2v.4l-.1.1-.2.1h-.6l-.3-.2V63h.3v.1h.5"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#e1e1e1",
    d: "M8.4 68.8H6.8q-.3 0-.4.4v3.1q0 .3.4.4H9q.4 0 .4-.4V70zm-1.6 3.5v-3.1h1.4v1h1v2.1zm7.8-1.8v.2l-.1.5-.2.4-.4.3H13l-.3-.3-.2-.4V70l.2-.4.3-.3h.9l.4.3.2.4zm-.4.2V70q0-.3-.2-.3l-.2-.2h-.6q-.2 0-.2.2-.2 0-.2.3v1l.2.3.2.2h.6l.2-.2.2-.3zm1.2-.5V72H15v-2h.4zm.6-.3v.3h-.4l-.1.2-.1.1v.2h-.2v-.3l.2-.2q0-.2.2-.2zm.3-.8h.3v2.8h-.3zm1.7 1.8v.4l-.2.4-.3.2H17l-.3-.2-.1-.3-.1-.4v-.6l.2-.3.3-.1.3-.1h.3l.3.3.1.3zm-.4 0v-.5a.4.4 0 0 0-.5-.2H17l-.2.1v.2l-.1.2v.7l.2.2h.6l.1-.2.1-.2zm1.2-1v2h-.4v-2zm-.4-.5h.4v.2h-.3zm1.7.5v.3h-1v-.3zm-.7-.5h.4v2.2h.4v.3h-.5q-.2 0-.2-.2zm1 1.5v-.4l.3-.3.2-.2.4-.1h.4l.3.3.2.3v.8l-.2.4-.7.2H21l-.4-.6zm.4 0v.6l.3.1h.5l.1-.1.1-.3v-.8l-.2-.2h-.3l-.4.2-.1.2zm3.7-1.7V72h-.3v-2.7zm.9 0v.3h-2v-.3zm1 2.7H26l-.5-.5v-.9l.2-.3a1 1 0 0 1 1-.2q.2 0 .3.2l.1.3v.5h-1.4v-.3h1.1v-.2l-.2-.2-.3-.1-.3.2-.2.2v.7l.2.2.4.2.3-.1.2-.2.2.2-.1.1-.3.2zm1.5-1.6V72h-.4v-2h.4zm0 .5h-.2v-.3q0-.3.2-.3l.2-.2.4-.1h.2l.4.4v1.6h-.3v-1.5l-.2-.2H28l-.2.2zm1.2-.1h-.2v-.3l.2-.3.2-.1.4-.1h.2l.2.2.2.2v1.6H30v-1.6h-.2l-.2-.1h-.2l-.2.1v.2zm2-.4v2.4h-.3v-2.8h.3zm1.4.6v.4l-.2.4-.6.2h-.3l-.2-.2-.2-.3v-1l.2-.3.2-.1.3-.1h.4l.2.3.2.3zm-.3 0v-.3l-.2-.2-.4-.2h-.2l-.1.1-.2.2v.9l.3.2h.5l.1-.1.1-.3zm1.1-1.8v2.8H33v-2.8zm1.7 2.5v-1.3h-.2l-.2-.1h-.2l-.2.1v.2h-.4v-.2l.2-.2.3-.2h.7l.3.3v1.5l.1.2H35zm0-.9v.2h-.5l-.2.1-.1.2v.3l.1.1h.2l.5-.2v-.2l.2.2v.2l-.4.3H34l-.2-.2-.1-.3V71l.2-.2.3-.1zm1.7-.8v.3h-1v-.3zm-.7-.5h.4v2.2h.3v.3h-.5l-.1-.2zm2 2.5h-.4l-.5-.5v-.9l.2-.3a1 1 0 0 1 1-.2l.2.2.2.3v.5h-1.5v-.3h1.2v-.2l-.2-.2-.3-.1-.4.2v.2l-.1.3v.4l.1.2.5.2.3-.1.2-.2.2.2-.2.1-.2.2zm2.3-.5v-.2H40l-.3-.2h-.3l-.2-.2-.2-.1v-.5l.2-.1.2-.2h.7l.3.3v.3h-.3v-.1l-.2-.2h-.4l-.1.1v.3l.2.1h.2l.4.2.2.2.1.3v.2l-.2.2-.3.1h-.7l-.3-.3v-.3h.3v.2l.2.1h.6zM8.2 80h-.4v.5h-.6v.4h.6v.6h.4v-.6h.6v-.4h-.6zm.2-1.8H6.8q-.3 0-.4.3v3.2q0 .3.4.4H9q.4 0 .4-.4v-2.4zm.7 3.5H6.8v-3.2h1.4v1h1zm5-1.3h.4l-.2.5-.3.3-.6.1H13l-.3-.3-.2-.4v-1.3l.2-.4.3-.2.5-.1h.5l.3.4.2.5H14V79l-.3-.2h-.6l-.3.2-.1.3v1l.1.4.2.2h.7l.2-.2zm2 .4v-1.5h.3v2h-.3zm0-.4h.2v.4l-.2.3-.2.1-.4.1h-.2l-.4-.4v-1.6h.3v1.5l.1.1.1.1h.5l.2-.3zm2 .4v-.2l-.2-.1h-.2l-.3-.2H17v-.8l.1-.2h.3l.3-.1h.4l.2.3.1.3h-.3v-.2l-.2-.1h-.5l-.1.3v.1h.2l.2.1.4.2.3.2v.2l-.2.5H18l-.3.1h-.5L17 81l-.1-.3h.3v.2l.3.1h.4l.2-.1zm1.6-1.5v.3h-1v-.3zm-.7-.5h.4V81h.3v.3h-.5l-.1-.2zm1 1.5v-.4l.2-.3.3-.3h.8l.3.3.1.3.1.4v.4l-.2.3-.7.3h-.4l-.4-.6zm.3 0v.3l.2.2.1.2h.5l.2-.2.1-.2v-.8l-.3-.2h-.5l-.1.2-.1.2zm2.3-.6v1.6h-.4v-2h.3zm-.1.5h-.2v-.4l.2-.3.3-.2h.6l.3.3v1.7h-.3v-1.6l-.2-.1h-.4l-.2.1v.3zm1.3-.2-.3.1.1-.3.2-.3.2-.2h.6l.2.1.2.3v1.6h-.3V80l-.1-.3-.1-.1H24zm3.6-1.4v2.7h-.3v-2.7zm.9 0v.3h-2.1v-.3zm1 2.7H29l-.5-.6V80l.2-.4a1 1 0 0 1 1-.2l.2.2.2.3v.6h-1.5V80h1.2v-.3l-.2-.2h-.3l-.4.1v.3l-.1.3v.3l.1.2.2.2h.6l.2-.2.2.1-.2.2-.2.2zm1.4-1.6v1.6h-.3v-2h.3zm0 .5h-.2v-.4l.2-.3.3-.2h.6l.3.3v1.7h-.3v-1.6l-.2-.1H31l-.2.1-.1.3zM32 80l-.3.1v-.3l.2-.3.3-.2h.6l.2.1.1.3v1.6h-.3v-1.6l-.2-.1h-.5l-.1.2zm2-.3V82h-.3v-2.7h.3zm1.4.6v.4l-.2.3-.6.3h-.3L34 81l-.1-.3-.1-.4v-.6l.2-.3.3-.2h.6l.3.2.1.4zm-.4 0V80l-.1-.2-.4-.3h-.2l-.2.2v.2l-.2.2v.4l.2.3.1.2h.5l.2-.2.1-.2zm1.2-1.8v2.8h-.4v-2.8zm1.7 2.4v-1.2l-.2-.1h-.6v.2h-.4v-.2l.2-.2h.3l.3-.1h.4l.2.3.1.3v1.3H38zm0-.8v.2h-.6l-.1.1-.2.1v.4h.2l.2.1.4-.2.1-.2.2.2-.1.1-.4.4H37l-.3-.3v-.6l.2-.2h.3l.4-.1zm1.7-.8v.3h-1v-.3zm-.7-.5h.3V81l.1.1h.3v.3h-.5l-.2-.2zm2 2.5h-.5l-.4-.6-.1-.3V80l.3-.4a1 1 0 0 1 1-.2l.2.2.1.3v.6h-1.4V80h1.1v-.3l-.2-.2h-.2l-.4.1-.1.3v.8l.3.2h.5l.2-.2.3.1-.2.2-.3.2zm2.2-.5v-.2l-.1-.1h-.3l-.3-.2H42V80l-.1-.3v-.2l.2-.2h.2l.3-.1h.4l.3.3v.3H43v-.2l-.2-.1h-.6v.4h.2l.3.1.4.2.2.2v.2l-.1.5H43l-.3.1h-.4L42 81l-.1-.3h.3l.1.2.2.1h.4z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#9a9ca5",
    d: "M6.6 90.6H6v-.3h.7v-.1L7 90v-.2h-.1l-.2-.1h-.4v1.7h-.4v-2H7l.3.6v.3l-.3.3zm1.4-.4v1.2h-.4v-1.5H8zm.4-.3v.3h-.3v.1l-.1.1v.1h-.1V90l.2-.1zm.1.7v-.3l.2-.2.2-.2h.6q.2 0 .2.2l.2.2v.6l-.2.3-.2.1H9l-.3-.4zm.4 0v.3l.2.1h.3l.1-.2v-.5l-.1-.1H9zm1.3-.7h.4v1.8l-.2.2H10v-.3h.2zm0-.4v-.2h.3l.1.2v.1zm1.4 1.9h-.3l-.5-.7v-.4l.2-.2.2-.2h.6l.2.1.2.3v.4H11v-.2h.8v-.2l-.1-.1h-.3l-.1.2v.6h.5l.2-.1.2.2-.2.1zM13 91h.2v-.3h.5l-.1.3-.2.2h-.7l-.2-.1-.1-.3v-.6l.1-.2.2-.2h.7l.2.2v.3h-.3v-.1l-.1-.1h-.3l-.1.2v.6zm1.6-1.2v.2h-.9zm-.6-.4h.4V91h.2v.3h-.4l-.2-.1zm2.6 1.3-.2-.1h-.2l-.2-.2-.3-.1-.1-.2v-.4q0-.2.2-.2l.2-.1h.7l.2.2.1.3h-.4v-.1l-.1-.1H16v.4h.4l.2.2.2.1.2.4v.3l-.2.1-.2.1h-.9l-.1-.3-.1-.3h.4v.2h.1l.1.1h.4zm1.4.6h-.4l-.4-.7v-.4l.2-.2.2-.2h.6l.2.1.1.3v.4h-1.1v-.2h.8v-.2l-.1-.1h-.4v.8h.5l.1-.1.2.2v.1zm1.5-1.5v.2h-.8zm-.6-.4h.4V91h.2v.3h-.4l-.2-.1zm1.6.4v.2h-.9zm-.7-.4h.4V91h.2v.3H20l-.1-.1zm1.3.4v1.5h-.4v-1.5zm-.4-.4v-.2h.4v.3zm1.1.7v1.2h-.4v-1.5h.4zm0 .4v-.3l.1-.3.4-.2h.2l.2.2v.1l.1.3v1h-.4v-1.2H22l-.1.2zm2.2-.7h.3v1.7l-.3.3h-.8l-.1-.2.1-.2h.2l.2.1h.2v-.1l.1-.2V90m-1 .7v-.3l.1-.3.5-.2h.2l.2.3v.2l.1.3v.3l-.1.3-.2.1h-.2l-.5-.1-.1-.3zm.4 0v.3l.1.1h.3l.1-.1v-.6l-.1-.1h-.3l-.1.2zm2 .3H25l-.2-.1-.2-.1v-.1l-.1-.2.2-.3.1-.1h.6l.2.2.1.2h-.4V90H25l-.1.1v.1l.1.1h.2l.2.1.2.2.1.2v.2l-.2.2h-.8l-.2-.2h.3v.1z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#e1e1e1",
    d: "M6.2 97.5v2.7h3.5v-2.7zm.8.4v.4h-.4v-.4zM6.6 99v-.3H7v.3zm0 .4H7v.4h-.4zm2.7.4h-2v-.4h2zm0-.8h-2v-.3h2zm0-.7h-2v-.4h2zm4.2.7h-.7v-.3h1l.2-.3V98l-.2-.2h-1v2.3h-.3v-2.6H14l.3.3.1.5v.4l-.4.3zm1.6-.6v1.6h-.3v-2h.3zm.7-.4v.3h-.4l-.2.2v.1l-.1.2H15v-.3l.1-.2.2-.2zm.2 1v-.4l.2-.3.3-.2.4-.1h.3l.3.3.2.3v.8l-.2.4-.6.3-.4-.1-.5-.6zm.3 0v.3l.1.3.2.1h.5l.2-.1v-.3l.1-.2v-.4l-.1-.2-.2-.2h-.5l-.2.2v.2zm1.9-1h.3v2.6l-.2.2h-.5v-.3h.4zm0-.5h.3v.2l-.1.1h-.2zm1.7 2.6-.4-.1-.4-.5-.1-.4v-.5l.3-.3a1 1 0 0 1 1-.2l.2.2.1.3v.5h-1.4v-.3h1.1v-.2l-.2-.2-.2-.1-.4.2-.1.2v.9l.5.2h.3l.2-.3.2.2-.1.2-.3.1zm2-.3h.2l.2-.2v-.2h.4q0 .2-.2.3l-.6.4-.4-.1-.3-.2-.2-.4v-.8l.2-.3.3-.2.4-.1.4.1.2.3.2.3h-.4v-.2l-.2-.2h-.5l-.2.2v1.1l.2.1zm2-1.8v.3h-1.1V98zm-.7-.4h.3v2l.1.1h.3v.3h-.5l-.2-.2zm3-.2v2.6h-.4v-2.6zm.8 0v.2h-2v-.2zm.8 2.4.5-1.8h.4l-.8 2.3-.2.3-.2.2h-.4v-.3h.3l.1-.1.1-.2zm-.4-1.8.5 1.6v.3l-.2.2-.7-2zm2 .4v2.4H29V98h.3zm1.3.6v.5l-.2.3-.6.3-.3-.1-.3-.2-.1-.3-.1-.3v-.6l.2-.3.3-.2.3-.1h.3l.3.3.1.3zm-.4 0v-.3l-.1-.2-.4-.2h-.2l-.2.2v.1l-.2.2v.5l.1.2.2.2h.5l.2-.1.1-.3zm1.6 1h-.3l-.5-.5v-.9l.2-.3a1 1 0 0 1 1-.2l.2.2.1.3.1.4v.1h-1.5v-.3h1.2l-.1-.2-.1-.2-.3-.1-.4.2-.1.2v.7l.1.2.2.1h.5l.3-.2.2.2-.2.2-.2.1zm2.3-.5-.1-.2h-.3l-.3-.1-.2-.1-.2-.2v-.4l.2-.2.2-.2h.7l.3.3v.3h-.3v-.1l-.2-.2h-.4l-.1.1v.3l.1.1h.3l.4.2.2.2v.3l-.1.4-.3.1h-.7l-.3-.3v-.3h.2l.1.2.2.1h.6zM6.5 108a.3.3 0 1 0 0 .5.3.3 0 0 0 0-.6m0-1.2a.3.3 0 1 0 0 .5.3.3 0 0 0 0-.5m0 2.3q-.3 0-.3.3t.3.3.2-.3-.2-.3m.5.5h2.8v-.4H7zm0-1.2h2.8v-.4H7zm0-1.5v.3h2.8v-.3zm6.5 1.5h-.7v-.2h.7l.3-.1.2-.2v-.5l-.2-.2h-1v2.3h-.3v-2.7h1l.5.1.3.3.1.4v.5l-.4.3zm1.6-.6v1.7h-.3v-2h.3zm.7-.3v.3h-.4l-.2.1v.2l-.1.2H15v-.3l.1-.3.2-.2zm.2 1v-.4l.2-.3.3-.2.4-.1h.3l.3.3.2.3v.8l-.2.3-.6.3h-.4l-.5-.6zm.3 0v.3l.1.2.2.2h.5l.2-.2v-.2l.1-.3v-.3l-.1-.2-.2-.2h-.5l-.2.2v.2zm1.9-1h.3v2.5l-.2.2h-.5v-.2h.2l.2-.1zm0-.5v-.2h.3v.3zm1.7 2.5h-.4l-.4-.5-.1-.4v-.5l.3-.4a1 1 0 0 1 1-.2l.2.3.1.3v.5h-1.4v-.3h1.1v-.3l-.2-.2H20l-.4.1-.1.3v.9l.5.2.3-.1.2-.2.2.1-.1.2-.3.2zm2-.3h.2l.2-.1v-.2h.4l-.2.3-.6.3h-.4l-.3-.3-.2-.3v-.8l.2-.3.3-.2.4-.1h.4l.2.3.2.4h-.4v-.2l-.2-.2h-.5l-.2.2v1l.2.2zm2-1.7v.3h-1.1v-.3zm-.7-.5h.3v2.2h.3v.3h-.4l-.2-.2zm3.5 1.8-.2-.2h-.2q0-.2-.3-.2l-.3-.1-.3-.2-.2-.2v-.3l.2-.5.3-.2h.4l.5.1.3.3.1.4h-.3l-.1-.3-.2-.2h-.6l-.2.2v.4l.3.2h.2l.4.2.3.2.2.2v.6l-.2.2-.3.2h-.8l-.3-.2-.2-.2-.1-.4h.3v.3l.2.1.2.1h.6l.2-.2zm2 .2v-1.5h.3v2h-.4zm0-.4v.4l-.1.3-.3.2h-.6l-.3-.4v-1.6h.2v1.5l.2.1v.1h.6l.1-.3zm.8-2h.3v2.9h-.3zm1.7 1.9v.4l-.2.3-.3.3h-.6l-.3-.2-.1-.3-.1-.4v-.6l.2-.3.3-.2h.6l.3.3.1.3zm-.4 0v-.5l-.3-.2h-.4l-.2.1v.2l-.1.2v.7l.2.2h.5l.2-.2v-.2zm2.7-1.7v2.7H33v-2.7zm.8 0v.3h-2v-.3zm.8 2.5.6-1.8h.3l-.8 2.3-.2.3-.1.1h-.4v-.2h.2l.2-.1v-.2zm-.4-1.8.5 1.5.1.4-.2.1-.8-2zm2 .4v2.4h-.4v-2.8h.3zm1.3.6v.4l-.2.3-.6.3H37l-.2-.2-.2-.3v-1l.2-.3.2-.2h.7l.2.3.2.3zm-.3 0v-.3l-.2-.2-.4-.2H37l-.2.1v.2l-.1.2v.7l.3.2h.5l.1-.2.1-.2zm1.6 1h-.4l-.5-.5v-.9l.2-.4a1 1 0 0 1 1-.2l.2.3.2.3v.5h-1.5v-.3h1.2v-.3l-.2-.2h-.3l-.4.1v.3l-.1.3v.3l.1.3.5.2.3-.1.2-.2.2.1q0 .2-.2.2l-.2.2zm2.3-.5v-.2h-.2q0-.2-.3-.2h-.3l-.2-.2-.1-.1v-.5l.1-.2h.2l.3-.1h.4l.3.3.1.3h-.3v-.2l-.2-.1h-.5l-.1.1v.3h.2l.2.1.4.2q.2 0 .2.2l.1.2v.3l-.2.2h-.2l-.3.1h-.5l-.3-.3v-.3h.3v.2l.2.1h.6zm-35.2 7.6v.4q0 .2-.2.2H6v.8h.2q.2 0 .2.2v.4q0 .5.6.6h.6v-.4H7l-.2-.2v-.4q0-.5-.4-.6.3-.1.4-.6v-.4l.2-.2h.6v-.4H7q-.5 0-.6.6m3.3.6-.2-.2v-.4q0-.5-.6-.6h-.5v.4h.5q.3 0 .2.2v.4q0 .5.4.6-.4.1-.4.6v.4l-.2.2h-.5v.4h.5q.6 0 .6-.6v-.4l.2-.2h.2v-.8zm3.8.5h-.7v-.3h1l.2-.2v-.5l-.2-.2-.3-.1h-.7v2.4h-.3V116h1l.5.1.3.3.1.4v.4l-.4.3zm1.6-.6v1.7h-.3v-2h.3zm.7-.3v.3h-.4l-.2.1v.2l-.1.2H15v-.3l.1-.3.2-.2zm.2 1v-.4l.2-.4.3-.2h.7l.3.2.2.4v.8l-.2.3-.3.2-.3.1h-.4l-.3-.3-.2-.3zm.3 0v.3l.1.2.2.2h.5l.2-.2v-.2l.1-.3v-.3l-.1-.3-.4-.2h-.3l-.2.2v.3zm1.9-1h.3v2.5l-.2.2h-.5v-.2h.2l.2-.1zm0-.5v-.2h.3v.2l-.1.1zm1.7 2.5h-.4l-.4-.6-.1-.4v-.5l.3-.3a1 1 0 0 1 1-.2l.2.2.1.3v.6h-1.4v-.3h1.1v-.3l-.2-.2H20l-.4.1-.1.2v.9l.5.2h.3l.2-.2.2.1-.1.2-.3.1zm2-.3h.2l.2-.2v-.2h.4q0 .3-.2.4l-.6.3h-.4l-.3-.3-.2-.3v-.8l.2-.4.3-.2h.8l.2.3.2.4h-.4v-.3l-.2-.1h-.5l-.2.1v1.1l.2.2zm2-1.7v.2h-1.1v-.2zm-.7-.5h.3v2.1h.1l.1.1h.1v.3h-.4l-.2-.2zm2.8 2.5h-.6v-.3h.6l.4-.1q.3-.1.3-.4l.1-.5v-.6l-.2-.3-.3-.2h-.9v-.3h1.1l.3.3.3.4v1.2a1 1 0 0 1-.6.7zm-.4-2.7v2.7h-.4V116zm3.2 2.3v-1.2l-.2-.1H28v.2h-.4v-.2l.2-.2.3-.1h.7l.3.2v1.5l.1.2H29v-.3m0-.8v.2h-.7l-.1.2v.3l.1.2h.2l.5-.2v-.2l.2.2v.1l-.4.3-.3.1h-.4l-.2-.3-.1-.3v-.3l.2-.2.3-.1h.8m1.7-.8v.2h-1v-.2zm-.7-.5h.3v2.1h.2v.1h.2v.3H30l-.1-.2v-2.3m2.3 2.1v-1.2l-.2-.1h-.6v.2H31v-.2l.2-.2.3-.1h.7l.2.2.1.4v1.3h-.3zm0-.8v.2h-.7l-.2.2v.3l.2.2h.2l.4-.2.1-.2.2.2-.1.1-.4.3-.3.1h-.3l-.3-.3v-.6l.2-.2.3-.1z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#9a9ca5",
    d: "M6.6 128.1H6v-.3h.7v-.1l.1-.2v-.2h-.1l-.2-.1h-.4v1.6h-.4v-2h.8l.4.1.3.6v.3l-.3.2zm1.7.8h-.4l-.3-.5v-.6l.1-.3.2-.1h.6l.2.1.1.3v.4h-1v-.2h.8v-.2l-.1-.1H8v.7l.1.1h.4l.1-.1.2.2-.1.1-.2.1zm.7-.8v-.3l.2-.3.2-.1h.6l.3.1v.3l.1.3v.3l-.1.2-.3.2h-.6l-.2-.2-.1-.2zm.4 0v.3l.2.1h.3l.1-.2v-.5l-.1-.1h-.4zm1.7-.5v1.8h-.4v-2h.3zm1 .5-.1.3-.1.2-.5.3h-.2l-.2-.2v-.3l-.1-.3v-.3l.1-.3.2-.1h.5l.2.1v.3zm-.5 0v-.3a.2.2 0 0 0-.3-.2h-.1l-.1.1v.8h.4l.1-.2zm1-1.4v2.1h-.3v-2zm1 2.2h-.2l-.4-.5v-.6l.1-.3.3-.1h.5l.2.1.2.3v.4h-1.2v-.2h.8v-.2l-.1-.1h-.4v.7l.2.1h.3l.2-.1.2.2-.2.1-.2.1z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#e1e1e1",
    d: "M6.4 136.5q.3 0 .4-.4 0-.3-.4-.4-.3 0-.4.4 0 .3.4.4m.2.2h-.2l-.5.1q-.3.1-.3.4v.3h.9v-.3zm3-.2q.2 0 .3-.4 0-.3-.4-.4-.3 0-.4.4 0 .3.4.4m.7.7q0-.3-.2-.4h-.8l.1.4v.3h1zm-1.5-.5a2 2 0 0 0-1.7 0q-.3.1-.3.5v.3H9v-.3q0-.4-.3-.5m-1.6.4.2-.1h1.2l.1.1zm.8-1.6.2.2q0 .3-.2.2t-.2-.2.2-.2m0-.3a.6.6 0 1 0 0 1.1.6.6 0 0 0 0-1.1m6.2 1.5h.4l-.2.4-.3.3-.6.1H13l-.3-.3-.2-.4v-1.3l.2-.4.3-.2.5-.1.5.1.3.3.2.5H14v-.3l-.3-.2-.3-.1h-.3l-.3.2-.1.3v1.1l.1.3.2.2h.7l.2-.2zm1.2-2v2.8h-.4v-2.8zm.9.8v2h-.4v-2zm-.4-.5.2-.1h.1l.1.2v.1zm1.7 2.5h-.3l-.5-.5v-.9q0-.3.2-.3l.6-.3h.4l.2.3.2.3v.5h-1.5v-.3H18v-.3l-.2-.2h-.5l-.2.2-.1.2v.6l.1.3.2.1h.6l.2-.2.2.2-.2.1-.2.2zM19 136v1.6h-.3v-2h.3zm0 .5h-.2v-.3l.2-.3.6-.3h.3l.2.1.1.3v1.6H20V136l-.2-.2h-.2l-.4.2zm2.6-.9v.3h-1v-.3zm-.7-.5h.3v2.2h.4v.3h-.5l-.1-.2-.1-.3zm2.3 2v-.2H23l-.3-.2h-.3l-.2-.2-.2-.1v-.5l.2-.1.2-.2h.7l.3.3v.3h-.3v-.2h-.2l-.2-.1h-.2l-.1.1v.3l.2.1h.2l.4.2.2.2v.3l-.1.4H23l-.3.1h-.4l-.3-.3v-.3h.3v.2l.2.1h.6zm-16.8 9.7v-.2l.1-.1 1.1-.3.1-.4h-.1q-.8 0-1.3.4-.3 0-.3.4v.6h1.8l-.1-.4zm1.2-1.2a.8.8 0 1 0 0-1.6.8.8 0 0 0 0 1.6m0-1.2q.4 0 .4.4a.4.4 0 0 1-.8 0q0-.4.4-.4m2.1 2 .2-.2-.2-.4-.3.1-.2-.1v-.3h-.4v.3l-.3.1h-.3l-.2.3.2.2v.2l-.2.2.2.3h.5v.4h.5v-.3l.2-.2.3.1.2-.3zm-.7.4a.4.4 0 0 1-.4-.4q0-.3.4-.4.3 0 .4.4 0 .3-.4.4m5.1-.8h.4l-.2.5-.3.3-.6.1H13l-.3-.3-.2-.4v-1.3l.2-.4.3-.2.5-.1h.5l.3.4.2.5H14v-.4l-.3-.2h-.6l-.3.2-.1.3v1l.1.3.2.2.3.1h.4l.2-.3zm1.1-.8v1.7H15v-2h.3zm.6-.3v.3h-.3l-.2.1v.2l-.1.2H15v-.3l.1-.3.2-.2zm1.1 2h-.3l-.5-.6v-.9l.2-.3a1 1 0 0 1 1-.2l.2.2.2.3v.6h-1.5v-.3h1.2v-.3l-.2-.2h-.3l-.4.1v.3l-.1.3v.3l.1.2.5.2h.3l.2-.2.2.1-.2.2-.2.2zm1.7-.4.5-1.6h.2v.3l-.5 1.7h-.2zm-.3-1.6.4 1.6v.4h-.2l-.6-2zm1.5 1.6.4-1.6h.4l-.6 2h-.2zm-.4-1.6.5 1.6v.4h-.2l-.5-1.7v-.3zM9.1 155h-.7v.4H9zm0 .7h-.7v.2H9z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#e1e1e1",
    d: "M9.5 154h-1v-.5q0-.3-.3-.4h-.4q-.3 0-.4.4v.6h-1q-.3 0-.4.4v2.1q0 .3.4.4h3.1q.4 0 .4-.4v-2.1q0-.4-.4-.4m-1.7-.5h.4v1h-.4zm1.7 3.1h-3v-2.1h.9q0 .4.4.4h.4q.3 0 .4-.4h1z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#e1e1e1",
    d: "M7.4 155.7a.3.3 0 1 0 0-.6.3.3 0 0 0 0 .6m.4.2H7q-.2 0-.2.3H8q0-.3-.2-.3m6.2-.3-.1-.2-.1-.1-.2-.1-.3-.1-.4-.2-.2-.1-.2-.3v-.2l.2-.6.3-.1h.8l.4.4v.3H14v-.2l-.2-.2H13l-.2.1v.4l.1.1.2.2h.3l.4.2.3.2.1.2v.6l-.2.2-.3.1H13l-.3-.1-.3-.3v-.3h.3v.2l.2.2h.8l.2-.1zm1.5-1.3v.2h-1v-.2zm-.7-.5h.3v2.1h.4v.3H15l-.1-.1-.1-.3zm2.3 2.1v-1.2l-.2-.2h-.5l-.1.2v.1h-.4v-.2l.2-.2.2-.1h.8l.2.2.1.4v1.3h-.3zm0-.9v.3h-.8v.2l-.1.1v.2l.1.1h.3l.4-.1.1-.2.1.1v.2l-.4.3h-.6l-.3-.2v-.6l.2-.2.3-.1zm1.3 1.2h-.3v-2.5l.3-.2.4-.1h.2v.3h-.4l-.1.2v2.3m.5-2v.3h-1.1v-.2zm.8 2h-.3v-2.5l.3-.2.4-.1h.2v.3H20l-.1.2zm.5-2v.3H19v-.2z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "l",
    width: 385,
    height: 15,
    x: 60,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#k"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#l)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "m",
    width: 385,
    height: 15,
    x: 60,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#k"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#m)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e1e1e1",
    d: "M422.6 8.9h.4v-.5h-.4zm.2-3.7a2.3 2.3 0 1 0 0 4.6 2.3 2.3 0 0 0 0-4.6m0 4.2a1.9 1.9 0 1 1 0-3.8 1.9 1.9 0 0 1 0 3.8m0-3.3a1 1 0 0 0-1 1h.5q.1-.5.5-.5t.5.4c0 .5-.7.4-.7 1.2h.4c0-.5.8-.6.8-1.2q-.1-.9-1-1m9.4-1-2.1.9v1.4a3 3 0 0 0 2 2.8 3 3 0 0 0 2.2-2.8V5.9zm1.6 2.3q0 .6-.3 1.2l-.3-.4a1.2 1.2 0 1 0-.4.4l.4.4q-.4.5-1 .7-1.6-.6-1.7-2.3V6.2l1.7-.8 1.6.8zm-1.6.9a.7.7 0 1 1 0-1.4.7.7 0 0 1 0 1.4m12.2-.7a2.8 2.8 0 1 0-5.6 0 2.8 2.8 0 0 0 5.6 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1c1c1c",
    d: "M442 8v-.2l-.2-.2h-.2l-.3-.2h-.2l-.2-.7.2-.1.2-.2h.7q0 .2.2.3V7h-.2v-.2l-.2-.1h-.5l-.1.2v.2l.2.1.2.1.3.1.2.2.2.1v.4l-.2.2-.2.1h-.8l-.2-.3V8h.2l.1.3h.6z"
  })))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#n)",
    d: "M157.3 18.3v4h-1.1v-5.1h1zm-.2 1.3h-.4q0-.6.2-1 0-.5.4-.8a2 2 0 0 1 1.5-.7h.7l.5.4.3.6.2 1v3.3h-1.2V19l-.1-.6-.3-.3h-.5a1 1 0 0 0-1 .4l-.2.5z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#o)",
    d: "m150.4 19.8.1-1.1.5-.9.8-.5q.4-.2 1-.2t1 .2l.8.5.4.9.2 1v.1q0 .6-.2 1 0 .6-.4 1l-.8.5-1 .2-1-.2q-.5-.2-.8-.6l-.5-.8zm1.1 0v.7l.3.5.4.4.6.1a1 1 0 0 0 1-.5l.2-.5V19l-.3-.6a1 1 0 0 0-1-.5l-.5.1-.4.4-.2.6z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#p)",
    d: "M148.4 21v-.3l-.4-.3-.7-.2-.8-.2-.5-.3-.4-.5-.2-.6.2-.6.4-.5.6-.3.8-.1q.8 0 1.2.2t.7.6q.2.3.2.8h-1.1l-.1-.4-.3-.3h-1q-.3 0-.3.3v.7l.4.2.6.1 1 .3.6.5q.3.3.3.8l-.2.6q0 .3-.4.5l-.7.4h-.8q-.8 0-1.2-.2l-.8-.6-.2-.9h1l.3.6.4.2.5.1h.5l.3-.3z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#q)",
    d: "M141.2 18.3v4H140v-5.1h1.1zm-.2 1.3h-.4q0-.6.2-1 0-.5.4-.8a2 2 0 0 1 1.5-.7h.7l.5.4.3.6.1 1v3.3h-1.1V19l-.1-.6-.4-.3h-.5a1 1 0 0 0-.9.4l-.2.5z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#r)",
    d: "M135.7 15v7.4h-1.1V15zm-.2 4.6h-.4q0-.6.2-1 0-.5.4-.8a2 2 0 0 1 1.5-.7h.7l.5.4.3.6.2 1v3.3h-1.2V19l-.1-.6-.3-.3h-1.1l-.4.4-.2.5z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#s)",
    d: "m128.8 19.8.1-1.1.5-.9.8-.5q.4-.2 1-.2t1 .2l.8.5.4.9.2 1v.1q0 .6-.2 1 0 .6-.4 1l-.8.5-1 .2-1-.2q-.5-.2-.8-.6l-.5-.8zm1.1 0v.7l.3.5.4.4.6.1a1 1 0 0 0 1-.5l.2-.5V19l-.3-.6a1 1 0 0 0-1-.5l-.5.1-.4.4-.2.6z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#t)",
    d: "M126.5 20.3v-5h1.2v5q0 .6-.3 1.2l-.8.7q-.5.3-1.2.3l-1.2-.3q-.5-.1-.8-.6l-.3-1.2h1.3v.6l.5.4.5.1.6-.1.4-.4z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#u)",
    d: "M113.6 18.2v4.2h-1.1v-5.2h1zm-.1 1.4h-.4l.1-1q0-.5.4-.8l.6-.5q.4-.2 1-.2h.6l.5.4.3.6.2.8v3.5h-1.2V19l-.1-.6-.3-.3H114l-.4.4-.2.5zm3.2-.3h-.6l.2-.8q0-.4.4-.7a2 2 0 0 1 1.5-.7h.7l.5.4.4.6v4.3h-1V19l-.2-.6q0-.2-.3-.3h-1l-.3.3-.2.4z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#v)",
    d: "M110.1 21.3v-2.9l-.4-.3-.5-.2-.5.1-.3.3-.1.4H107l.2-.6q0-.3.4-.5l.7-.4.9-.1 1 .2q.5.2.7.6.3.4.3 1v2.9l.2.5h-1.2l-.1-.4zm.2-2v.6h-1.4l-.4.3-.3.6v.4l.3.3h.5a1 1 0 0 0 1-.5l.2-.4.4.6-.2.4-.4.4a2 2 0 0 1-1.2.5l-1-.2-.6-.6-.2-.8q0-.4.2-.7 0-.3.4-.5l.8-.4z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#w)",
    d: "M105 20.6v-.4l-.3-.3-.4-.3-.8-.3-1-.3-.6-.4-.5-.6-.2-.8a2 2 0 0 1 .7-1.4l.8-.4 1-.1q.8 0 1.3.3l1 .7.2 1.1H105l-.1-.6-.5-.4-.7-.2q-.4 0-.7.2l-.5.3v.9l.3.3.4.2.7.3q.6 0 1 .3l.8.5a2 2 0 0 1 .5 1.4l-.1.8-.6.6-.7.3a4 4 0 0 1-3-.4l-.6-.7-.2-1h1.2l.1.6q0 .3.3.4l.5.3h1.3l.5-.4z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#x)",
    d: "M97.7 21.3v.8l-.3 1-.6.8-.7-.3.3-.5.2-.4v-1.4z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#y)",
    d: "M93.6 22.5q-.7 0-1-.2a2 2 0 0 1-1.3-1.4q-.3-.4-.2-1v-.1q0-.6.2-1.1 0-.6.5-.9l.7-.5q.4-.2 1-.2l1 .2q.3.1.6.5l.4.8.2 1v.5h-4v-.8h2.8v-.1l-.1-.6-.3-.4-.7-.2-.5.1-.3.4-.3.5v1.6l.3.5.5.3.5.1A2 2 0 0 0 95 21l.6.6-.5.5-.6.3z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#z)",
    d: "M83.9 18.2v4.2h-1.2v-5.2h1.1zm-.2 1.4h-.4l.1-1 .4-.8.7-.5q.3-.2.9-.2h.6l.5.4.4.6v4.3h-1V19l-.2-.6-.3-.3h-1.1l-.3.4-.2.5zm3.2-.3h-.5l.1-.8q0-.4.4-.7a2 2 0 0 1 1.5-.7h.7l.5.4.4.6.1 1v3.3h-1.2v-4l-.4-.3h-1l-.3.3-.2.4z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#A)",
    d: "M77 19.8v-1.1l.5-.9.8-.5q.4-.2 1-.2t1 .2l.8.5.5.9.1 1v.1l-.1 1-.5 1a2 2 0 0 1-1.8.7l-1-.2-.8-.6-.4-.8zm1 0 .1.7q0 .3.3.5 0 .3.4.4l.5.1a1 1 0 0 0 1-.5l.2-.5V19l-.2-.6a1 1 0 0 0-1-.5l-.5.1-.4.4-.3.6z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#B)",
    d: "M74.1 21.5h.5l.4-.4.1-.4h1.1q0 .4-.3.9l-.7.6q-.5.3-1 .3l-1.1-.2-.7-.6-.5-.8-.1-1v-.2l.1-1 .5-.9q.2-.3.7-.5t1-.2 1.1.2l.8.7.2 1h-1l-.2-.5-.4-.4-.5-.1-.6.1-.3.4-.2.6v1.4q0 .3.2.5 0 .3.3.4z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#C)",
    d: "M70.7 15v7.4h-1.1V15z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#D)",
    d: "M66.5 22.5q-.6 0-1-.2a2 2 0 0 1-1.3-1.4q-.2-.4-.2-1v-.1q0-.6.2-1.1.1-.6.5-.9l.7-.5q.4-.2 1-.2l1 .2q.3.1.6.5l.4.8.2 1v.5h-4v-.8h2.8v-.1l-.1-.6-.3-.4-.7-.2-.5.1-.3.4-.3.5v1.6l.3.5.5.3.6.1a2 2 0 0 0 1.3-.6l.6.6-.5.5-.6.3z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#E)",
    d: "m57.6 20.8 1.3-5.4h.8l-.1 1.4-1.5 5.6h-.8zm-1-5.4 1 5.4.1 1.6H57l-1.6-7zm4.7 5.3 1-5.3h1.3l-1.6 7h-1zM60 15.4l1.3 5.4.2 1.6h-.7l-1.5-5.6v-1.4z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#1c1c1c",
    fillOpacity: 0.8,
    d: "M324.8 28.6H59.1c-2 0-3.6 1.6-3.6 3.5v57c0 1.9 1.6 3.5 3.6 3.5h265.7c2 0 3.6-1.6 3.6-3.5V32c0-1.9-1.6-3.5-3.6-3.5"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#F)",
    strokeWidth: 0.5,
    d: "M324.8 28.6H59.1c-2 0-3.6 1.6-3.6 3.5v57c0 1.9 1.6 3.5 3.6 3.5h265.7c2 0 3.6-1.6 3.6-3.5V32c0-1.9-1.6-3.5-3.6-3.5Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#9a9ca5",
    d: "M89 36.5v-.2l-.2-.1-.4-.2H88l-.3-.3-.3-.2v-.7l.3-.3.3-.2h.5l.7.1.4.3.1.5H89V35l-.2-.2h-.6l-.1.2v.3l.2.2h.3l.6.2.4.3.1.5-.3.6-.4.2h-1.2l-.4-.5-.1-.4h.6l.1.3.2.1h.6l.2-.1zM85 33v4.3h-.6v-4.2zm1.9 1.3-1.3 1.5-.7.7-.2-.6.5-.6.9-1zm-.7 3-1-1.4.5-.5 1.3 1.9zM81.8 35v2.3H81v-3h.6zm-.1.7h-.2v-.6l.3-.4a1 1 0 0 1 .8-.4h.4l.3.2.2.4v2.4H83V35l-.2-.1h-.3l-.5.2-.2.3zm-1.4-1.4v3h-.7v-3zm-.7-.7v-.3l.4-.1.2.1.1.3v.2l-.3.1-.3-.1zm-.6 3.2v.5h-2v-.5zm-1.8-3.5v4h-.7v-4zm-4.6-.3v4.3h-.7v-4.2zm1.8 1.3-1.3 1.5-.7.7-.2-.6.6-.6.8-1zm-.7 3-1-1.4.5-.5 1.3 1.9zm-3.7-.5h.3l.3-.2v-.3h.7q0 .3-.2.5l-.4.4-.6.2q-.5 0-.6-.2-.3 0-.4-.3t-.3-.5v-1.2q0-.2.3-.5l.4-.3.6-.1.6.1.4.4.2.6h-.6l-.1-.3-.2-.2-.3-.1h-.4l-.2.3v.3l-.1.4v.4l.1.3.2.2zm-2-2.5v3h-.7v-3zm-.7-.7.1-.3.3-.1.3.1v.5l-.3.1-.3-.1zm-1.4 3v-2.3h.6v3H66zm0-.6h.3l-.1.5-.2.5-.4.3h-.9l-.3-.2-.2-.3v-2.5h.6v2.2l.2.2h.1l.2.1h.4l.3-.4zm-3.6.8 1 .8-.4.4-1-.8zm1-1.6v.2l-.1.8q0 .5-.3.6l-.6.4-.6.2q-.4 0-.7-.2-.3 0-.5-.4-.3-.1-.4-.6l-.1-.8v-.2l.1-.8q.1-.5.4-.6l.5-.4.7-.2.6.2q.3 0 .6.4l.3.6zm-.7.2v-.8l-.2-.4-.3-.3h-.8q-.3 0-.3.3l-.2.4-.1.6v.8l.3.4q0 .2.3.3h.8l.3-.3.2-.4z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#242424",
    d: "M107.5 43.7H60.9q-.7 0-.8.9v17.8q.1.7.8.8h46.6q.7-.1.8-.8V44.6q-.1-.8-.8-.9"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    stroke: "#616467",
    strokeWidth: 0.5,
    d: "M107.5 43.7H60.9q-.7 0-.8.9v17.8q.1.7.8.8h46.6q.7-.1.8-.8V44.6q-.1-.8-.8-.9Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "H",
    width: 5,
    height: 4,
    x: 64,
    y: 47,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#G"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#H)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "I",
    width: 5,
    height: 4,
    x: 64,
    y: 47,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#G"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#I)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0066da",
    d: "m65 50.4.1.3.2.2.6-1h-1.2v.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00ac47",
    d: "m66.6 48.6-.6-1-.2.2-1 1.8-.1.2h1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ea4335",
    d: "m67.8 50.9.2-.2v-.1l.4-.6v-.2h-1.1l.2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00832d",
    d: "m66.6 48.6.6-1H66z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2684fc",
    d: "M67.3 49.8h-1.4l-.6 1 .2.1h2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffba00",
    d: "m67.8 48.7-.5-1h-.1l-.6 1 .7 1.1h1.1v-.2z"
  })))), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#e1e1e1",
    d: "M90.4 50.3H90l-.5-.6v-.9l.2-.3a1 1 0 0 1 1-.2l.2.2.2.3v.6h-1.4V49h1.1v-.3l-.2-.2h-.3l-.4.1v.2l-.1.4v.3l.2.2.1.2h.6l.2-.3.2.2-.1.2-.3.1zm-2-.3.5-1.7h.4l-.8 2h-.2zm-.5-1.7.6 1.7v.3h-.2l-.7-2zm-.7 0v2H87v-2zm-.4-.6.1-.1h.2v.3h-.3zm-.8.9v1.7h-.4v-2h.3zm.5-.3v.3h-.3l-.2.1v.2l-.1.2h-.1v-.3l.1-.3.2-.2zm-2.6 2h-.6V50h.6q.3 0 .5-.2l.3-.3v-1.1l-.2-.3-.2-.2h-1v-.3h1.1l.4.3.2.4.1.5v.7a1 1 0 0 1-.7.7zm-.4-2.7v2.7h-.3v-2.7zM81 50.3h-.4l-.4-.6v-.9l.2-.3a1 1 0 0 1 1-.2l.2.2.1.3v.6h-1.4V49h1.2l-.1-.3-.1-.2H81l-.4.1-.1.2v.7l.1.2.2.2h.5l.3-.3.2.2-.2.2-.2.1zm-1.3-2.9v2.9h-.4v-2.9zm-1.2.9h.3v2l-.1.4-.3.2-.7.1-.3-.1-.2-.2.2-.2.2.2h.6l.2-.2zm-1.4 1v-.5l.2-.3.6-.3.3.1.2.2.2.3v.9q0 .3-.2.3l-.2.2h-.6l-.3-.2-.1-.3zm.3 0v.3l.2.2.1.1.3.1h.2l.2-.3.1-.2v-.6l-.2-.2-.1-.1h-.5l-.1.1-.1.3zm-2.3 0v-.5l.2-.3.3-.2h.7l.3.2.2.3v.9l-.2.3-.6.3h-.4l-.5-.6zm.3 0v.3l.1.2.2.2h.5l.2-.2v-.2l.1-.3V49l-.1-.3-.2-.1H76l-.5.1v.3zm-2.5 0v-.5l.3-.3.2-.2h.8l.3.2.2.3v.9l-.2.3-.7.3h-.4l-.4-.6zm.4 0v.5l.3.2h.5l.1-.2.1-.2v-.9l-.2-.1h-.3l-.4.1-.1.3zm-.8-.3v.9l-.5.3h-1l-.3-.2-.2-.4v-1.3l.2-.4.3-.3h1l.3.3.2.5H72V48l-.3-.2h-.6l-.3.2v.3l-.1.4v.6q0 .3.2.3l.5.3h.3l.2-.1h.1v-.7h-.6V49z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "#2196f3",
    d: "M67.8 58.7h-2.5v-2.5h1.3V56h-1.3q-.3 0-.3.3v2.5q0 .3.3.3h2.5q.3 0 .3-.3v-1.3h-.3zm-.9-2.8v.3h.6L65.8 58l.3.3 1.7-1.7v.6h.3V56zm11.5.5v2.1h-.3L77 57v1.5h-.4v-2.1h.4l1 1.5v-1.5zm-2.1 1.8v.3h-1.2v-.3zm-1-1.8v2.1h-.4v-2.1zm.8.9v.3h-1v-.3zm.2-1v.4H75v-.3zm-2.7 1.4h-.5v-.3h.8l.1-.2V57l-.1-.2h-.7v1.8h-.4v-2.1h1.3l.3.6v.4l-.3.2zm-1.3-.3v.4l-.2.4-.3.2h-.7l-.3-.2-.2-.4v-1l.2-.3.3-.2h.7l.3.2.2.3zm-.3.1v-.4l-.2-.3-.1-.1h-.5l-.1.1-.1.3v1l.2.1h.5l.1-.1.1-.3z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#242424",
    d: "M161 43.7h-46.5q-.8 0-.8.9v17.8q0 .7.8.8H161q.8-.1.8-.8V44.6q0-.8-.8-.9"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    stroke: "#616467",
    strokeWidth: 0.5,
    d: "M161 43.7h-46.5q-.8 0-.8.9v17.8q0 .7.8.8H161q.8-.1.8-.8V44.6q0-.8-.8-.9Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "K",
    width: 4,
    height: 4,
    x: 118,
    y: 47,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#J"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#K)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "L",
    width: 4,
    height: 4,
    x: 118,
    y: 47,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _use6 || (_use6 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#J"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#L)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0066da",
    d: "m118.5 50.4.2.3.1.2.6-1h-1.2v.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00ac47",
    d: "m120.1 48.6-.6-1-.1.2-1.1 1.8v.2h1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ea4335",
    d: "m121.4 50.9.1-.2.1-.1.3-.6v-.2h-1l.2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00832d",
    d: "m120.1 48.6.6-1h-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2684fc",
    d: "M120.8 49.8h-1.4l-.6 1 .2.1h2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffba00",
    d: "m121.4 48.7-.6-1-.7 1 .7 1.1h1.2v-.2z"
  })))), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#e1e1e1",
    d: "M150.1 49.7v-.2h-.2l-.2-.2h-.3l-.3-.2-.1-.1v-.5l.1-.2h.3l.3-.1h.4l.2.3.1.3h-.3v-.2l-.2-.1h-.5v.1l-.1.2v.1h.2l.2.1.4.2.3.2v.2l-.2.5h-.2l-.3.1h-.5l-.2-.3-.1-.3h.3v.2l.3.1h.6zm-1.5-1.5v.3h-1.1v-.3zm-.8-.5h.4V50h.4v.3h-.5l-.2-.2zm-1.3 2.2.2-.1.1-.1.1-.2h.3v.3l-.7.3h-.4l-.3-.3-.2-.3v-.8l.2-.3.3-.2.4-.1h.4l.2.3.1.4h-.3v-.2l-.2-.2h-.5l-.2.2v1l.2.2zm-2 .2h-.4l-.4-.5-.1-.4v-.5l.3-.4.6-.2h.3l.3.3.1.3v.5H144V49h1.1v-.3l-.2-.2h-.2l-.4.1-.1.3v.9l.5.1h.3l.2-.2.2.1-.1.2-.3.2zm-1.7-2h.3v2.5l-.2.2h-.5v-.2h.2l.2-.1zm0-.5v-.2h.3v.3zm-2.2 1.5v-.4l.2-.3.3-.3h.7l.3.3.2.3v.8l-.2.3-.6.3h-.4l-.5-.6zm.3 0v.3l.1.2.2.2h.5l.2-.2v-.2l.1-.3v-.3l-.1-.2-.2-.2h-.5l-.2.2v.2zm-1.2-.7v1.7h-.3v-2h.3zm.7-.3v.3h-.4l-.2.1v.2l-.1.2h-.1v-.3l.1-.3.2-.2zm-2.3.9h-.7zl.3-.1.2-.2v-.5l-.2-.2h-1v2.3h-.3v-2.7h1l.5.1.3.3.1.4-.1.5-.3.3zm-2.4-.9v.3h-1v-.3zm-.7-.5h.3V50h.4v.3h-.5l-.1-.2v-2.3m-2 .8v1.6h-.3v-2h.3zm0 .5h-.2v-.4l.3-.3.5-.2h.3l.2.1.1.3v1.6h-.3v-1.6l-.2-.1h-.2l-.4.2zm-1.5 1.1h-.3l-.5-.5v-.9l.2-.4a1 1 0 0 1 1-.2l.2.3.2.3v.5H131V49h1.2v-.3l-.2-.2h-.3l-.4.1v.3l-.1.3v.3l.1.3.2.1h.6l.2-.2.2.1-.2.2-.2.2zm-1.7-1.7v1.7h-.3v-2h.3zm.6-.3v.3h-.3l-.2.1v.2l-.1.2h-.1v-.3l.1-.3.2-.2zm-1.8.3v1.7h-.4v-2h.3zm.6-.3v.3h-.4l-.2.1v.4h-.2v-.3l.2-.3.1-.2zm-1.8 1.5v-1.5h.3v2h-.3zm0-.4h.2v.4l-.2.3-.2.2h-.7l-.3-.4v-1.6h.3v1.6l.2.1h.5l.2-.3zm-2 0h.3l-.1.5-.4.3-.5.1h-.4l-.3-.3-.3-.4v-1.3l.3-.4.3-.2.4-.1.5.1q.3 0 .4.3l.1.5h-.3l-.1-.3-.2-.2-.4-.1h-.3l-.2.2-.1.3v1.4l.3.2h.7l.2-.2z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "#2196f3",
    d: "M121.3 58.7H119v-2.5h1.2V56H119q-.3 0-.4.3v2.5q0 .3.4.3h2.4q.4 0 .4-.3v-1.3h-.4zm-.8-2.8v.3h.6l-1.7 1.7.2.3 1.7-1.7v.6h.4v-1.2zm11.5.5v2.1h-.4l-1-1.5v1.5h-.3v-2.1h.3l1 1.5v-1.5zm-2.1 1.8v.3h-1.2v-.3zm-1-1.8v2.1h-.5v-2.1zm.8.9v.3h-1v-.3zm.1-1v.4h-1.1v-.3zm-2.6 1.4h-.6v-.3h.8l.2-.2V57l-.2-.2h-.6v1.8h-.4v-2.1h1.2l.4.6-.1.4-.3.2zm-1.3-.3v.4l-.2.4-.3.2h-.8l-.2-.2-.2-.4-.1-.4v-.6l.3-.3.2-.2h.8l.3.2.1.3zm-.4.1v-.4l-.1-.3-.2-.1h-.4l-.2.1v.3l-.1.3v.4l.1.3.2.1h.4l.2-.1v-.3z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "#242424",
    d: "M214.6 43.7H168q-.7 0-.8.9v17.8q.1.7.8.8h46.6q.7-.1.8-.8V44.6q-.1-.8-.8-.9"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    stroke: "#616467",
    strokeWidth: 0.5,
    d: "M214.6 43.7H168q-.7 0-.8.9v17.8q.1.7.8.8h46.6q.7-.1.8-.8V44.6q-.1-.8-.8-.9Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "N",
    width: 5,
    height: 4,
    x: 171,
    y: 47,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _use7 || (_use7 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#M"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#N)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "O",
    width: 5,
    height: 4,
    x: 171,
    y: 47,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _use8 || (_use8 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#M"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#O)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0066da",
    d: "m172 50.4.2.3.2.2.6-1h-1.2v.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00ac47",
    d: "m173.7 48.6-.6-1-.2.2-1 1.8-.1.2h1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ea4335",
    d: "M175 50.9v-.2l.2-.1.3-.6v-.2h-1.1l.2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00832d",
    d: "m173.7 48.6.6-1H173z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2684fc",
    d: "M174.4 49.8H173l-.6 1 .2.1h2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffba00",
    d: "m175 48.7-.6-1h-.1l-.6 1 .7 1.1h1.1v-.2z"
  })))), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "#e1e1e1",
    d: "M204.1 49.7v-.1l-.2-.1-.2-.1-.3-.1-.3-.1-.1-.2v-.4l.1-.2.3-.1h.7l.2.2.1.3h-.3v-.1l-.2-.1h-.5l-.1.3.2.1.2.1.4.1.3.2v.3l-.2.4-.2.1h-.8l-.2-.3-.1-.3h.3v.3h.9zm-1.5-1.4v.2h-1.1v-.2zm-.7-.5h.3v2.1h.4v.3h-.5l-.2-.1zm-1.3 2.2h.2l.1-.2.1-.2h.3v.3l-.7.4-.4-.1-.3-.2-.2-.3v-.9l.2-.3.3-.2h.8l.2.3.1.3h-.3v-.2l-.2-.1h-.5l-.2.1v1.1l.2.1zm-2 .3h-.4l-.4-.6-.1-.4v-.5l.3-.3a1 1 0 0 1 1-.2l.2.2.1.3v.6H198V49h1.1v-.3l-.2-.2h-.2l-.4.1-.1.2v.9l.5.2h.3l.2-.3.2.2-.1.2-.3.1zm-1.7-2h.3v2.5l-.2.2h-.5v-.3h.4zm0-.6h.3v.3h-.3zm-2.2 1.6v-.5l.2-.3.3-.2h.7l.3.2.2.3v.9l-.2.3-.6.3h-.4l-.5-.6zm.3 0v.3l.1.2.2.1.3.1h.2l.2-.2v-.2l.1-.3V49l-.1-.3-.2-.1h-.5l-.2.1v.3zm-1.2-.7v1.6h-.3v-2h.3zm.7-.3v.3h-.6v.3l-.1.1-.1.1v-.3l.1-.3.2-.2zm-2.3.9h-.7v-.3h1l.2-.2V48l-.2-.2h-1v2.3h-.3v-2.6h1.5l.3.4.1.4-.1.4q0 .2-.3.3zm-2.5-1.8v2.8h-.4v-2.8zm-1.3 2.6v-1.3l-.2-.2h-.4l-.2.2v.1h-.4l.1-.2.2-.2.2-.1h.7l.3.2V50l.1.2h-.3zm0-1v.3h-.7l-.1.2v.3l.1.1h.5l.2-.1v-.2l.2.1v.2l-.4.3h-.7l-.2-.2-.1-.3v-.3l.2-.2.3-.1h.8m-2.1-.5v1.6h-.3v-2h.3zm.6-.3v.3h-.5l-.1.3v.1l-.1.1v-.3l.1-.3.2-.2zm-2.1 2h-.4l-.4-.6-.1-.4v-.5l.3-.3a1 1 0 0 1 1-.2l.2.2.1.3v.6h-1.4V49h1.1v-.3l-.2-.2h-.2l-.4.1-.1.2v.9l.5.2h.3l.2-.3.2.2-.1.2-.3.1zm-2.6-1.6v1.5h-.3v-2h.3zm0 .5h-.2v-.4l.2-.3.6-.3h.3l.2.2.1.2v1.6h-.3v-1.5l-.2-.1h-.2l-.4.1zm-1.5 1.1h-.3l-.5-.6v-.9l.2-.3a1 1 0 0 1 1-.2l.2.2.2.3v.6h-1.5V49h1.2v-.3l-.2-.2h-.3l-.4.1v.2l-.1.3v.4l.1.2.5.2h.3l.2-.3.2.2-.2.2-.2.1zm-1.3-1.3v.9l-.5.3h-1l-.3-.3-.2-.4v-1.2l.2-.4.3-.3h1l.3.3.2.5h-.4V48l-.3-.2h-.6l-.2.2-.2.3v1l.2.3.5.3h.3l.2-.1.1-.1v-.6h-.6v-.3z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "#2196f3",
    d: "M174.9 58.7h-2.5v-2.5h1.3V56h-1.3q-.3 0-.3.3v2.5q0 .3.3.3h2.5q.3 0 .4-.3v-1.3h-.4zm-.9-2.8v.3h.7l-1.8 1.7.3.3 1.7-1.7v.6h.4v-1.2zm11.5.5v2.1h-.3l-1-1.5v1.5h-.4v-2.1h.4l1 1.5v-1.5zm-2.1 1.8v.3h-1.1v-.3zm-1-1.8v2.1h-.4v-2.1zm.9.9v.3h-1v-.3zm.1-1v.4h-1.1v-.3zm-2.6 1.4h-.6v-.3h.8l.1-.2V57l-.1-.2h-.7v1.8h-.4v-2.1h1.3l.3.6v.4l-.3.2zm-1.3-.3-.1.4-.2.4-.3.2h-.7l-.3-.2-.2-.4v-1l.2-.3.3-.2h.7l.3.2.2.3zm-.4.1v-.4l-.2-.3-.1-.1h-.5l-.1.1-.1.3v1l.2.1h.5l.1-.1.1-.3z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "#242424",
    d: "M268.1 43.7h-46.5q-.8 0-.8.9v17.8q0 .7.8.8h46.5q.8-.1.8-.8V44.6q0-.8-.8-.9"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    stroke: "#616467",
    strokeWidth: 0.5,
    d: "M268.1 43.7h-46.5q-.8 0-.8.9v17.8q0 .7.8.8h46.5q.8-.1.8-.8V44.6q0-.8-.8-.9Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "Q",
    width: 5,
    height: 4,
    x: 225,
    y: 47,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _use9 || (_use9 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#P"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#Q)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "R",
    width: 5,
    height: 4,
    x: 225,
    y: 47,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _use10 || (_use10 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#P"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#R)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0066da",
    d: "m225.6 50.4.2.3.1.2.6-1h-1.1v.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00ac47",
    d: "m227.2 48.6-.6-1-.1.2-1.1 1.8v.2h1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ea4335",
    d: "m228.5 50.9.2-.2v-.1l.3-.6.1-.2h-1.2l.3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00832d",
    d: "m227.2 48.6.6-1h-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2684fc",
    d: "M228 49.8h-1.5l-.6 1 .2.1h2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffba00",
    d: "m228.5 48.7-.5-1h-.2l-.6 1 .7 1.1h1.2v-.2z"
  })))), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "#e1e1e1",
    d: "m252.6 48.2.5.7.4-.7h.4l-.7 1 .7 1h-.4l-.4-.8-.5.8h-.4l.7-1-.7-1zm-.8 0v2h-.3v-2zm-.3-.5v-.2h.3v.3zm-1 .8v1.7h-.3v-2h.3zm.7-.3v.3h-.4l-.2.1v.2l-.1.2h-.1v-.3l.1-.3zm-1.4 0v.3h-1v-.3zm-.7-.5h.3V50h.4v.3h-.5l-.1-.2-.1-.3zm-1 2.2v-1.3l-.2-.1h-.4l-.2.1v.2h-.4v-.3l.2-.1.3-.2h.7l.3.3V50l.1.2h-.3zm0-1v.3h-.5l-.2.1-.1.1v.4l.3.1.5-.2v-.2l.2.2v.2l-.7.3h-.4l-.2-.3-.1-.3v-.2l.2-.2.3-.2h.8m-4.5-1.5h.4l.8 2.2 1-2.2h.3l-1.1 2.7h-.3zm0 0h.2v2.7h-.3zm2.3 0h.3v2.7h-.4zm-3.7.7v.3h-1v-.3zm-.7-.5h.4V50h.3v.3h-.4l-.2-.2v-2.3m-1.4 2.2.3-.1.1-.1.1-.2h.3v.3l-.8.3h-.3l-.3-.3-.2-.3v-.8l.2-.3q0-.2.3-.2l.3-.1h.4l.3.3.1.4h-.3v-.2l-.2-.2h-.5l-.2.2v.2l-.1.3v.3l.1.2.2.2zm-1.9.2h-.4l-.3-.2-.2-.3v-.9l.2-.4.6-.2h.4l.3.3.1.3v.5h-1.4V49h1.1v-.3l-.2-.2h-.3l-.3.1-.1.3v.9l.3.1h.5l.2-.2.2.1-.1.2-.3.2zm-1.7-2h.3v2.5l-.2.2h-.5v-.2h.3zm0-.5v-.2h.3v.3zm-2.2 1.5.1-.4.2-.3.3-.3h.7l.3.3.2.3v.8l-.2.3-.3.3h-.7l-.3-.3-.2-.3zm.4 0v.3l.1.2.2.2h.5l.2-.2v-.2l.1-.3v-.3l-.1-.2-.2-.2h-.5l-.2.2v.2zm-1.2-.7v1.7h-.3v-2h.3zm.6-.3v.3h-.3l-.2.1v.2l-.1.2h-.1v-.3l.1-.3.2-.2zm-2.2.9h-.8V49h.8l.3-.1.2-.2v-.5l-.2-.2h-1v2.3h-.3v-2.7h1l.5.1.4.7-.1.5-.3.3z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "#2196f3",
    d: "M228.5 58.7H226v-2.5h1.2V56H226q-.3 0-.4.3v2.5q0 .3.4.3h2.5q.3 0 .3-.3v-1.3h-.3zm-1-2.8v.3h.7l-1.7 1.7.2.3 1.8-1.7v.6h.3v-1.2zm11.5.5v2.1h-.3l-1-1.5v1.5h-.3v-2.1h.3l1 1.5v-1.5zm-2 1.8v.3h-1.2v-.3zm-1-1.8v2.1h-.5v-2.1zm.8.9v.3h-1v-.3zm.2-1v.4h-1.2v-.3zm-2.7 1.4h-.6v-.3h.9v-.2l.1-.2-.1-.2h-.7v1.8h-.4v-2.1h1.2l.3.3.1.3v.4l-.4.2zm-1.3-.3v.4l-.2.4-.3.2h-.8l-.2-.2-.2-.4v-1l.2-.3.2-.2h.8l.3.2.1.3zm-.4.1v-.4l-.1-.3-.2-.1h-.4l-.2.1v.3l-.1.3v.4l.1.3.2.1h.4l.2-.1.1-.3z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "#242424",
    d: "M321.7 43.7h-46.5q-.8 0-.9.9v17.8q0 .7.9.8h46.5q.7-.1.8-.8V44.6q-.1-.8-.8-.9"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    stroke: "#616467",
    strokeWidth: 0.5,
    d: "M321.7 43.7h-46.5q-.8 0-.9.9v17.8q0 .7.9.8h46.5q.7-.1.8-.8V44.6q-.1-.8-.8-.9Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "T",
    width: 5,
    height: 4,
    x: 278,
    y: 47,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _use11 || (_use11 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#S"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#T)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "U",
    width: 5,
    height: 4,
    x: 278,
    y: 47,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _use12 || (_use12 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#S"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#U)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0066da",
    d: "m279.2 50.4.2.3.1.2.6-1h-1.2v.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00ac47",
    d: "m280.8 48.6-.6-1-.2.2-1 1.8v.2h1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ea4335",
    d: "m282 50.9.2-.2v-.1l.4-.6v-.2h-1.1l.2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00832d",
    d: "m280.8 48.6.6-1h-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2684fc",
    d: "M281.5 49.8H280l-.6 1 .2.1h2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffba00",
    d: "m282 48.7-.5-1h-.1l-.6 1 .7 1.1h1.2l-.1-.2z"
  })))), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "#e1e1e1",
    d: "M302.3 48.3h.3v2l-.1.4-.3.2-.7.1-.3-.1-.2-.2.2-.2.2.2h.6l.2-.2v-2.2m-1.4 1v-.5l.2-.3.6-.3.3.1.2.2.2.3v.9q0 .3-.2.3l-.2.2h-.7l-.2-.2-.2-.3zm.3 0v.3l.1.2.2.1.2.1h.3l.2-.3.1-.2v-.6l-.2-.2-.1-.1h-.2l-.5.1v.5m-2-.5v1.6h-.3v-2h.3zm0 .5h-.2v-.4l.2-.3.3-.2h.6l.2.1.1.2v1.7h-.3v-1.6l-.2-.1h-.2l-.4.1zm-.8-.9v2h-.4v-2zm-.4-.6.2-.1h.1v.3h-.3zm-.6-.3v2.9h-.3v-2.9zm-1.2 2.4v-1.5h.4v2h-.4zm0-.4h.2v.3q0 .2-.2.3 0 .2-.2.2h-.8l-.2-.3v-1.6h.3v1.5l.1.1h.2l.1.1h.3l.2-.3zm-2.1.5v-2.5h.4v2.9h-.3zm-1.3-.6v-.5l.2-.3.6-.3.3.1.2.2.2.3v.9q0 .3-.2.3l-.2.2h-.6l-.3-.2-.1-.3zm.3 0v.3l.2.2.1.1.3.1.4-.3.1-.2v-.6l-.3-.3h-.5l-.1.1-.1.3zm-1.4 1h-.4l-.4-.6v-.9q0-.2.2-.3l.3-.2h.6l.3.2.1.3v.6H291V49h1.2l-.1-.3-.2-.2h-.4l-.2.1-.1.2v.7l.1.2.2.2h.5l.3-.3.2.2-.2.2-.2.1zm-2.5-2.9v2.9h-.4v-2.9zm-.1 1.8h-.2l.1-.4.2-.3.2-.2h.6l.3.3v1.7h-.3v-1.6l-.1-.1h-.5l-.2.1zm-1.4.8.4-.2v-.2h.3v.4l-.7.3h-.4l-.3-.3-.2-.3v-.9l.2-.3.3-.2h.8l.2.3.1.4h-.3v-.3l-.2-.1h-.5l-.2.1v1.1zm-1.6-.4v-.2l-.1-.1-.2-.1-.3-.1-.4-.2-.2-.1-.2-.2v-.3l.2-.5q0-.2.3-.2h.8l.4.4v.4h-.3V48l-.2-.2h-.7l-.2.2v.3l.1.2h.2l.3.2.4.1.3.2.1.2v.6l-.2.2-.3.1-1-.1-.3-.3v-.3h.3v.2l.2.2h.9z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "#2196f3",
    d: "M282 58.7h-2.4v-2.5h1.2V56h-1.2q-.4 0-.4.3v2.5q0 .3.4.3h2.4q.3 0 .4-.3v-1.3h-.4zm-.9-2.8v.3h.7L280 58l.3.3 1.7-1.7v.6h.4V56zm11.5.5v2.1h-.3l-1-1.5v1.5h-.4v-2.1h.4l1 1.5v-1.5zm-2.1 1.8v.3h-1.1v-.3zm-1-1.8v2.1h-.4v-2.1zm.9.9v.3h-1v-.3zm.1-1v.4h-1.1v-.3zm-2.6 1.4h-.6v-.3h.8l.1-.2v-.5h-.8v1.8h-.4v-2.1h1.3l.3.3v.7l-.3.2zm-1.3-.3-.1.4-.2.4-.3.2h-.7l-.3-.2-.2-.4v-1l.2-.3.3-.2h.7l.3.2.2.3zm-.4.1v-.4l-.1-.3-.2-.1h-.5l-.1.1-.1.3v1l.2.1h.5l.2-.1v-.6"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "#242424",
    d: "M107.5 68.6H60.9q-.7 0-.8.8v17.8q.1.7.8.8h46.6q.7-.1.8-.8V69.4q-.1-.8-.8-.8"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    stroke: "#616467",
    strokeWidth: 0.5,
    d: "M107.5 68.6H60.9q-.7 0-.8.8v17.8q.1.7.8.8h46.6q.7-.1.8-.8V69.4q-.1-.8-.8-.8Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "W",
    width: 5,
    height: 4,
    x: 64,
    y: 72,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _use13 || (_use13 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#V"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#W)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "X",
    width: 5,
    height: 4,
    x: 64,
    y: 72,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _use14 || (_use14 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#V"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#X)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0066da",
    d: "m65 75.3.1.3h.2l.6-1h-1.2v.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00ac47",
    d: "m66.6 73.5-.6-1h-.2l-1 2-.1.2h1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ea4335",
    d: "m67.8 75.7.2-.1v-.2l.4-.5v-.2h-1.1l.2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00832d",
    d: "m66.6 73.5.6-1-.2-.1h-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2684fc",
    d: "M67.3 74.7h-1.4l-.6 1h2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffba00",
    d: "m67.8 73.5-.5-1h-.1l-.6 1 .7 1.2h1.1v-.2z"
  })))), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "#e1e1e1",
    d: "m81.9 75.1.5-1.6h.2v.3l-.5 1.7h-.3zm-.4-1.6L82 75v.4h-.2l-.6-2zm1.6 1.6.4-1.6h.4l-.6 2H83zm-.4-1.6.5 1.6v.4H83l-.5-1.7v-.3zm-2.5 2h-.4l-.4-.6V74q0-.2.2-.3a1 1 0 0 1 1-.2l.2.2.1.3v.6h-1.4v-.3h1.1V74l-.2-.2h-.2l-.4.1-.1.2v.7l.1.2.2.2h.5l.3-.3.2.2-.2.2-.2.1zm-1.7-1.7v1.7h-.3v-2h.3zm.6-.3v.3h-.4l-.1.1-.1.2v.2h-.1V74l.1-.3.2-.2zm-1.7 1.1h.3l-.1.5-.3.3h-1l-.3-.2-.2-.4-.1-.5v-.8l.3-.4.3-.3h1l.3.4.1.4h-.3l-.1-.3-.2-.2h-.7l-.2.2-.1.3v1l.1.3.2.2.3.1h.4l.2-.3zm-3.2-2v2.9H74v-2.9zm-.9 0v2.9H73v-2.9zm-1.7.4-1 2.5h-.3l1-2.7h.3zm.7 2.5-.9-2.5v-.2h.2l1 2.7zm0-1v.3h-1.5v-.3z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "#2196f3",
    d: "M67.8 83.5h-2.5V81h1.3v-.3h-1.3q-.3 0-.3.3v2.5q0 .3.3.4h2.5q.3 0 .3-.4v-1.2h-.3zm-.9-2.8v.3h.6l-1.7 1.8.3.2 1.7-1.7v.6h.3v-1.2zm11.5.5v2.2h-.3l-1-1.6v1.6h-.4v-2.2h.4l1 1.5v-1.5zM76.3 83v.4h-1.2V83zm-1-1.8v2.2h-.4v-2.2zm.8.9v.3h-1V82zm.2-1v.4H75v-.3zm-2.7 1.4h-.5v-.3h.8l.1-.1v-.4l-.1-.2h-.7v1.9h-.4v-2.2h1.3l.3.7v.3l-.3.3zm-1.3-.3v.6l-.2.3-.3.2h-.7l-.3-.2-.2-.3v-1l.2-.4.3-.2h.7l.3.2.2.4zm-.3.1v-.4l-.2-.2-.1-.2h-.5l-.1.2-.1.2v1l.2.1h.5l.1-.1.1-.2z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "#242424",
    d: "M161 68.6h-46.5q-.8 0-.8.8v17.8q0 .7.8.8H161q.8-.1.8-.8V69.4q0-.8-.8-.8"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    stroke: "#616467",
    strokeWidth: 0.5,
    d: "M161 68.6h-46.5q-.8 0-.8.8v17.8q0 .7.8.8H161q.8-.1.8-.8V69.4q0-.8-.8-.8Z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "#1e88e5",
    d: "M120.3 73.8h.2v.7h.2v-1h-.2zm-.3.2.1-.2q0-.2-.3-.3t-.3.3h.1l.2-.1.2.1-.2.2h-.1v.1q.3 0 .3.2l-.2.1h-.3l.3.2q.3 0 .3-.3z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbc02d",
    d: "M121 75.8h-1.8V75h1.9z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "#4caf50",
    d: "M121.8 75v-1.9h-.7v2z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "#1e88e5",
    d: "M121 73.1v-.7h-2.3q-.3 0-.3.3V75h.8v-1.9z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "#e53935",
    d: "M121 75v.8l.8-.8z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "#1565c0",
    d: "M121.5 72.4h-.4v.7h.7v-.4q0-.3-.3-.3m-2.8 3.4h.5V75h-.8v.5q0 .2.3.3"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "#e1e1e1",
    d: "M150.2 73.4v1.7h-.4v-2h.3zm.6-.3v.3h-.4l-.2.1v.2l-.1.2v-.6l.2-.2zm-1.8 1.6v-1l-.1-.2-.1-.1h-.5l-.1.1-.1.2h-.3v-.3l.2-.1.2-.2h.7l.3.3v1.3l.1.2v.2h-.3zm0-.8v.2h-.6l-.2.1-.1.1v.4h.1l.2.1.5-.2v-.2l.2.2v.1l-.4.4h-.7l-.2-.3v-.5q0-.2.2-.2l.2-.2zm-2 .8v-2.4h.2V75h-.3zm-1.4-.6v-.4l.2-.4.2-.2h.7l.2.2.2.3v1l-.2.3-.2.2h-.7l-.2-.3-.2-.3zm.3 0v.3l.1.2.2.2h.2l.5-.2v-1.1l-.2-.1h-.5l-.2.2zm-2-.6v1.6h-.4v-2h.3zm-.2.5v-.4l.2-.3.6-.2h.3l.2.1.1.3V75h-.3v-1.6l-.2-.1h-.2l-.4.2zm-1.4 1.1h-.4l-.4-.6v-.8q0-.3.2-.4a1 1 0 0 1 1-.2l.2.2.1.4v.5h-1.4v-.3h1.2l-.1-.3-.1-.2h-.3l-.4.1-.1.3v.6l.1.2.2.2h.5l.3-.2.2.1-.2.2-.2.2zm-1.4-2.8V75h-.3v-2.8zm-1.2 2.4v-1.2l-.2-.1h-.4l-.2.1v.2h-.4v-.3l.2-.1.3-.2h.7l.3.3v1.5l.1.2h-.3zm0-.8v.2h-.5l-.2.1-.1.1v.4h.1l.2.1.5-.2v-.2l.2.2v.1l-.5.4h-.6l-.2-.3-.1-.3v-.2l.2-.2.3-.2h.8m-2.1.3h.3l-.1.5-.4.3-.5.1h-.4l-.4-.3-.2-.4v-1.3l.3-.4.3-.2.4-.1.5.1q.3 0 .4.3l.1.5h-.3l-.1-.3-.2-.3h-.7l-.2.2-.1.3v1.4l.3.2h.7l.2-.2zm-3.8.9h-.4l-.4-.6-.1-.3v-.5l.3-.4.6-.2h.3l.3.2.1.4v.5h-1.4v-.3h1.1v-.3l-.2-.2h-.2l-.4.1-.1.3v.8l.3.2h.5l.2-.2.3.1-.2.2-.3.2zm-1.4-2.8V75h-.3v-2.8zm-1.1.8h.3v2l-.1.4-.3.3h-1l-.2-.3.2-.2.2.2h.6l.2-.2v-2.2m-1.4 1v-.4l.2-.4.6-.2h.3l.2.2.2.3v1l-.2.3-.2.2h-.7l-.2-.3-.2-.3zm.3 0v.3l.1.2.2.2h.5l.2-.2.1-.3v-.6l-.2-.2-.1-.1h-.5l-.2.2zm-2.5 0 .1-.4.2-.3.3-.3h.7l.3.3.2.3v.8l-.2.3-.7.3h-.3l-.3-.3-.2-.3zm.4 0v.3l.1.2.2.2h.5l.2-.2v-.2l.1-.3v-.3l-.1-.2-.2-.2h-.3l-.4.2v.2zm-2.5 0v-.4l.2-.3.3-.3h.8l.3.3.1.3.1.4v.4l-.2.3-.7.3h-.4l-.4-.6zm.3 0v.3l.2.2.2.2h.4l.2-.2.1-.2v-.8l-.3-.2h-.4l-.2.2-.1.2zm-.7-.3v1l-.5.3h-1l-.3-.3-.2-.4-.1-.5V73l.3-.4.3-.2.5-.1h.5l.3.4.2.4h-.4v-.3l-.3-.2h-.6l-.3.2-.1.3v1.1l.2.3.5.2h.5l.1-.2V74h-.6v-.2z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "#2196f3",
    d: "M121.3 83.5H119V81h1.2v-.3H119q-.3 0-.4.3v2.5q0 .3.4.4h2.4q.4 0 .4-.4v-1.2h-.4zm-.8-2.8v.3h.6l-1.7 1.8.2.2 1.7-1.7v.6h.4v-1.2zm11.5.5v2.2h-.4l-1-1.6v1.6h-.3v-2.2h.3l1 1.5v-1.5zm-2.1 1.8v.4h-1.2V83zm-1-1.8v2.2h-.5v-2.2zm.8.9v.3h-1V82zm.1-1v.4h-1.1v-.3zm-2.6 1.4h-.6v-.3h.8l.2-.1v-.4l-.2-.2h-.6v1.9h-.4v-2.2h1.2l.4.7-.1.3-.3.3zm-1.3-.3v.6l-.2.3-.3.2h-.8l-.2-.2-.2-.3-.1-.5v-.5l.3-.4.2-.2h.8l.3.2.1.4zm-.4.1v-.4l-.1-.2-.2-.2h-.4l-.2.2v.2l-.1.3v.5l.1.2.2.1h.4l.2-.1v-.2z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "#242424",
    d: "M214.6 68.6H168q-.7 0-.8.8v17.8q.1.7.8.8h46.6q.7-.1.8-.8V69.4q-.1-.8-.8-.8"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    stroke: "#616467",
    strokeWidth: 0.5,
    d: "M214.6 68.6H168q-.7 0-.8.8v17.8q.1.7.8.8h46.6q.7-.1.8-.8V69.4q-.1-.8-.8-.8Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "Y",
    width: 5,
    height: 4,
    x: 171,
    y: 72,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M175.4 72.7h-3.7v2.8h3.7z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#Y)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4285f4",
    d: "M172 75.5h.5V74l-.8-.6v1.8q0 .3.2.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34a853",
    d: "M174.6 75.5h.6q.2 0 .2-.3v-1.8l-.8.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fbbc04",
    d: "M174.6 73v1l.8-.6V73q0-.5-.6-.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ea4335",
    d: "M172.5 74v-1l1 .7 1-.8V74l-1 .8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c5221f",
    d: "M171.7 73v.4l.8.6v-1l-.2-.3a.4.4 0 0 0-.6.3"
  }))), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "#e1e1e1",
    d: "M186.6 72.6v2.9h-.3v-2.9zm-.9.9v2h-.3v-2zm-.4-.5v-.2h.4v.2l-.2.1zm-.8 2.1V74l-.2-.1h-.6v.2h-.4v-.2l.2-.2.2-.1h.8l.2.2.1.4v1.3h-.3v-.3m0-.8v.2h-.8v.2l-.1.2v.1l.2.2h.4l.2-.2.1-.2.1.1v.2l-.7.4h-.3l-.3-.3v-.6l.2-.2.3-.1zm-4.1-.5v1.6h-.4v-2h.3zm-.1.5h-.2V74l.2-.3.3-.2h.6l.3.3v1.7h-.3v-1.6l-.2-.1h-.4l-.2.1v.2zm1.3-.2h-.3V74l.2-.3.3-.2h.6l.2.1.1.2v1.7h-.3v-1.6l-.2-.1h-.5l-.1.2zm-2.1-.1v1l-.5.3h-1l-.3-.2-.2-.4v-1.3l.2-.4.3-.3h1q.2.1.3.4l.2.4h-.4v-.3l-.3-.2h-.6l-.2.2-.2.3v1q0 .3.2.3l.5.3h.3l.2-.1h.1v-.7h-.6v-.3z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fill: "#2196f3",
    d: "M174.9 83.5h-2.5V81h1.3v-.3h-1.3q-.3 0-.3.3v2.5q0 .3.3.4h2.5q.3 0 .4-.4v-1.2h-.4zm-.9-2.8v.3h.7l-1.8 1.8.3.2 1.7-1.7v.6h.4v-1.2zm11.5.5v2.2h-.3l-1-1.6v1.6h-.4v-2.2h.4l1 1.5v-1.5zm-2.1 1.8v.4h-1.1V83zm-1-1.8v2.2h-.4v-2.2zm.9.9v.3h-1V82zm.1-1v.4h-1.1v-.3zm-2.6 1.4h-.6v-.3h.8l.1-.1v-.4l-.1-.2h-.7v1.9h-.4v-2.2h1.3l.3.7v.3l-.3.3zm-1.3-.3-.1.5-.2.3-.3.2h-.7l-.3-.2-.2-.3v-1l.2-.4.3-.2h.7l.3.2.2.4zm-.4.1v-.4l-.2-.2-.1-.2h-.5l-.1.2-.1.2v1l.2.1h.5l.1-.1.1-.2z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fill: "#242424",
    d: "M268.1 68.6h-46.5q-.8 0-.8.8v17.8q0 .7.8.8h46.5q.8-.1.8-.8V69.4q0-.8-.8-.8"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    stroke: "#616467",
    strokeWidth: 0.5,
    d: "M268.1 68.6h-46.5q-.8 0-.8.8v17.8q0 .7.8.8h46.5q.8-.1.8-.8V69.4q0-.8-.8-.8Z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Z)",
    d: "M225.2 72.2h3.8v3.7h-3.8z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fill: "#e1e1e1",
    d: "M238.6 72.6v2.9h-.4v-2.9zm1.2.9-.9.9-.5.5v-.4l.3-.4.7-.6zm-.3 2-.7-1 .1-.3 1 1.3zm-2.5-.3h.3l.1-.2.1-.2h.3v.4l-.4.2h-.7l-.3-.2-.2-.3V74l.2-.4.3-.2h.8l.2.3.1.4h-.3v-.3l-.2-.1h-.5l-.2.1V75l.2.2zm-1.6-.1V74l-.2-.1h-.6v.2h-.4v-.2l.2-.2.3-.1h.7l.2.2.1.4v1.1l.1.2h-.4v-.3m0-.8v.2h-.7l-.2.2v.3l.2.2h.2l.4-.2.1-.2.2.1-.1.2-.4.3h-.6l-.3-.2v-.6l.2-.2.3-.1zm-1.8-1.8v2.9h-.4v-2.9zm-1.1 2.2v-.2l-.2-.1-.2-.1-.3-.1-.3-.2-.3-.1-.2-.2v-.3l.2-.5.3-.2h.9l.3.4.1.4h-.3l-.1-.3-.2-.2h-.6q-.2 0-.2.2v.5h.3l.2.2.4.1.3.2.2.2v.6l-.2.2-.3.1h-.8l-.3-.1-.2-.3-.1-.3h.3v.2l.2.2h1z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fill: "#2196f3",
    d: "M228.5 83.5H226V81h1.2v-.3H226q-.3 0-.4.3v2.5q0 .3.4.4h2.5q.3 0 .3-.4v-1.2h-.3zm-1-2.8v.3h.7l-1.7 1.8.2.2 1.8-1.7v.6h.3v-1.2zm11.5.5v2.2h-.3l-1-1.6v1.6h-.3v-2.2h.3l1 1.5v-1.5zm-2 1.8v.4h-1.2V83zm-1-1.8v2.2h-.5v-2.2zm.8.9v.3h-1V82zm.2-1v.4h-1.2v-.3zm-2.7 1.4h-.6v-.3h.9v-.1l.1-.2v-.2l-.1-.2h-.7v1.9h-.4v-2.2h1.2l.3.3.1.4v.3l-.4.3zm-1.3-.3v.6l-.2.3-.3.2h-.8l-.2-.2-.2-.3v-1q0-.3.2-.4l.2-.2h.8l.3.2.1.4zm-.4.1v-.4l-.1-.2-.2-.2h-.4l-.2.2v.2l-.1.3v.5l.1.2.2.1h.4l.2-.1.1-.2z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fill: "#1c1c1c",
    fillOpacity: 0.8,
    d: "M440.6 28.6H338c-2 0-3.5 1.6-3.5 3.5v57c0 1.9 1.5 3.5 3.5 3.5h102.6c2 0 3.5-1.6 3.5-3.5V32c0-1.9-1.5-3.5-3.5-3.5"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#aa)",
    strokeWidth: 0.5,
    d: "M440.6 28.6H338c-2 0-3.5 1.6-3.5 3.5v57c0 1.9 1.5 3.5 3.5 3.5h102.6c2 0 3.5-1.6 3.5-3.5V32c0-1.9-1.5-3.5-3.5-3.5Z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fill: "#9a9ca5",
    d: "M362.5 36.5v-.2l-.2-.1-.4-.2h-.5l-.3-.3-.2-.2v-.7l.2-.3.4-.2h.5l.6.1q.3 0 .4.3l.2.5h-.7V35l-.2-.2h-.6l-.2.2v.3l.3.2h.3l.6.2.3.3.2.5-.1.3-.3.3-.3.2h-1.2l-.4-.5-.2-.4h.7v.3l.3.1h.6l.2-.1zm-4-3.5v4.3h-.7v-4.2zm1.8 1.3-1.3 1.5-.7.7-.1-.6.5-.6.8-1zm-.6 3-1-1.4.4-.5 1.3 1.9zm-4.5-2.3v2.3h-.6v-3h.6zm0 .7h-.3v-.6l.3-.4a1 1 0 0 1 .9-.4h.4l.3.2.2.4v2.4h-.6v-2l-.1-.3-.2-.1h-.3l-.5.2-.1.3zm-1.5-1.4v3h-.6v-3zm-.7-.7.1-.3.3-.1.3.1v.5l-.3.1-.3-.1zm-.5 3.2v.5h-2v-.5zm-1.9-3.5v4h-.6v-4zm-4.2 3.7.8-2.7h.7l-1.2 3.5-.1.2-.2.2-.2.2h-.7V38h.4l.1-.1.2-.2zm-.5-2.7.7 2.3.1.7h-.4l-1-3zm-2.2 3.1-.6-.2-.4-.3-.3-.4v-1.3q0-.3.3-.5l.4-.3.6-.1h.5l.4.4.3.4v.9h-2.3v-.5h1.7v-.3l-.3-.3-.3-.1h-.3l-.2.3-.2.3v.9l.2.3.2.2h.4l.7-.3.4.3-.3.3-.3.2zm-4.1-4.1v4h-.7v-4zm2.4 0-1.6 2-1 1v-.8l.6-.8 1.2-1.4zm-.7 4-1.4-1.9.5-.5 1.7 2.4z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "ac",
    width: 102,
    height: 12,
    x: 338,
    y: 42,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _use15 || (_use15 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ab"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#ac)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M440.2 41.8H338.9V54h101.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4285f4",
    d: "M379.7 48v-.5l.2-.3.3-.1.3-.1h.4l.2.2.2.3v.8l-.2.2-.2.2h-.7l-.4-.4zm.4-.1v.2l.1.2.1.1h.4l.1-.1v-.2l.1-.2v-.4l-.2-.1h-.4l-.1.3zm-.6-.9v.3h-1V47zm-.7-.4h.4v1.8h.3v.4h-.5l-.2-.2zm-.6.4v1.8h-.4V47zm-.4-.4v-.2h.4v.3zm-1.8-.3h.3v2.5h-.4zm1.4 1.6v.4l-.1.2-.2.2h-.6l-.2-.1-.1-.3-.1-.4v-.4l.2-.3.2-.1.3-.1h.3l.2.2.1.3zm-.4 0v-.4l-.2-.1h-.4l-.1.4v.4l.2.2h.3l.1-.1.1-.2zm-1.9-.5v1.4h-.4V47h.4zm.5-.4v.4h-.3l-.2.2v.2h-.1v-.3l.1-.3.2-.1zm-1.3.5v.6l-.3.4-.3.2h-.8l-.3-.2-.2-.4v-1l.2-.4.3-.2.4-.1h.4l.3.3.2.4zm-.4.2v-.5l-.2-.2q0-.2-.2-.2h-.4l-.2.2v.2l-.1.3v.5l.1.2.2.2h.5l.1-.2.1-.2zm-3.9-1.4v2.5h-.4v-2.5zm0 1.5h-.1v-.3l.2-.3.2-.1.2-.1h.3l.2.1v.2l.1.4v1h-.4v-1.2l-.1-.1h-.5v.2zm-.7-.8v.3h-1V47zm-.7-.4h.4v1.7l.1.1h.2v.4h-.5l-.1-.2zm-.7.4v1.8h-.4V47zm-.4-.4v-.2h.4l.1.2v.1h-.4zm-2 1.7.4-1.3h.3v.5l-.5 1.3h-.2zm-.2-1.3.3 1.3v.5h-.2L365 47zm1.2 1.3.3-1.3h.4l-.4 1.8h-.3zm-.3-1.3.4 1.3v.5h-.2l-.4-1.3V47zm-2.8 1.4v-2.1h.4v2.5h-.4zm-1.2-.5v-.4l.2-.3.5-.2h.3l.2.2.1.3v.8l-.1.3-.2.1h-.6l-.2-.2-.1-.2zm.5 0v.4l.2.1h.3l.2-.2v-.6l-.2-.2h-.5zm-1.4.9h-.4l-.4-.5v-.8l.2-.3.2-.1.3-.1h.4l.2.2.1.3v.5h-1.3v-.3h1v-.2l-.2-.1h-.4l-.1.3v.6l.2.1h.5l.1-.1.3.2-.2.1-.2.1zm-1.1-1.8v.3h-1V47zm-.7-.4h.4v1.8h.3v.4h-.5l-.2-.2zm-1 .8v1.4h-.4V47h.4zm.5-.4v.4h-.3l-.2.1v.3h-.1v-.6l.2-.1zm-1.8 1.4v-1h-.5v.1h-.5v-.2l.2-.1.3-.2h.6l.3.3v1.3l.1.1h-.4v-.3m0-.7v.3h-.4l-.2.1v.3h.6v-.2l.2.2-.4.3h-.5q-.2 0-.2-.2l-.1-.2V48l.2-.1.2-.2h.7M356 47v.3h-1V47zm-.7-.4h.4v1.7l.1.1h.3v.4h-.6l-.1-.2zm-1 1.6V48l-.2-.2h-.3l-.3-.2-.2-.1-.2-.2v-.5l.2-.2.3-.2h.8l.3.3v.4h-.4V47l-.2-.1h-.5v.4l.2.1.2.1.3.1.3.2.1.2v.5q0 .2-.2.2l-.2.1h-1l-.2-.3-.1-.4h.4v.2l.2.2h.6zm-2.9-1.2h.4v1.7l-.1.4-.3.3a1 1 0 0 1-.9 0l-.2-.2.2-.3.2.2h.5l.1-.2v-1.5zm-1.2 1v-.5l.2-.3.5-.2h.3l.2.2.1.3.1.4v.4l-.2.3-.5.2-.5-.3-.1-.2zm.5-.1v.4l.2.1h.4v-.2l.1-.2v-.5l-.2-.1h-.4l-.1.3zm-1.8-.5v1.4h-.5V47h.4zm-.1.4h-.1v-.3l.1-.3.5-.2h.3l.1.1.2.2v1.5h-.4v-1.3l-.2-.1h-.4v.2zm-.9-.8v1.8h-.3V47zm-.4-.4.1-.2h.4v.3h-.4zm-.3.4v.3h-1V47zm-.7-.4h.4v1.7l.1.1h.2v.4h-.5l-.1-.2-.1-.3zm-.4.4v.3h-1V47zm-.7-.4h.4v1.8h.3v.4h-.5l-.2-.2zm-1.2 2.2h-.3l-.3-.3-.2-.2v-.8l.2-.3.6-.2h.3l.2.2.2.3v.5h-1.3v-.3h1l-.1-.2-.1-.1h-.5v.9l.2.1h.4l.2-.1.2.2zm-1.2-1.2v.9l-.1.1-.3.1h-.9l-.3-.2-.2-.4V47l.2-.3.3-.2.4-.1h.5l.3.4.1.4h-.4v-.3l-.2-.1h-.5l-.2.1v.3l-.1.3v.5l.1.2.2.2h.6v-.5h-.4v-.3z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "ad",
    width: 102,
    height: 12,
    x: 338,
    y: 42,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _use16 || (_use16 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ab"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#ad)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#616467",
    d: "M439.7 53.5v-.2H338.9v.4h100.8z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "af",
    width: 102,
    height: 12,
    x: 338,
    y: 53,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _use17 || (_use17 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ae"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#af)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M440.2 53H338.9v12.2h101.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4285f4",
    d: "M385.5 59.9v-.2h-.3l-.3-.2h-.2v-.2l-.1-.2.1-.4h.3l.2-.1h.4l.3.2v.3h-.4V59l-.1-.1h-.4v.3h.1l.2.1.4.1.2.2v.2l-.1.4-.3.1h-.7l-.2-.2v-.3h.3v.1l.2.1h.4zm-1.9.5-.4-.1-.4-.4V59l.1-.3.3-.2h.6l.3.2.1.3v.5H383v-.3h1V59l-.2-.2h-.3l-.2.2v.8h.2l.2.1h.2l.2-.2.2.2-.1.2-.2.1zm-1.8-.4h.1l.1-.1v-.2h.5l-.1.4-.3.2h-.7l-.2-.2-.2-.3v-.7q0-.2.2-.3l.2-.2h.7l.3.3v.3h-.3v-.1a.3.3 0 0 0-.4-.2h-.1l-.1.2-.1.1v.7h.2zm-1.2-1.4v1.7h-.4v-1.7zm-.5-.5.1-.1h.4v.3h-.4zm-.3.5v.3h-1v-.3zm-.7-.4h.4v1.7l.1.1h.2v.3h-.5l-.1-.1-.1-.3zM378 60h.1l.1-.1v-.2h.5l-.1.4-.3.2h-.7l-.2-.2-.2-.3v-.7l.2-.3.2-.2h.7l.3.3v.3h-.3v-.1l-.2-.2h-.3l-.1.2v.1l-.1.2v.5h.2zm-1.6 0v-1h-.1l-.2-.1h-.2v.2h-.5v-.2l.2-.2h.9l.2.1.1.4v.9l.1.2h-.4V60m0-.7v.2h-.4l-.1.1v.4h.2l.3-.1v-.1l.2.1-.4.4h-.5l-.2-.2-.1-.3v-.2l.2-.2h.2l.4-.1zm-1.8-.3v1.3h-.4v-1.7h.4zm.5-.4v.4h-.4l-.1.2v.1h-.1V59l.1-.2.2-.2zm-2.2.9h-.5V59h.8l.1-.2v-.5h-.8v2h-.4V58h1.3l.4.7v.4l-.4.3zm-2-.9v.3h-1v-.3zm-.8-.4h.5V60h.3v.3h-.5l-.2-.1v-2m-.9 1.7v-.1l-.2-.1h-.2l-.3-.2h-.1l-.2-.2V59l.2-.4h.2l.3-.1h.3l.3.2v.3h-.8l-.1.2v.1h.2l.1.1.4.1.2.2v.4l-.1.2-.2.1h-.7l-.3-.2v-.3h.3v.1l.2.1h.4zm-2 .5-.4-.1-.2-.2-.2-.2V59q0-.2.2-.3l.2-.2h.7l.2.2.1.3v.5h-1.3v-.3h1V59l-.2-.2h-.2l-.2.2-.1.1v.7h.2l.2.1h.3l.1-.2.3.2zm-2-1h-.6V59h.7l.2-.2v-.3l-.2-.1h-.5v2h-.5V58h1.2l.2.1.2.2v.6l-.2.2h-.4zm0 1h-.7l.2-.3h.7l.1-.2v-.5h-.7V59h.5l.1.1h.4l.2.3v.6l-.4.3zm-2.6-.3V58h.4v2.4h-.4zm-1.1-.5V59l.1-.3.3-.2h.2l.5.2.1.3.1.3v.5l-.2.2-.2.2h-.3l-.5-.2v-.3zm.4 0v.4h.2l.1.1h.3v-.2l.1-.2v-.4l-.2-.3h-.3l-.1.2v.1zm-1.8-.5v1.3h-.4v-1.7h.4zm0 .4h-.2v-.3l.2-.3.5-.2h.2l.2.1v.2l.1.3v1.1h-.4V59h-.1l-.2-.1-.3.1zm-1.3.6v-1h-.1l-.2-.1h-.2v.2h-.5V59l.2-.2h.9l.3.1v1.3l.1.2h-.4V60m0-.7v.2h-.4v.1h-.2v.3l.1.1h.4v-.1l.1-.1.2.1-.1.2-.1.1-.2.1h-.5l-.2-.2-.1-.3v-.2l.2-.2h.2l.4-.1zm-2.7.6v-.1l-.1-.1h-.2l-.3-.2h-.2l-.1-.2v-.4l.1-.2h.2l.3-.1h.4l.2.2.1.3h-.4V59l-.1-.1h-.4v.3h.1l.2.1.3.1.3.2v.2l-.2.4-.2.1h-.7l-.2-.2-.1-.3h.4v.1l.2.1h.3zm-1.9.5-.4-.1-.4-.4-.1-.4V59l.2-.3.3-.2h.6l.3.2.1.3v.5h-1.3v-.3h1l-.1-.2-.1-.2h-.2l-.3.2v.8h.2l.2.1h.2l.2-.2.2.2-.1.2-.2.1zm-2.3-1.4v1.3h-.4v-1.7h.4zm0 .4h-.2v-.3l.2-.3.2-.2h.5l.2.1.1.2v1.4h-.4V59h-.1l-.2-.1h-.1l-.2.1zm-.8-.8v1.7h-.5v-1.7zm-.5-.5V58h.4v.3h-.3zm-.4-.2v2.4h-.5V58zm-1.5 2.5-.4-.1a1 1 0 0 1-.5-.8l.1-.4q0-.2.2-.3l.2-.2h.7l.2.2.1.3v.5h-1.3v-.3h1V59l-.2-.2h-.3l-.1.2-.1.1v.7l.4.1h.3l.1-.2.3.2-.2.2-.2.1zm-1.6-.4v-2.1h.4v2.4h-.4zm-1.2-.5V59l.2-.3.2-.2h.3l.5.2.1.3.1.3v.5l-.2.2-.2.2h-.3l-.5-.2-.1-.3zm.5 0v.4h.2l.1.1h.2l.2-.2v-.6l-.2-.3h-.3l-.1.2-.1.1zm-.8-.9v1.7h-.4v-1.7zm-.5-.5V58h.4l.1.1v.2h-.4zm-.8 1.9v-1.4h.4v1.7h-.4zm0-.4h.2v.3l-.2.2-.2.2h-.7l-.1-.3v-1.4h.4v1.3l.1.1h.4l.1-.2zm-1.5-.5v1h-.1l-.3.2h-.9l-.3-.2-.2-.4v-1.1l.2-.3.3-.3h.9l.3.3.1.4h-.4v-.2l-.2-.1h-.5l-.2.1v.3l-.1.3v.5l.1.2.2.2h.6v-.6h-.4v-.3z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "ag",
    width: 102,
    height: 12,
    x: 338,
    y: 53,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _use18 || (_use18 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ae"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#ag)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#616467",
    d: "M439.7 64.7v-.2H338.9v.5h100.8z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "ai",
    width: 102,
    height: 12,
    x: 338,
    y: 64,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _use19 || (_use19 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ah"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#ai)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M440.2 64.3H338.9v12.2h101.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4285f4",
    d: "M342.8 69.2h.4v1.5l-.1.5-.3.3h-.9l-.3-.3-.2-.5v-1.5h.5V71l.2.2h.5l.1-.2v-1.8m1.8 1.9-.1-.1h-.3l-.2-.2h-.2l-.1-.2V70h.3l.3-.1h.4l.2.2.1.3h-.4l-.2-.2h-.3v.3l.3.1.3.1.2.2.1.2v.2l-.2.2-.2.1h-.7l-.3-.2V71h.4v.1l.1.1zm1.5.5-.3-.1-.4-.4-.1-.4v-.4l.2-.3.3-.2h.6l.3.2.1.3v.5h-1.3v-.3h1l-.1-.2-.1-.1-.2-.1-.3.2v.8h.2l.2.1h.2l.2-.2.2.2-.1.2-.3.1zm1.5-1.4v1.3h-.4v-1.7h.4zm.5-.4v.4h-.4l-.1.2v.2h-.1v-.4l.1-.2.2-.2zm1.4-.6h.4l.6 1.8.6-1.8h.4l-.9 2.3h-.3zm-.2 0h.4v2.3h-.4zm2 0h.4v2.3h-.4zm1.8 2v-1h-.1l-.2-.1h-.2v.2h-.5v-.2l.2-.2h.9l.3.1v1.3l.1.2h-.4v-.3m0-.7v.2h-.4v.1h-.2v.3l.1.1h.2l.3-.1V71l.2.1-.1.2-.1.1-.4.2-.3-.1-.2-.2-.1-.3v-.2l.2-.2h.2l.4-.1zm1.3-.3v1.3h-.4v-1.7h.4zm0 .4h-.2v-.3l.2-.3.5-.2h.2l.2.1v.2l.1.3v1.1h-.4v-1.3h-.1l-.2-.1-.3.1zm2.4.6v-1h-.1l-.2-.1h-.1l-.2.2h-.4v-.2l.2-.2h.9l.2.1.1.4v1.1h-.3v-.1zm0-.7v.2h-.4l-.1.1-.1.2v.1l.1.1h.1l.4-.1V71l.1.1v.2l-.1.1-.4.2-.3-.1-.3-.2v-.5l.2-.2h.2l.4-.1zm2-.7h.3v2.1l-.4.2h-.8l-.2-.2.2-.2.2.1h.4l.2-.1v-1.9m-1.2.9v-.4l.2-.3.5-.2h.3l.2.2v.3l.1.3v.5l-.2.2-.4.3-.5-.3-.2-.3zm.4 0v.4h.2l.2.1h.2l.1-.2v-.8h-.2l-.1-.1h-.2l-.1.2v.1zm2.3.9-.3-.1-.3-.2-.2-.2v-.8l.2-.3.3-.2h.6l.2.2.2.3v.5h-1.3v-.3h1l-.1-.2-.1-.1-.2-.1h-.2l-.1.2v.1l-.1.3v.2l.1.2h.2l.2.1h.2l.2-.2.2.2zm1.5-1.4v1.3h-.4v-1.7h.3zm0 .4h-.2v-.3l.2-.3.5-.2h.2l.1.1.2.2v1.4h-.4v-1.3h-.2l-.1-.1h-.2l-.1.1zm1 0h-.2v-.4l.2-.2.2-.2h.5l.2.1v.2l.1.3v1.1h-.4v-1.3h-.1l-.2-.1h-.1l-.1.1-.1.2zm2.2 1-.3-.1-.5-.4v-.8l.2-.3.6-.2h.3l.4.5v.5h-1.3v-.3h1l-.1-.2-.3-.2h-.2l-.1.2v.1l-.1.3v.2l.1.2h.2l.1.1h.3l.2-.2.2.2-.4.3zm1.5-1.4v1.3h-.5v-1.7h.4zm-.1.4h-.1v-.3l.2-.3.5-.2h.2l.2.1v.2l.1.3v1.1h-.4v-1.3h-.2l-.1-.1-.3.1v.2zm2.3-.8v.3h-1v-.3zm-.7-.4h.4V71l.1.1h.3v.3h-.6l-.1-.1v-2"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "aj",
    width: 102,
    height: 12,
    x: 338,
    y: 64,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _use20 || (_use20 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ah"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#aj)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#616467",
    d: "M439.7 76v-.3H338.9v.5h100.8z"
  }))), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fill: "#1c1c1c",
    fillOpacity: 0.8,
    d: "M440.6 98.7H59.1c-2 0-3.6 1.5-3.6 3.5v83.4c0 2 1.6 3.5 3.6 3.5h381.5c2 0 3.5-1.6 3.5-3.5v-83.4c0-2-1.5-3.5-3.5-3.5"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#ak)",
    strokeWidth: 0.5,
    d: "M440.6 98.7H59.1c-2 0-3.6 1.5-3.6 3.5v83.4c0 2 1.6 3.5 3.6 3.5h381.5c2 0 3.5-1.6 3.5-3.5v-83.4c0-2-1.5-3.5-3.5-3.5Z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fill: "#9a9ca5",
    d: "M100 106.4v-.2l-.3-.1-.4-.1-.4-.2-.3-.1-.3-.3v-.7l.3-.2.3-.2.5-.1.6.1.5.4.1.4h-.7v-.2l-.2-.2h-.6l-.1.2v.4h.2l.3.2.6.2.4.2.1.5v.3l-.3.3-.4.2h-1.2l-.4-.4-.1-.5h.6l.1.3.2.1h.8zm-2.3-2.1v.4H96v-.5zm-1.2-.8h.7v3.1l.1.1h.4v.5H97l-.3-.3-.1-.5zm-2 3.2h.3l.2-.2v-.3h.7l-.2.6-.4.3-.6.2-.6-.1-.4-.4-.3-.4V105q0-.2.3-.5l.4-.3.6-.1.6.1.4.4.2.6h-.6l-.1-.3-.2-.2h-.6l-.3.2v1.5l.3.2zm-3 .6-.6-.1-.5-.3-.3-.5v-1.3l.3-.5.4-.3.6-.1.5.1q.3 0 .4.3l.3.5v.8h-2.2v-.4H92v-.4l-.3-.3h-.6l-.2.2-.2.3v.9l.2.3.6.3.7-.4.4.3-.3.3-.3.2zm-2.8-3h.6v3.7l-.4.3-.5.1h-.3v-.5h.4l.1-.2v-3.4m0-.8v-.3h.6v.5l-.3.1h-.3zm-3.4 2.3.1-.7q0-.2.3-.5l.4-.3.6-.1.6.1.4.3.3.5v1.3l-.3.4a1 1 0 0 1-1 .5l-.6-.1a1 1 0 0 1-.7-.8zm.7 0v.3l.1.4.6.2.5-.2.2-.4v-.8l-.2-.3-.5-.3-.3.1-.3.2v.3zm-1.9-1v2.4h-.7v-3h.6zm.9-.6v.6h-.6l-.3.4-.1.3h-.1v-.5l.2-.4.3-.3zm-3.6 1.4h-1v-.5h1l.4-.1.3-.2v-.8l-.3-.2-.4-.1h-.8v3.4h-.7v-4h1.5q.5 0 .8.2l.5.4.1.7-.1.7-.5.4zm-3.7-1.4v.4h-1.7v-.5zm-1.2-.8h.6v3.1l.2.1h.4v.5h-.8l-.3-.3-.1-.5zm-2.8 1.4v2.3H73v-3h.6zm0 .7h-.3v-.6l.3-.4.4-.3.5-.1h.4l.3.2.2.4v2.5h-.6V105l-.3-.2h-.3l-.5.2-.1.3zm-2.5 1.7-.5-.1a1 1 0 0 1-.8-.8V105l.3-.5.4-.3.6-.1.5.1q.3 0 .4.3l.3.5v.8H70v-.4h1.6v-.4l-.3-.3h-.6l-.2.2-.2.3v.9l.2.3.6.3a1 1 0 0 0 .8-.4l.3.3-.2.3-.4.2zm-3-.6h.2l.2-.2.1-.3h.6l-.1.6-.5.3-.6.2-.6-.1-.4-.4-.2-.4-.1-.6v-.7l.3-.5.4-.3.6-.1.7.1.4.4.1.6h-.6v-.3l-.3-.2h-.6l-.2.2-.1.3v1.2l.3.2zm-3.1.6-.6-.1a1 1 0 0 1-.7-.8l-.1-.6v-.7l.4-.5.4-.3.5-.1.6.1.4.3.2.5v.8h-2.2v-.4h1.6v-.4l-.2-.3h-.7l-.2.2-.1.3v.9l.1.3.6.3a1 1 0 0 0 .8-.4l.3.3-.2.3-.4.2zm-4.9-4.1h1.4q.5 0 .8.2.3 0 .5.4l.2.6-.2.6-.3.3-.4.3h-1.5v-.5h1.3l.3-.3v-.7q0-.2-.3-.2l-.4-.1h-.7v3.4H60zm2.3 4-1-1.8h.8l1 1.8z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "al",
    width: 47,
    height: 9,
    x: 393,
    y: 103,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M393.7 104q0-.8 1-.9h44q1 0 1 1v6.5q0 .9-1 1h-44a1 1 0 0 1-1-1z"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#al)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#am)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2196f3",
    d: "M414.6 103.1h-20a1 1 0 0 0-.9 1v6.5q0 .9 1 1h19.9q.8-.1.9-1v-6.5q0-1-1-1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M410.7 108.5h-.5v-.3h.5l.3-.1.3-.3v-.9l-.1-.2-.2-.2h-.8v-.3h.9l.6.6v1.1a1 1 0 0 1-1 .6m-.3-2.3v2.3h-.4v-2.3zm-.8 2v.3h-1.3v-.3zm-1.1-2v2.3h-.4v-2.3zm1 1v.3h-1.2v-.4zm0-1v.3h-1.2v-.3zm-2.5 0v2.3h-.5v-2.3zm.7 0v.3h-1.9v-.3zm-2.9.3-.7 2h-.4l.9-2.3h.2zm.6 2-.7-2v-.3h.2l1 2.3zm0-.9v.4H404v-.4zm-1.9.6v.3h-1.3v-.3zm-1.2-2v2.3h-.4v-2.3zm1 1v.3h-1v-.4zm.2-1v.3h-1.3v-.3zm-3.7 0h1.3l.3.3v.7l-.2.2-.3.1v.1h-.8v-.3h.8l.1-.2v-.4l-.1-.2h-.7v2h-.4zm1.3 2.3-.5-1h.4l.5 1zm-2.1-.8h.3l-.1.5-.3.2-.5.1h-.4l-.3-.3-.2-.3v-1.1l.2-.4.3-.2h.9l.3.3.1.4h-.4v-.2l-.2-.2h-.5l-.2.2v.2l-.1.3v.6l.1.2.2.2h.5l.2-.2z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#2196f3",
    fillOpacity: 0.5,
    d: "M415.5 103.1h.2v8.5h-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2196f3",
    d: "M434.6 108.5h-.5v-.3h.5l.4-.1.2-.3.1-.4v-.5l-.2-.2-.2-.2h-.8v-.3h1l.5.6.1.5v.6l-.3.3-.3.2zm-.2-2.3v2.3h-.4v-2.3zm-.9 2v.3h-1.2v-.3zm-1-2v2.3h-.5v-2.3zm.9 1v.3h-1.1v-.4zm.1-1v.3h-1.2v-.3zm-2.9 1.8.6-1.8h.5l-.9 2.3h-.3zm-.6-1.8.6 1.9.1.4h-.3l-.8-2.3zm-.8 0v2.3h-.4v-2.3zm-1.3.9v.4h-1.2v-.4zm-1.1-1v2.4h-.4v-2.3zm1.4 0v2.4h-.4v-2.3zm-2.7 1.6h.4l-.1.5-.3.2-.5.1h-.4l-.3-.3-.2-.3v-1.1l.2-.4.3-.2h.9l.3.3.1.4h-.4v-.2l-.2-.2h-.5q-.2 0-.2.2l-.1.2v1.1l.5.2h.3l.1-.2zm-3.5-1.5h1.2l.3.3.1.4v.3l-.2.2-.3.1-.1.1h-.8v-.3h.8l.2-.2v-.4l-.2-.2h-.6v2h-.4zm1.3 2.3-.6-1h.5l.5 1zm-2.7-2-.7 2h-.4l.9-2.3h.2zm.6 2-.7-2v-.3h.2l.9 2.3zm0-.9v.4h-1.3v-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2196f3",
    fillOpacity: 0.5,
    d: "M439.5 103.1h.2v8.5h-.2z"
  }))), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    stroke: "#2196f3",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    d: "M394.7 103.2h44q.8 0 .9.9v6.5q0 .8-.9.8h-44a1 1 0 0 1-.9-.8v-6.5q0-.8.9-.9Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "an",
    width: 380,
    height: 14,
    x: 60,
    y: 115,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M60 115.3h379.7v13.1H60z"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#an)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#616467",
    d: "M439.7 128.4v-.2H60v.5h379.7z"
  }))), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M129.4 115.3H60v13.1h69.4z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fill: "#e1e1e1",
    d: "M72.7 121v.3h-1v-.3zm-.7-.5h.4v1.9h.3v.3h-.5l-.1-.2v-2m-1.2 1.9.2-.1v-.2h.4l-.1.3-.3.3h-.7l-.2-.2-.2-.3v-.7l.2-.3.2-.2h.7l.3.3v.3h-.3v-.2l-.3-.2-.2.1-.1.1-.1.2v.7h.2zm-1.8.3h-.3l-.4-.5-.1-.3v-.4l.2-.3.3-.2h.6l.2.2.2.2v.6h-1.3v-.3h1l-.1-.2-.1-.2h-.4l-.1.1v.2l-.1.2v.3l.1.2.4.1.4-.2.2.2-.2.2h-.2zm-1.6-1.7h.4v2.2l-.2.1-.3.1h-.2v-.3h.2l.1-.1zm0-.5h.4v.3h-.4zm-2 1.5v-.4l.2-.3.3-.2h.7l.2.2.2.3v.7l-.2.3-.6.2H66l-.4-.5zm.4 0v.2l.1.2h.1l.2.1.4-.1v-.9l-.2-.1h-.4v.1l-.2.2zm-1.1-.6v1.4h-.4V121h.4zm.6-.3v.3H65l-.2.2v.2h-.1v-.3l.1-.2.2-.2h.3m-2.1.8h-.6v-.3h.9l.1-.2v-.4l-.1-.1-.3-.1h-.5v2h-.4v-2.3h1.4l.3.3v.8l-.3.3z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M173.7 115.3h-44.3v13.1h44.3z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fill: "#e1e1e1",
    d: "M149.2 123.1h-.4l-.2-.2-.2-.3v-.8l.2-.2.2-.2h.7l.2.1.1.3v.5h-1.3v-.3h1v-.2l-.2-.1h-.5v.9l.4.2.4-.2.2.2-.1.1-.2.2zm-3.2-1.4v1.4h-.5v-1.8h.4zm-.2.4v-.6l.3-.1h.7l.1.2v1.5h-.3v-1.3l-.2-.1h-.5zm1.1 0h-.2v-.3l.2-.3.5-.2h.3l.1.2.1.2v1.3h-.3v-1.3h-.5l-.2.2zm-2.3.6v-1h-.1l-.2-.1h-.2v.1l-.1.1h-.4v-.2l.2-.1.2-.1h.7l.2.2v1.3l.1.1h-.4zm0-.7v.3h-.6v.4l.2.1.4-.2v-.1l.1.2v.1l-.3.3h-.6l-.2-.2v-.6l.2-.1.2-.1zm-1.5-1.4v2.4h-.4l-1-1.7v1.7h-.4v-2.4h.4l1 1.7v-1.7zm-3.1.6v.3h-1v-.3zm-.6-.4h.3v1.8h.4v.4h-.5l-.2-.2zm-1.6.8v1.4h-.4v-1.8h.3zm-.1.4v-.3l.2-.3.5-.2h.2l.2.2v.2l.1.3v1h-.4v-1.2l-.1-.1h-.5v.2zm-1.3 1h-.4l-.4-.5v-.8l.1-.2.6-.3h.3l.3.2.1.3v.5h-1.3v-.3h1v-.2l-.2-.1h-.5v.9l.4.2.4-.2.2.2-.1.1-.2.2zm-1.3-1.8v1.8h-.4v-1.8zm-.4-.4v-.2h.4v.3zm-.4-.3v2.5h-.4v-2.5zm-1.2 1.7h.4q0 .3-.2.4l-.3.3-.4.1h-.4l-.3-.3-.2-.3v-1.1q0-.3.2-.4l.3-.2h.8q.3 0 .3.3l.2.4h-.4l-.1-.2q0-.2-.2-.2h-.5l-.1.1-.1.3v1.1l.2.1h.5l.2-.1z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M218 115.3h-44.3v13.1H218z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fill: "#e1e1e1",
    d: "M195.5 122.7h-.4l-.4-.5v-.7l.1-.3.3-.2h.6l.3.2.1.2v.6h-1.3v-.3h1v-.2l-.2-.2h-.4v.1l-.2.2v.5l.1.2.4.1.4-.2.2.2-.1.2h-.2zm-3.3-1.4v1.4h-.4V121h.4zm0 .5h-.2v-.4l.2-.2q0-.2.2-.2h.7v.3l.1.3v1.1h-.4v-1.3l-.1-.1h-.4v.1l-.2.2zm1-.1h-.2v-.3l.2-.2.2-.2h.5l.3.3v1.4h-.3v-1.3l-.2-.1h-.4v.2zm-2.2.7v-1l-.2-.1h-.4v.2h-.4v-.2l.2-.2.2-.1h.6l.3.2v1.3l.1.2h-.4zm0-.7v.2h-.6v.5h.2l.3-.1v-.2l.2.2v.1l-.6.3h-.3l-.2-.2v-.5l.1-.2.3-.1zm-1.5-1.3v2.3h-.4l-1-1.7v1.7h-.4v-2.3h.4l1 1.6v-1.6zm-3.1.6v.3h-1v-.3zm-.7-.5h.4v1.9h.3v.3h-.5l-.1-.2v-2m-1.2 1.9.2-.1v-.2h.4l-.1.3-.3.3h-.7l-.2-.2-.2-.3v-.7l.2-.3.2-.2h.7q.2 0 .3.3v.3h-.3v-.2l-.1-.1h-.4l-.1.1-.1.2v.7h.2zm-1.8.3h-.3l-.4-.5-.1-.3v-.4l.2-.3.3-.2h.6l.2.2.2.2v.6h-1.3v-.3h1l-.1-.2-.1-.2h-.4l-.1.1v.2l-.1.2v.3l.1.2.4.1.4-.2.2.2-.1.2h-.3zm-1.6-1.7h.4v2.2l-.2.1-.3.1h-.2v-.3h.2l.1-.1zm0-.5h.4v.3h-.3zm-2 1.5v-.4l.2-.3.3-.2h.7l.2.2.2.3v.7l-.2.3-.6.2h-.3l-.3-.2-.1-.3zm.4 0v.2l.1.2h.1l.2.1h.2l.2-.1v-.9l-.2-.1h-.4v.1l-.2.2zm-1.1-.6v1.4h-.4V121h.4zm.6-.3v.3h-.4l-.1.1v.1l-.1.2v-.5l.2-.2zm-2.1.8h-.7v-.3h.9l.1-.2v-.4l-.1-.1-.3-.1h-.4v2h-.5v-2.3h1.4l.4.7-.1.4-.3.3z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M262.4 115.3H218v13.1h44.4z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fill: "#e1e1e1",
    d: "m232.1 122.7.5-2.3h.2l-.4 2.3zm.7 0 .4-2.3h.3l-.5 2.3zm.9-1.4H232v-.3h1.7zm-.2.7H232v-.2h1.6zm-2.8-1v.3h-1v-.3zm-.6-.5h.3v1.9h.4v.3h-.5q-.2 0-.2-.2zm-1.1 1.9.2-.1v-.2h.4v.3l-.3.3h-.7l-.3-.2-.1-.3v-.7l.1-.3.3-.2h.7l.2.3.1.3h-.3v-.2l-.2-.1h-.4l-.1.1v.9h.1zm-1.8.3h-.4l-.4-.5v-.7l.2-.3.2-.2h.6l.3.2.1.2v.6h-1.3v-.3h1v-.2l-.2-.2h-.4v.1l-.2.2v.5l.1.2h.2l.2.1.4-.2.2.2-.1.2h-.2zm-1.6-1.7h.3v2.2l-.2.1-.3.1h-.2v-.3h.3v-2.2m0-.5v-.1h.3v.3h-.3zm-1.9 1.5v-.4l.2-.3.2-.2h.7l.3.2.1.3v.7l-.1.3-.3.2h-.7l-.2-.2-.2-.3zm.3 0v.2l.1.2h.2l.2.1.3-.1v-.9l-.3-.2h-.2l-.2.2zm-1.1-.5v1.4h-.4V121h.3zm.5-.3v.3h-.3l-.2.2v.2h-.2v-.3l.2-.2.1-.2zm-2.1.8h-.6v-.3h.8l.2-.2v-.4l-.2-.1-.2-.1h-.5v2h-.4v-2.3h1.3l.3.3.1.4v.4l-.4.3z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M306.7 115.3h-44.3v13.1h44.3z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fill: "#e1e1e1",
    d: "M271 122.7h-.3l-.4-.5v-.8l.1-.2.3-.2h.6l.3.2.1.2v.5h-1.3v-.3h1v-.2l-.2-.1h-.4l-.2.3v.5l.3.3h.4l.2-.2.2.2-.1.1-.2.2zm-2.2-1.4v2h-.4V121h.4zm1.1.5v.4l-.2.3-.5.2h-.2l-.2-.2-.2-.3v-.8l.2-.3.2-.1h.5q.2 0 .2.2l.2.2zm-.4 0v-.4l-.2-.1h-.5v.9l.1.1.2.1h.2l.1-.2.1-.2zm-2.2.7.4-1.6h.4l-.7 2v.2l-.1.1-.2.1h-.3v-.2h.2v-.1l.1-.2zm-.3-1.6.4 1.3v.4l-.2.1-.6-1.8zm-1.2-.6v2.4h-.4v-2.4zm.8 0v.4h-1.9v-.4z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M351 115.3h-44.3v13.1H351z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fill: "#e1e1e1",
    d: "M318 122.6v-.2l-.3-.1h-.3l-.2-.2v-.1l-.1-.2v-.2l.1-.2.3-.1h.6l.2.2.1.3h-.4v-.1l-.1-.1h-.4v.3h.1l.2.1.3.1.3.2v.2l-.2.4-.2.1h-.7l-.2-.2-.1-.3h.4v.2h.6zm-1.7 0v-1.3h.3v1.7h-.3zm0-.3h.1v.3l-.1.2-.2.2h-.7l-.1-.3v-1.4h.3v1.3l.2.1h.3l.2-.2zm-1.4-1v.3h-1v-.3zm-.7-.4h.4v1.8h.2v.3h-.4l-.2-.1zm-.9 1.8v-1l-.2-.1h-.4v.2h-.4v-.2l.1-.2.3-.1h.6l.3.2v1.3l.1.2h-.4zm0-.7v.2h-.5l-.2.2v.2l.1.1h.2l.3-.1v-.2l.2.2v.2l-.2.1-.4.2-.3-.1-.2-.2v-.5l.1-.2h.3l.3-.1zm-1.3-.7v.3h-1v-.3zm-.8-.4h.4v1.8h.4v.3h-.5l-.2-.1zm-.9 1.5-.1-.1h-.2l-.2-.2-.3-.1-.3-.1-.1-.2v-.3l.1-.5h1.1l.3.2v.4h-.3v-.2l-.2-.2h-.5l-.1.1v.4l.2.1h.2l.4.2.2.2.1.2v.5l-.1.2-.3.1h-.7l-.3-.1-.2-.3v-.3h.3v.2l.2.1.2.1h.4l.1-.1z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M395.4 115.3H351v13.1h44.4z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fill: "#e1e1e1",
    d: "m368.4 122.6.5-1.6h.4l-.7 2v.1l-.2.2-.1.1h-.4v-.3h.3v-.2zm-.3-1.6.5 1.3v.4h-.2l-.7-1.7zm-2.1-.7h.4v2.4h-.4zm1.6 1.6v.3l-.2.3-.5.3h-.3l-.2-.3-.1-.2-.1-.4v-.4l.2-.3.5-.2h.3l.2.2.1.3zm-.4 0v-.3l-.1-.1-.3-.2h-.2l-.1.1v.2l-.1.1v.5l.2.2h.4v-.1l.2-.2zm-2.8.5v-2.1h.3v2.4h-.3zm-1.2-.5v-.4l.2-.3.5-.2.5.2.1.3v.8l-.1.2-.5.3-.5-.3-.1-.3zm.4 0v.2l.1.2.1.1h.4l.2-.2v-.6l-.1-.2h-.1l-.2-.1h-.2l-.1.2zm-1.4.9h-.4l-.4-.5v-.8l.2-.3.5-.2h.3l.3.2.1.3v.5h-1.3v-.3h1v-.2l-.2-.2h-.4v.1l-.2.2v.5l.3.3h.2l.4-.1.2.1-.1.2-.2.1zm-1.1-1.8v.3h-1v-.3zm-.7-.4h.4v1.8h.3v.3h-.5l-.2-.1zm-1 1.8v-1l-.1-.1h-.4v.2h-.5v-.2l.2-.2h.3l.2-.1h.4l.3.6v1.1h-.3zm0-.7v.2h-.4l-.1.1-.1.2v.1l.1.1h.4l.1-.1v-.1l.2.1v.2l-.6.3-.3-.1-.2-.2-.1-.2v-.3l.2-.2h.3l.3-.1zm-2.1 1.1h-.3l-.5-.5v-.8l.2-.3.6-.2h.3l.2.2.2.3v.5h-1v-.3h1l-.1-.2-.1-.2h-.2l-.3.1-.1.2v.5l.1.2.3.2h.3l.2-.2.2.1-.2.2-.2.1zm-1.5-1.5v1.4h-.4V121h.4zm.5-.3v.4h-.5v.3h-.1v-.5l.2-.2zm-1.7 1h.4l-.1.4-.3.3h-.9l-.3-.2-.2-.4V121l.2-.3.3-.2.4-.1h.5l.3.4.1.4h-.4v-.3l-.2-.1-.3-.1h-.2l-.2.2v.2l-.1.4v.5l.1.2.2.2h.5l.1-.2z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M439.7 115.3h-44.3v13.1h44.3z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fill: "#e1e1e1",
    d: "M413 121.7v1.4h-.3v-1.8h.3zm0 .4h-.1v-.3l.2-.3.5-.2h.2l.2.2v.2l.1.3v1h-.4v-1.2l-.1-.1h-.5v.2zm-.7-.3v.2l-.1.4-.2.4-.3.2-.4.1h-.4l-.3-.3-.2-.4v-1l.2-.4.7-.3h.4l.3.3.2.4zm-.4.2v-.5l-.2-.3-.2-.1h-.4l-.2.1-.1.3v1.1l.3.1h.4l.2-.1.1-.3zm-3.2.7v-2h.4v2.4h-.4zm-1.1-.5v-.4l.1-.2.5-.3h.3l.2.2.1.3.1.4v.4l-.2.3-.5.2-.5-.2-.1-.3zm.3 0v.2l.1.2.2.1h.3l.2-.1v-.9h-.7v.5m-1.4.9h-.4l-.4-.5v-.8l.4-.4h.7l.2.1.1.3v.5H406v-.3h1v-.2l-.2-.1h-.4l-.1.3v.6l.4.2.5-.2.2.2-.2.1-.2.2zm-1.1-1.8v.3h-1v-.3zm-.7-.4h.4v1.8h.3v.4h-.5l-.1-.2-.1-.3zm-.9 1.8v-1h-.2l-.1-.1h-.2l-.1.1v.1h-.4v-.2l.2-.1.2-.1h.6l.3.2v1.3l.1.1h-.4zm0-.7v.3h-.6v.5h.4l.1-.2v-.1l.2.2v.1l-.2.2h-.2l-.2.1h-.3l-.2-.2v-.6l.1-.1.3-.1h.6m-2 1h-.4l-.3-.2-.1-.3v-.8l.1-.2.3-.2h.6l.3.1.1.3v.5h-1.3v-.3h1v-.2l-.2-.1h-.4l-.2.3v.5l.1.1.2.2h.4l.2-.2.2.2-.1.1-.2.2zm-1.6-1.4v1.4h-.4v-1.8h.4zm.5-.4v.4h-.4l-.1.2v.2h-.1v-.3l.1-.3.2-.1h.3m-1.6.9h.4l-.2.4-.3.3-.5.1h-.4l-.2-.3-.2-.3-.1-.5v-.6l.3-.4.3-.2h.8q.3 0 .3.3l.2.4h-.4l-.1-.2-.2-.2h-.5l-.2.1v.3l-.1.3v.5l.1.3.4.2h.3l.2-.2z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "aq",
    width: 380,
    height: 12,
    x: 60,
    y: 128,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _use21 || (_use21 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ap"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#aq)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M129.4 128H60v12h69.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4285f4",
    d: "M90.3 133.4v.3h-1v-.3zm-.7-.5h.4v1.8l.2.1h.1v.3h-.5l-.2-.2zm-.6-.1v2.3h-.4v-2.3zm-2.5 1.5v-.4l.2-.3.3-.2h.7l.2.2.2.3v.7l-.2.3-.2.2H87l-.3-.2-.1-.3zm.5 0v.3l.2.2h.3l.1-.2.1-.1v-.7l-.4-.1-.3.1zm-1.8.9h-.5v-.3h.5l.3-.1.2-.3v-1.1l-.3-.1h-.8v-.4h1l.3.3.2.3.1.5v.6a1 1 0 0 1-1 .6m-.3-2.3v2.3h-.4v-2.3zm-.8.6v.3h-1v-.3zm-.7-.5h.4v1.8l.2.1h.1v.3h-.5l-.2-.2zm-.9 1.7-.3-.1H82l-.2-.2-.1-.1v-.4l.1-.2.2-.1h.7l.2.2.1.3h-.4v-.1l-.1-.1H82v.2l.1.1h.2l.3.2.2.1.1.3-.2.4-.2.1h-.7l-.2-.3-.1-.2h.4v.1l.2.1h.3zm-1.8.1v-1.3h.4v1.7h-.4zm0-.4h.2v.4l-.2.2-.2.2H80l-.2-.1v-.2l-.1-.3v-1.1h.4v1.3h.2v.1h.3l.1-.2zm-1.9.1v-1.6h.4v2l-.3.3H78l-.3-.3-.1-.4h.4v.2l.2.2h.3l.2-.2zm-1.2.7v.3H76v-.3zm-2.3 0h-.4l-.4-.5v-.7l.2-.3.2-.2h.7l.2.2.1.2v.6h-1.3v-.3h1v-.2l-.2-.2h-.2l-.2.1-.1.2v.7h.2l.2.1h.3l.1-.2.3.2-.2.2-.2.1zm-2.1-2.5v2.5h-.4v-2.5zm1 .8-.7.8-.4.4-.1-.3.3-.4.5-.5zm-.4 1.7-.5-.8.3-.3.7 1.1zm-1.5-1.7v1.7H72v-1.7zm-.4-.5.2-.1h.2v.4h-.4zm-.5-.1v2.3H71l-1-1.6v1.6h-.5v-2.3h.5l1 1.6v-1.6zm-2.1 2.3v.3h-1.5v-.3zm-2.8-1.3h.5l.1-.2v-.4H67l-.2-.1h-.2v.1l-.1.2H66l.1-.3.3-.3h.8l.4.6v.2l-.2.2-.6.2h-.3zm0 .3v-.2h.7l.2.1.2.2v.5l-.2.3-.3.1h-.6l-.2-.1-.2-.2v-.3h.3l.2.3h.4l.1-.2v-.4H67l-.2-.1zm-.8.7v.3h-1.5v-.3l.7-.8.2-.2.1-.2v-.4H65l-.2-.1h-.2l-.1.2v.2H64l.1-.4.3-.3h.8l.3.2v.8l-.2.2-.2.3-.5.5zm-2.4-2v2.3H63v-1.8l-.6.2v-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.7 128h-44.3v12h44.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e1e1e1",
    d: "M137.5 135.3h-.3l-.5-.5v-.8l.2-.3.2-.1.4-.1h.3l.2.2.2.3v.5h-1.4v-.3h1v-.2l-.2-.1h-.1l-.3.1v.8l.3.1h.3l.2-.2.2.3-.2.1zm-2.1-2.5v2.5h-.4v-2.5zm1.1.7-.7.9-.4.4-.2-.3.3-.4.5-.6zm-.5 1.8-.5-.8.3-.3.8 1zm-1.5-1.8v1.8h-.4v-1.8zm-.5-.4.1-.2h.4v.3l-.2.1h-.2zm-.4-.1v2.3h-.5l-.9-1.6v1.6h-.5v-2.4h.5l1 1.6v-1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218 128h-44.3v12H218z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e1e1e1",
    d: "M190.2 133.5v.2h-1v-.2zm-.6-.5h.3v2h.3v.2h-.4l-.2-.2zm-.6-.1v2.3h-.4v-2.3zm-3.3 1.4v-.3l.2-.3.3-.2h.6l.3.2.1.3v.7l-.1.3-.6.2h-.3l-.4-.5zm.3 0v.3l.1.2.2.1h.2l.4-.1v-.9l-.2-.2h-.4l-.2.2v.2zm-1.7.9h-.5v-.3h.9l.2-.4.1-.4v-.5l-.2-.3-.2-.1h-.8v-.3h.9l.3.3.3.3v1.1l-.6.5zm-.4-2.3v2.3h-.3v-2.3zm-1.5.6v.2h-1v-.2zm-.7-.5h.3v1.8l.1.2h.3v.2h-.5l-.1-.2v-2m-.9 1.7-.1-.2h-.3l-.3-.1-.2-.1v-.2l-.1-.2v-.2l.2-.1.2-.1h.6l.2.2v.3h-.2v-.2h-.2l-.2-.1h-.2v.1l-.1.2.2.1h.2l.3.2.2.2.1.2-.2.4h-.2l-.3.1h-.4l-.2-.3v-.2h.2v.2h.8zm-1.8.1v-1.3h.3v1.7h-.3zm0-.4h.2v.3l-.2.3-.2.2h-.5l-.3-.3v-1.4h.2v1.3h.1l.1.2h.2l.3-.1.1-.2zm-1.9.1V133h.3v2l-.3.2-.4.1h-.4l-.3-.3v-.4h.3v.3l.2.1h.4l.2-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.4 128H218v12h44.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e1e1e1",
    d: "M224.5 133.9h.5l.1-.2v-.4l-.1-.2h-.5l-.1.2v.2h-.4l.4-.6h.7l.3.2v.8l-.3.1zm0 .2h.6l.3.2v.1l.1.3v.2l-.2.3h-1.1l-.2-.5h.3v.2l.2.1h.5l.2-.1v-.5l-.2-.1zm-.8.8v.2h-1.5v-.2l.8-.9.2-.2v-.8h-.6l-.1.2v.3h-.4l.1-.4.3-.3h.8l.2.2.1.4v.2l-.1.2-.2.2-.1.2-.7.7zm-2.4-2.1v2.3h-.3v-2l-.6.3v-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.7 128h-44.3v12h44.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2a2a2a",
    d: "M293 131.2h-25.5a2.8 2.8 0 0 0 0 5.7h25.6a2.8 2.8 0 1 0 0-5.7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d1d1d1",
    d: "M293.5 133.3v.2h-.9v-.2zm-.6-.4h.3v1.6l.1.1h.2v.3h-.4l-.1-.2V133m-1 .5v1.4h-.3v-1.7h.3zm.5-.3v.3h-.3l-.2.2v.2h-.1v-.5a.4.4 0 0 1 .6-.2m-2.6.8v-.3l.1-.2.3-.2h.6l.2.2.2.2v.7l-.2.3-.5.2h-.3l-.3-.2-.1-.3zm.2 0v.3l.1.2.2.1h.2l.3-.1.1-.2v-.7l-.2-.1h-.4l-.2.1v.4m-1.7-1.4v2.3h-.3v-2.3zm0 1.4h-.2v-.3l.2-.3.5-.2h.2l.1.2.1.1v1.3h-.2v-1.2l-.1-.1h-.2l-.4.1zm-.9.3-.2-.1-.3-.1-.2-.1-.3-.2-.1-.1v-.2l.1-.5h.3l.3-.1h.4l.2.3.1.3h-.2l-.1-.2-.2-.1-.2-.1h-.3l-.1.2v.3l.2.2h.2l.4.2.2.1.1.2v.4l-.2.2-.2.1h-.9l-.2-.3v-.3h.3v.2l.1.2h.6l.2-.1zm-3.1.4.5-1.5h.3l-.7 2-.1.2h-.2l-.2.1h-.1v-.2h.2l.1-.1.1-.2zm-.3-1.5.4 1.3.1.3h-.2l-.6-1.6zm-.9.3v1.4h-.3v-1.7h.3zm.5-.3v.3h-.3l-.2.1v.3h-.2v-.2l.2-.3.1-.1zm-1.6 1.4v-1l-.1-.1h-.5v.2h-.3v-.2l.2-.1.2-.1h.5q.2 0 .2.2l.1.3v1h-.2zm0-.7v.2h-.5l-.1.1v.4h.2l.4-.1v-.2l.2.1v.2l-.2.1-.4.2h-.3l-.2-.2v-.3l.1-.4h.3l.3-.1zm-1.2-.6v.2h-1v-.2zm-.6-.4h.2v1.6l.1.1h.2v.3h-.4v-.2l-.1-.2zm-1.6.7v1.3h-.3v-1.7h.3zm0 .4h-.2v-.3l.2-.3.5-.2h.2l.2.2v.1l.1.3v1h-.3v-1.2l-.1-.1h-.4l-.1.1zm-1.2.9h-.4l-.2-.2-.1-.3v-.7l.1-.3.5-.2h.3l.2.2.1.3v.4H277v-.2h.9v-.2l-.2-.2h-.4v.1l-.2.2v.5l.1.2.4.2.2-.1.2-.2.2.2-.2.1-.2.1zm-3.2-1.3v1.3h-.2v-1.7h.2zm0 .4v-.3l.1-.3.2-.1h.7l.1.2v1.3h-.2v-1.2l-.2-.1h-.4l-.1.1v.2zm1-.2-.1.1.1-.5.5-.2h.2l.2.2v.1l.1.3v1h-.2v-1.2l-.2-.1h-.4l-.1.2zm-2 .7v-1.3h.3v1.7h-.2zm0-.4h.2v.3l-.1.3-.2.1h-.7l-.1-.2v-1.3h.2v1.2h.1l.1.1h.4l.1-.2zm-1.9.6h.1l.2-.2v-.2h.3v.3l-.6.3h-.4l-.2-.3-.1-.2v-.7l.1-.2.3-.2h.6l.2.2.1.3h-.3l-.1-.3h-.4l-.2.1v.9l.2.1zm-2.5-.7v-.3l.2-.2.2-.2h.6q.2 0 .2.2l.2.2v.7l-.2.3-.5.2h-.3l-.2-.2-.2-.3zm.3 0v.5l.2.1h.2l.4-.1v-.9l-.2-.1h-.2l-.3.1-.1.2zm-1.7.9h-.4v-.3h.8l.3-.3v-.9l-.1-.3-.2-.1h-.8v-.3h.9l.3.3.2.3v1l-.2.3-.4.2zm-.3-2.2v2.2h-.2v-2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351 128h-44.3v12H351z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#29562b",
    d: "M318.7 131.2h-6.8a2.8 2.8 0 1 0 0 5.7h6.8a2.8 2.8 0 1 0 0-5.7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#66e56c",
    d: "M318.6 135h-.3l-.2-.1-.1-.3v-.6l.1-.3.5-.2h.2l.2.2.1.3v.3h-1v-.1h.8v-.2l-.1-.2h-.5l-.1.3v.6l.2.1h.4l.2-.1h.2l-.2.2-.1.1zm-1.6-.2.5-1.2h.2l-.5 1.4h-.2zm-.3-1.2.4 1.2v.2h-.1l-.5-1.4zm-.5 0v1.4h-.3v-1.4zm-.3-.4h.2v.2zm-.4.4v.2h-.8v-.2zm-.5-.4h.3v1.6h.2v.2h-.4v-1.8m-1.1 1.7h.2l.1-.2v-.1h.3v.2l-.6.3h-.3l-.2-.3-.1-.2v-.6l.1-.3.2-.1h.6l.2.2.1.3h-.2l-.1-.2-.3-.2h-.2l-.1.2v.2l-.1.2v.4l.2.1zm-1.7-1.7-.6 1.8h-.3l.7-2h.2zm.6 1.8-.7-1.8v-.2h.2l.7 2zm0-.7v.2h-1.2v-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.4 128H351v12h44.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e1e1e1",
    d: "m368.8 134.7-.1-.2h-.3l-.2-.1-.2-.1-.2-.2v-.3l.2-.2.2-.1h.6l.2.2.1.3h-.3v-.2h-.2l-.2-.1h-.2l-.1.2v.2h.2l.2.1.4.1.2.2v.2l-.2.4-.2.1h-.6l-.3-.3v-.2h.2l.1.2h.6zm-1.8.3v-1.2h-.1l-.3-.1h-.1l-.2.1v.2h-.3v-.2l.2-.2.2-.1h.6l.2.2.1.3v1.2h-.2zm0-.8v.2h-.6l-.1.1v.4h.3l.4-.1v-.2l.2.2v.1l-.4.3h-.6l-.2-.2v-.5l.2-.2.2-.1zm-1.6-.7v1.7h-.3v-1.7zm-.3-.5h.3v.2zm-1.6 2.1h-.4v-.2h.4l.5-.1.2-.3v-1l-.1-.3-.2-.1h-.9v-.3h1l.3.3.2.3v1.1l-.2.3-.3.2zm-.3-2.3v2.3h-.3V133zm-2 2.1v-1.2h-.2l-.2-.1h-.2v.1l-.1.2h-.3v-.2l.2-.2.2-.1h.6l.2.2.1.3v1.2h-.2zm0-.8v.2h-.6l-.1.1v.4h.3l.4-.1v-.2l.2.2-.1.1-.3.3h-.6l-.2-.2v-.5l.1-.2.3-.1zm-1.9-.5v1.5h-.3v-1.7h.3zm.5-.2v.2h-.3l-.1.1-.1.2v.2h-.1v-.5l.3-.2zm-1.7.2v1.5h-.3v-1.7h.3zm.6-.2v.2h-.3l-.2.1v.2l-.1.2v-.5zm-1.9 1.7h-.3l-.5-.5v-.7q0-.2.2-.3l.5-.3.4.1.2.2.1.3v.4h-1.2v-.2h1v-.3l-.2-.1-.3-.1-.3.2v.2l-.1.2v.3l.1.2.2.2h.5l.2-.2.1.1-.1.2h-.2zm-1.3-1.7v1.7h-.2v-1.7zm-.3-.5h.3v.2h-.2m-1.8-.2v2.3h-.3V133zm1.4 0-1 1-.5.6v-.3l.3-.5.8-.8zm-.3 2.3-.9-1.1.2-.3 1 1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.7 128h-44.3v12h44.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e1e1e1",
    d: "M417.3 134v.3h-1.7v-.1l1-1.7h.3l-.2.5-.7 1zm-.3-1.5v2.4h-.3v-2.4zm-1.6 2.1v.3h-1.5v-.2l.7-.9.2-.3.2-.2v-.3l-.2-.2h-.5l-.1.2v.2h-.4l.1-.3.3-.3h.8l.2.2v.7l-.2.3-.2.2-.6.6zm-2-1.1v.9l-.2.3-.2.2h-.5l-.3-.1-.1-.2-.1-.3V133l.2-.3.2-.1h.6l.3.2.1.3zm-.3.4v-.9l-.1-.1-.1-.1h-.4l-.1.1-.1.2v1.3l.1.2h.5l.1-.1.1-.2zm-1.5.7v.3h-1.5v-.2l.8-.9.2-.3v-.7h-.6l-.1.2v.2h-.4l.1-.3.3-.3h.8l.2.2.1.3v.2l-.3.5-.1.2-.7.6zm-2.8-.1v.6l-.2.2h-.2l.2-.5v-.3zm-.7-1v.9l-.2.3-.2.2h-.6l-.2-.1-.1-.2-.1-.3V133l.2-.3.2-.1h.5l.4.2v.3zm-.3.4v-.9l-.1-.1-.2-.1h-.3l-.1.1-.1.2v1.3l.1.2h.5l.1-.1.1-.2zm-2.6-.3h.5l.1-.2v-.5l-.1-.1h-.4l-.2.1v.3h-.3v-.4l.3-.2h.7l.3.2v.7l-.3.2zm0 .2v-.2h.6l.3.2v.2l.1.2v.3l-.2.2-.2.2h-.6l-.2-.2-.3-.4h.3v.2l.2.1h.5l.2-.1v-.5l-.2-.1zm-2.4.8.5-1.6h.3l-.6 2-.2.3-.4.2h-.1v-.3h.2l.1-.1.1-.2zm-.3-1.6.4 1.4.1.3-.2.1-.6-1.8zm-.9 1.5v-1l-.2-.2h-.5v.2h-.4v-.2l.2-.1.3-.1h.6l.2.2v1.3l.1.1h-.3zm0-.8v.2h-.5l-.2.1v.5h.5l.1-.2.1-.1.1.1v.2l-.2.1-.2.2h-.5l-.2-.2v-.6l.1-.1.3-.1zm-3.8-1.4h.3l.8 2 .7-2h.3l-1 2.4h-.2zm-.1 0h.3v2.4h-.3zm2 0h.3v2.4h-.3z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "ar",
    width: 380,
    height: 12,
    x: 60,
    y: 128,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _use22 || (_use22 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ap"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#ar)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#616467",
    d: "M439.7 139.7v-.3H60v.5h379.7z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "at",
    width: 380,
    height: 12,
    x: 60,
    y: 139,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _use23 || (_use23 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#as"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#at)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M129.4 139.2H60v12.2h69.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4285f4",
    d: "M92.4 146h.3v-.2h.5l-.1.3-.3.2-.4.1h-.3l-.3-.3-.1-.2v-.8l.1-.2.3-.2.3-.1h.4l.3.3v.4h-.3v-.2l-.2-.1h-.3l-.2.1v.8zm-2.7-.5.1-.4.2-.2.2-.2.4-.1h.3l.3.3.1.2v.8l-.1.3-.3.1-.3.1h-.4l-.2-.2-.2-.3zm.5 0v.4l.2.1h.5v-.9l-.3-.2-.3.2-.1.2zm-1.8.9h-.5v-.4h.8l.2-.3.1-.4v-.5l-.2-.2-.2-.2H88v-.4h.5l.4.1.3.2.3.4v1l-.6.6zM88 144v2.4h-.4V144zm-2.3 2 .3-1.4h.3v.5l-.4 1.3h-.3zm-.2-1.4.2 1.4v.4h-.2l-.5-1.8zm1.2 1.3.2-1.3h.5l-.5 1.8h-.3zm-.3-1.3.3 1.3v.5h-.1l-.4-1.3-.1-.5zm-2.2 1.8h-.4l-.4-.5v-.8l.1-.2.3-.2.3-.1h.3l.3.2.1.3v.5h-1.3v-.3h1v-.2l-.2-.1h-.4l-.1.3v.6l.2.1h.4l.2-.1.2.2-.1.1-.2.2zM83 144v2.4h-.5l-1-1.6v1.6H81V144h.5l1 1.7V144zm-2.2 2.4v.3h-1.5v-.3zm-2.7-1.8.4.6.3-.6h.4l-.5.9.5.9h-.4l-.3-.6-.4.6h-.4l.5-1-.5-.8zm-.7 0v1.8h-.5v-1.8zm-.5-.4v-.2h.4v.3l-.1.1H77zm-.4-.2v2.4H76v-2.5zm-1.1 2.4h-.5v-2l.1-.3.2-.2h.6v.3h-.3v.1l-.1.2zm.3-1.8v.3h-1v-.3zm-1.2 0v.3h-1v-.3zm-.7-.4h.4v1.8h.3v.4H74l-.2-.2zm-1.1 2.2h-.4a1 1 0 0 1-.5-.8v-.5l.2-.2.3-.2.3-.1h.3l.3.2.1.3v.5H72v-.3h1l-.1-.2-.1-.1h-.4l-.1.3v.6l.2.1h.4l.2-.1.2.2-.1.1-.2.2zm-1.3-2.4v2.4H71l-1-1.6v1.6h-.5V144h.5l1 1.7V144zm-2.1 2.4v.3h-1.5v-.3zm-1.6-.9v.4H66v-.3l1-1.6h.3l-.3.7-.6.8zm-.3-1.5v2.4H67V144zm-1.7 2v.4h-1.5v-.3l.7-.8.2-.3.1-.1v-.4l-.1-.1h-.4l-.1.1v.3H64l.1-.4.3-.3.4-.1h.4l.3.3v.8l-.4.4-.5.5zm-2.4-2v2.4H63v-1.9l-.6.2v-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.7 139.2h-44.3v12.2h44.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e1e1e1",
    d: "m140 144.8.4.6.4-.6h.3l-.5.8.5 1h-.3l-.4-.7-.4.6h-.4l.6-.9-.5-.8zm-.7 0v1.7h-.3v-1.7zm-.3-.5h.3v.2h-.3m-.5-.5v2.5h-.3v-2.4zm-1.1 2.5h-.3v-2.2l.3-.2h.5v.2h-.4v.1l-.1.2zm.4-1.7v.2h-1v-.2zm-1.2 0v.2h-1v-.2zm-.7-.4h.3v1.8h.3v.3h-.4l-.1-.1v-2m-1.2 2.1h-.4l-.4-.5v-.7l.2-.3a1 1 0 0 1 .9-.2l.2.2.1.3v.4h-1.2v-.2h1v-.3l-.2-.1-.3-.1h-.1l-.2.2v.2l-.1.2v.3l.1.2.4.2.4-.2.2.1-.1.2-.2.1zm-1.3-2.3v2.3h-.3l-1.2-1.8v1.8h-.3v-2.3h.3l1.2 1.8v-1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218 139.2h-44.3v12.2H218z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e1e1e1",
    d: "M188.3 146.2h.2l.2-.1v-.2h.3v.3l-.7.3-.3-.1-.3-.2-.1-.3v-.7l.1-.3.3-.2h.7l.2.3.1.3h-.3v-.2l-.2-.1h-.4l-.1.1-.1.2v.7l.2.2zm-2.7-.6.1-.4q0-.2.2-.3l.2-.2h.7l.2.2.2.3v.7l-.2.3-.6.3-.3-.1-.4-.5zm.3 0v.2l.2.2.1.2h.4l.2-.2v-.2l.1-.2v-.3l-.1-.2-.2-.1h-.2l-.3.1-.1.2zm-1.7.8h-.5v-.2h.5l.4-.1.3-.3v-1l-.1-.2-.3-.2h-.8v-.3h1l.3.3.2.3v1.1l-.6.6zm-.3-2.3v2.3h-.3v-2.3zm-3.3 2 .5-1.4h.1v.3l-.4 1.4h-.2zm-.3-1.4.4 1.4v.3h-.2l-.5-1.7zm1.4 1.4.3-1.4h.3l-.5 1.7h-.2zm-.4-1.4.4 1.4v.3h-.1l-.5-1.4v-.3zm-2.2 1.8h-.3l-.4-.5v-.8l.1-.3.3-.2h.6l.2.2.1.3v.5h-1.2v-.3h1v-.2l-.2-.2h-.6v1.1h.2l.2.1h.3l.2-.2.2.1-.2.2-.2.1zm-1.3-2.4v2.3h-.3l-1.1-1.8v1.8h-.4v-2.3h.4l1.1 1.8v-1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.4 139.2H218v12.2h44.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e1e1e1",
    d: "M225.6 145.7v.2H224v-.1l1-1.7h.2l-.2.5-.7 1zm-.3-1.6v2.4h-.3V144zm-1.6 2.1v.3h-1.5v-.2l.8-.9.2-.3v-.7h-.6l-.1.2v.2h-.4l.1-.3.3-.3.4-.1h.4l.2.3.1.3v.2l-.1.2-.2.2-.1.2-.7.7zm-2.4-2.1v2.4h-.3v-2l-.6.2v-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.7 139.2h-44.3v12.2h44.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3a0e0b",
    d: "M273.8 142.5h-6.3a2.8 2.8 0 1 0 0 5.6h6.3a2.8 2.8 0 1 0 0-5.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f2afa8",
    d: "M274.3 144.7v.3h-.9v-.3zm-.6-.3h.3v1.7h.2v.3h-.3l-.1-.2zm-1.6.6v1.4h-.3v-1.7h.2zm-.1.5h-.1v-.3l.2-.3.4-.2h.3l.1.1.1.2v1.3h-.2v-1.2l-.2-.1h-.3l-.2.1v.2zm-1.2.9h-.3l-.2-.2-.2-.3v-.7l.2-.3.5-.2h.3l.2.2v.3l.1.3v.1h-1.2v-.2h1v-.2l-.2-.2h-.2l-.3.1-.1.2v.7l.4.2.3-.1.1-.2.2.2-.1.1zm-1.7-.3.5-1.4h.3l-.6 1.7h-.2zm-.3-1.4.4 1.4v.3h-.1l-.6-1.7zm-.5 1.4v.3h-1.1v-.3zm-1-2v2.3h-.3v-2.2zm.9 1v.3h-1v-.3zm.1-1v.3h-1.1v-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351 139.2h-44.3v12.2H351z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#29562b",
    d: "M318.7 142.5h-6.8a2.8 2.8 0 1 0 0 5.6h6.8a2.8 2.8 0 1 0 0-5.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#66e56c",
    d: "M318.6 146.3h-.3l-.2-.2-.1-.2v-.7l.1-.2.5-.2h.2l.2.2.1.2v.4h-1v-.2h.8v-.2l-.1-.2h-.2l-.3.1-.1.2v.7h.2l.2.1h.2l.2-.2.2.1-.2.2h-.1zm-1.6-.3.5-1.2h.2l-.5 1.5h-.2zm-.3-1.2.4 1.3v.2h-.1l-.5-1.5zm-.5 0v1.5h-.3v-1.5zm-.3-.4h.2v.2h-.2m-.4.2v.2h-.8v-.2zm-.5-.4h.3v1.6h.2v.3h-.3l-.1-.1zm-1.1 1.7h.2l.1-.1v-.2h.3v.3l-.6.2h-.3l-.2-.2-.1-.2v-.7l.1-.2.2-.2h.6l.2.2.1.3h-.2l-.1-.2-.3-.1h-.2l-.1.2v.1l-.1.2v.4l.2.2zm-1.7-1.6-.6 1.8h-.3l.7-2h.2zm.6 1.8-.7-1.8v-.2h.2l.7 2zm0-.8v.3h-1.2v-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.4 139.2H351v12.2h44.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e1e1e1",
    d: "M371.1 145v1.4h-.3v-1.7h.3zm.6-.3v.3h-.5v.2l-.1.2h-.1v-.3l.1-.2zm-2.8.9v-.4l.2-.3.6-.2h.3l.3.2.2.3v.7l-.2.3-.3.2h-.6l-.4-.5zm.3 0v.2l.1.2.4.2h.2l.2-.2v-.2l.1-.2v-.3l-.1-.2-.4-.2h-.2l-.2.2v.5m-.6-.9v.2h-1v-.2zm-.7-.4h.3v1.8l.1.1h.3v.2h-.5l-.1-.1v-2m-1 1.8v-1l-.1-.2h-.4l-.2.1v.2h-.3v-.2l.2-.2h.2l.3-.1h.3l.2.2.1.3v1.2h-.2v-.3m0-.7v.2h-.6l-.1.2v.3h.1l.2.1.4-.2v-.2l.2.2v.1l-.4.3h-.6l-.2-.2v-.5l.2-.2h.2l.3-.1zm-2.3-.1h-.6v-.2h.8l.1-.2v-.4l-.1-.1h-.7v2h-.3v-2.3h1l.3.2.1.1v.6l-.2.2h-.3zm0 1.1h-.7l.2-.2h.7l.2-.2v-.5l-.1-.1h-.7v-.3h.6l.3.2.3.5-.1.3-.3.3zm-2.5-.3v-1l-.2-.2h-.4l-.1.1v.2h-.4v-.2l.2-.2h.2l.3-.1h.3l.3.2v1.2l.1.3h-.3zm0-.7v.2h-.7v.2l-.1.1v.2h.1l.2.1.4-.2v-.2l.2.2v.1l-.4.3h-.5l-.2-.2-.1-.2v-.3l.2-.2h.2l.4-.1zm-2.6-.4v1.4h-.3v-1.7h.3zm0 .5h-.2v-.3l.2-.3.2-.2h.5l.2.1.1.2v1.4h-.2v-1.3l-.2-.1h-.6zm-1.9-.5v1.4h-.3v-1.7h.3zm0 .5h-.2l.2-.6.3-.2h.5l.1.1.2.2v1.4h-.3v-1.3l-.2-.1h-.5l-.1.3zm-1.1.6v-1l-.1-.2h-.4l-.2.1v.2h-.3v-.2l.2-.2h.2l.3-.1h.3l.2.2.1.3v1.2h-.2v-.3m0-.7v.2h-.6l-.1.2v.3h.1l.2.1.4-.2v-.2l.2.2v.1l-.2.2-.2.1h-.6l-.2-.2v-.5l.2-.2h.2l.3-.1zm-1.9-.3v.3h-1.3v-.3zm-1.2-1v2.3h-.3v-2.3zm1.5 0v2.3h-.3v-2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.7 139.2h-44.3v12.2h44.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e1e1e1",
    d: "M398 144.1h.4l.7 2 .8-2h.3l-1 2.4h-.2zm0 0h.2v2.4h-.2zm2 0h.3v2.4h-.3zm1.9 2v-1l-.2-.1h-.5v.2h-.4v-.2l.2-.1.2-.2h.6l.3.2v1.4l.1.1h-.3zm0-.7v.2h-.7v.2l-.1.1v.2h.1l.2.1.4-.2v-.1l.2.1v.2l-.2.1-.2.1h-.5q-.2 0-.2-.2l-.1-.2v-.3l.2-.1.2-.2zm1.2.9.5-1.6h.3l-.7 2v.2l-.1.1-.2.1h-.4v-.2h.3l.1-.1v-.2zm-.3-1.6.4 1.4v.3h-.1l-.7-1.7zm3.8 1.5v.3H405v-.3l.8-.8.2-.3.1-.2v-.4l-.1-.1h-.5l-.1.2-.1.2h-.3v-.4l.3-.2.5-.1h.3l.3.3v.5l-.2.4-.2.2-.6.7zm1.8-.4-.1.4-.3.2h-.7l-.3-.2v-.6l.4-.4h.6l.3.3zm-.3 0v-.2l-.2-.2h-.5l-.1.2v.5h.1l.3.1h.2l.1-.1zm.2-1v.2l-.3.3h-.7l-.2-.3-.1-.3v-.3l.3-.2.4-.1h.3l.3.3zm-.2 0-.1-.3-.1-.1h-.4l-.2.1v.4l.2.2h.4l.1-.2zm1 1.3v.5l-.3.3h-.1v-.2l.1-.4v-.2zm2.8.1v.3h-1.5v-.3l.7-.8.2-.3.1-.2v-.4l-.1-.1h-.5l-.1.2v.2h-.4l.1-.4.3-.2.4-.1h.4l.2.3v.7l-.4.4-.6.7zm1.8-1v.7l-.2.4-.2.1h-.8l-.1-.2-.1-.3v-1.3l.1-.3.3-.2h.5l.4.3v.3zm-.3.3v-.9l-.2-.2h-.4l-.2.1v1.6l.2.1h.4l.1-.1v-.3zm2.3.7v.3H414v-.3l.8-.8.2-.3.1-.2v-.4l-.1-.1h-.5l-.2.2v.2h-.3v-.4l.3-.2.4-.1h.4l.3.3v.7l-.4.4-.6.7zm1.9-.5v.2h-1.7v-.2l1-1.6h.3l-.3.5-.7 1zm-.3-1.6v2.4h-.3V144z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "au",
    width: 380,
    height: 12,
    x: 60,
    y: 139,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _use24 || (_use24 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#as"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#au)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#616467",
    d: "M439.7 151v-.3H60v.4z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "aw",
    width: 380,
    height: 13,
    x: 60,
    y: 150,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _use25 || (_use25 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#av"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#aw)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M129.4 150.4H60v12.2h69.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4285f4",
    d: "M63.6 155.4v2.3h-.4v-1.8l-.6.1v-.3zm2.4 2v.3h-1.6v-.3l.8-.8.2-.2v-.6l-.2-.1H65l-.2.2v.2h-.4v-.4l.4-.3h.8l.2.2.1.4v.2l-.1.2-.2.2-.2.3-.4.5zm.8-.8h-.4l.2-1.2h1.2v.3H67v.6-.1h.6l.4.4v.7l-.2.2-.2.2h-.7l-.2-.1-.2-.5h.4v.1l.2.2h.3l.1-.1v-.7h-.1l-.2-.1zm2.7 1.1v.3h-1.4v-.3zm.9-.4.5-2h.2v.5l-.5 1.9h-.2zm-.3-2 .4 2v.4h-.3l-.5-2.3zm1.5 2 .4-2h.4l-.5 2.4h-.3zm-.4-2 .5 2v.4h-.2l-.5-2v-.3zm3 1v.4h-1.1v-.4zm-1-1v2.4h-.5v-2.3zm1.4 0v2.4h-.4v-2.3zm2.4 1.2v.6l-.3.3-.3.3h-.8l-.3-.3-.2-.3V156l.2-.4.3-.2h.8l.3.2.2.4zm-.5 0v-.4l-.1-.2-.2-.2h-.4l-.2.2v.2l-.1.4v.4l.1.3.4.2h.2l.2-.2.1-.3zm2.8 0v.6l-.3.3-.3.3H78l-.3-.3-.2-.3V156l.2-.4.3-.2h.8l.3.2.2.4zm-.5 0v-.4l-.1-.2-.2-.2h-.4l-.2.2v.2l-.1.4v.4l.1.3.2.1h.4l.2-.1.1-.3zm1.8.3H80v-.3h.8l.2-.2v-.4l-.2-.1h-.7v1.9h-.4v-2.3h1.4l.3.3v.8l-.3.3zm2.5.9v.3h-1.5v-.3zm.5-2.3.5 1 .6-1h.4l-.7 1.4v.9h-.5v-.9l-.8-1.4zm1.6 1.5v-.4l.2-.3.3-.2h.7l.2.2.2.3v.7l-.2.3-.2.2h-.7l-.3-.2-.1-.3zm.4 0v.2l.1.1.1.2h.4l.1-.2v-.1l.1-.2v-.5l-.4-.1-.3.1v.4m2.6.4V156h.4v1.7h-.4zm0-.4h.2v.3l-.2.3-.2.2h-.5l-.2-.1-.1-.2V156h.4v1.3h.5l.1-.1zm1.3-.6v1.4H89V156h.4zm.5-.3v.3h-.3l-.2.1v.3h-.2v-.3l.2-.2.1-.2zm1.3-.6v2.3H91v-2.3zm.7 0v.3h-1.9v-.3zm.8.6v1.7h-.5V156zm-.5-.5v-.1l.3-.1h.1l.1.2v.2h-.4zm1.3.8v1.4h-.4V156h.4zm0 .5h-.2v-.4l.2-.2.5-.3h.2l.2.2.1.2v1.4h-.4v-1.4h-.4l-.1.1-.1.2zm1-.1h-.1v-.3l.1-.2.2-.2h.7l.1.3v1.4h-.3v-1.3l-.2-.1h-.3l-.1.2zm2.3 1h-.4l-.4-.5v-.7l.2-.3.2-.2h.7l.2.2.1.2v.6h-1.3v-.3h1v-.2l-.2-.2h-.3l-.1.1-.1.2v.7h.2l.2.1h.3l.1-.2.3.2-.2.2h-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.7 150.4h-44.3v12.2h44.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e1e1e1",
    d: "M142.7 156.8h-.6v-.3h.9l.1-.2v-.4l-.1-.2h-.9v2h-.3v-2.3h1.3l.3.3.1.4v.4l-.4.2zm-1.4-.3v.6l-.2.3-.3.3h-.8l-.3-.3-.2-.3V156l.2-.4.7-.3.4.1.3.2.2.4zm-.3.1v-.5l-.2-.3-.2-.2h-.5l-.2.2-.1.3v.9l.1.2.2.2h.6l.2-.2v-.2zm-2-.1v.6l-.2.3-.3.3h-.8l-.3-.3-.2-.3V156l.2-.4.3-.2h.8l.3.2.2.4zm-.3.1v-.5l-.1-.3-.2-.2h-.6l-.2.2-.1.3v.9l.1.2.2.2h.6l.2-.2v-.2zm-2.3-.2v.2H135v-.2zm-1.2-1v2.3h-.4v-2.3zm1.4 0v2.3h-.3v-2.3zm-4.1 1.6.5-1.6h.2l-.1.6-.5 1.7h-.3zm-.5-1.6.4 1.6.1.7h-.2l-.6-2.3zm1.8 1.6.4-1.6h.3l-.6 2.3h-.2zm-.6-1.6.5 1.6.1.7h-.2l-.5-1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218 150.4h-44.3v12.2H218z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e1e1e1",
    d: "M190.3 157.7h-.3l-.4-.5v-.8l.2-.2.8-.2.2.2.2.2v.5h-1.3v-.2h1v-.3l-.2-.2h-.2l-.3.1-.1.2v.8l.2.1h.5l.2-.2.2.2-.2.2h-.2zm-3.3-1.4v1.4h-.3V156h.3zm0 .5h-.2v-.4l.2-.2.2-.2h.7l.1.3v1.4h-.2v-1.4h-.2l-.2-.1h-.2l-.2.2zm1-.2v-.2l.1-.2.2-.2h.6l.3.3v1.3h-.3v-1.3h-.6zm-1.8-.6v1.7h-.3V156zm-.3-.5h.3v.2zm-1.1-.1v2.3h-.3v-2.3zm.7 0v.2h-1.8v-.2zm-3.3.8v1.5h-.3V156h.3zm.6-.2v.2h-.4l-.2.3v.1l-.1.1v-.3l.1-.2.2-.2zm-1.7 1.3V156h.3v1.7h-.3zm0-.4h.2v.3l-.1.3-.3.2h-.5l-.3-.3V156h.3v1.4h.6l.1-.2zm-3.1-.1.1-.3.2-.3.2-.2h.7l.2.2.2.3v.7q0 .2-.2.3l-.5.2h-.4l-.2-.2-.2-.3zm.4 0v.5l.3.1h.4l.1-.1.1-.2v-.7l-.4-.2h-.3l-.1.2-.1.2zm-2-1.4.6 1.1.6-1.1h.4l-.8 1.4v.9h-.3v-.9l-.9-1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.4 150.4H218v12.2h44.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e1e1e1",
    d: "M224.4 156.6h-.2l.1-1.2h1.2v.2h-1v.7l.2-.1h.5l.2.2.1.2v.9q-.2 0-.3.2h-.6l-.2-.1-.2-.2v-.3h.2v.2l.2.1h.6v-.8l-.2-.1h-.6m-.7 1v.2h-1.5v-.2l.8-.9.2-.2v-.8h-.6l-.1.2v.2h-.4l.1-.3.3-.3h.8l.2.2.1.4v.2l-.1.2-.2.2-.1.2-.7.7zm-2.4-2.1v2.3h-.3v-2l-.6.2v-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.7 150.4h-44.3v12.2h44.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3a2753",
    d: "M274.4 153.7h-6.9a2.8 2.8 0 1 0 0 5.6h6.9a2.8 2.8 0 1 0 0-5.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c2a6e2",
    d: "M273.4 156.9v-.4l.2-.2.2-.2h.6q.2 0 .3.2l.1.2v.7l-.1.3-.6.2h-.3l-.2-.2-.2-.3zm.3 0v.4l.2.1h.4l.2-.1v-.9l-.2-.1h-.2l-.3.1-.1.2zm-.6-.9v.3h-.8v-.3zm-.5-.3h.2v1.6l.1.1h.2v.3h-.4v-.2l-.1-.2zm-2 1.2v-.4l.2-.2.2-.2h.6l.3.2.1.2v.7l-.1.3-.6.2h-.3l-.2-.2-.1-.3zm.3 0v.2l.1.2.1.1h.4l.2-.1v-.2l.1-.2v-.3l-.1-.2-.2-.1h-.4l-.1.1v.2zm-1.7-1.5v2.3h-.2v-2.3zm0 1.4h-.1v-.3l.1-.3.5-.2h.2l.2.2.1.1v1.3h-.2v-1.2l-.2-.1h-.3l-.2.1v.2zm-1.3 0h-.6v-.2h.8l.2-.2v-.5l-.2-.1h-.8v1.9h-.2v-2.2h1.2l.3.7v.3l-.3.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351 150.4h-44.3v12.2H351z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#29562b",
    d: "M318.7 153.7h-6.8a2.8 2.8 0 1 0 0 5.6h6.8a2.8 2.8 0 1 0 0-5.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#66e56c",
    d: "m318.6 157.6-.3-.1-.2-.1-.1-.3v-.6l.1-.3.2-.1h.5l.2.1.1.3v.4h-1v-.2h.8v-.3l-.1-.1h-.5l-.1.2v.7l.2.1h.4q.2 0 .2-.2l.2.2-.2.1-.1.1zm-1.6-.3.5-1.3h.2l-.5 1.5h-.2zm-.3-1.3.4 1.3v.2h-.1l-.5-1.5zm-.5 0v1.5h-.3V156zm-.3-.3v-.2h.2v.2zm-.4.3v.2h-.8v-.2zm-.5-.3h.3v1.6h.2v.2h-.3l-.1-.1zm-1.1 1.6h.3v-.2h.3v.2l-.6.3-.3-.1-.2-.2-.1-.2v-.6l.1-.3.2-.1h.6l.2.2.1.3h-.2l-.1-.2-.1-.1h-.5v.3l-.1.2v.4l.2.1zm-1.7-1.6-.6 1.8h-.3l.7-2h.2zm.6 1.8-.7-1.8v-.2h.2l.7 2zm0-.7v.2h-1.2v-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.4 150.4H351v12.2h44.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e1e1e1",
    d: "M373.8 157v-.2h-.1l-.3-.1-.2-.1-.2-.1-.1-.1v-.4l.3-.3h.6l.2.2.1.3h-.3v-.1l-.2-.2h-.3l-.2.1v.3h.2l.2.1.4.1.2.2v.5l-.2.1-.2.1h-.6l-.3-.2v-.3h.3v.2h.6zm-2.6-1v2h-.3v-2.3h.3zm1.2.5v.4l-.2.3-.2.2h-.6l-.2-.2-.1-.2v-.9l.1-.2.2-.2h.6l.2.2.2.3zm-.3 0v-.2l-.1-.2-.1-.1h-.5l-.2.2v.8l.2.2h.5l.1-.2v-.2zm-1.7-.8v1.7h-.3v-1.7zm-.3-.5.2-.1h.1v.3h-.3zm-.5-.2v2.4h-.3V155zm-.8.7v1.7h-.3v-1.7zm-.4-.5.2-.1h.1v.3h-.2zm-1.5-.2v2.4h-.3V155zm0 1.5h-.2v-.3l.2-.3.5-.2h.2l.2.1.1.2v1.4h-.3v-1.3l-.1-.2h-.2l-.4.2zm-1.5 0h-.6v-.2h.6l.3-.1.1-.2v-.4l-.1-.2h-.9v2h-.3v-2.3h1.3l.3.3.1.4-.1.4-.3.2zm-2.5.5v-.2h-.1l-.3-.1-.3-.1-.2-.1v-.1l-.1-.2v-.2l.1-.2.2-.1h.7l.2.2v.3h-.2v-.1l-.2-.2h-.4l-.1.1v.3h.2l.2.1.3.1.2.2v.5l-.1.1-.2.1h-.7l-.2-.2v-.3h.2v.2h.7zm-2.1.5-.3-.1-.4-.4v-.8l.2-.3.8-.2.2.2.2.3v.4h-1.3v-.2h1v-.2l-.2-.2h-.5l-.1.3v.7l.2.2h.5l.2-.2.2.1-.2.2-.2.1zm-3.3-1.5v1.4h-.3v-1.7h.3zm0 .5h-.2v-.3l.2-.3.2-.2h.5l.2.1.1.2v1.4h-.2v-1.1l-.1-.2-.1-.2h-.4l-.2.2zm1-.2h-.2l.2-.4.2-.2h.6l.2.1v.2l.1.3v1.1h-.3v-1.3l-.2-.2h-.3zm-2.1.8v-1l-.2-.2h-.4l-.1.1v.2h-.4v-.2l.2-.2h.3l.2-.1h.4l.2.2v1.1l.1.2v.2h-.3zm0-.7v.2h-.7v.5l.2.1h.3l.1-.2.1-.2.1.2v.1l-.4.3h-.5l-.2-.2v-.5l.1-.2h.3l.3-.1zm-1.9.3v-1.6h.3v2l-.3.3h-.8l-.2-.2-.1-.4h.3v.2l.2.2h.4l.2-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.7 150.4h-44.3v12.2h44.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e1e1e1",
    d: "M417.3 156.6v.2h-1.7v-.2l1-1.6h.3l-.2.5-.7 1zm-.3-1.6v2.4h-.3V155zm-1.6 2.1v.3h-1.5v-.3l.7-.8.2-.3.2-.2v-.4l-.2-.1h-.5l-.1.2v.2h-.4l.1-.3q0-.2.3-.3l.4-.1h.4l.2.3v.7l-.2.2-.2.2-.6.7zm-2-1.1v.8l-.2.4-.2.1h-.5l-.4-.2-.1-.3v-1.3l.2-.3.2-.2h.6l.2.1.1.2.1.3zm-.3.4v-.9l-.1-.2h-.5l-.1.1-.1.2v1.3l.1.1.1.1h.4l.1-.1.1-.2zm-1.5.7v.3h-1.5v-.3l.8-.8.2-.3v-.2l.1-.1v-.3l-.2-.1h-.5l-.1.2v.2h-.4l.1-.3q0-.2.3-.3l.4-.1h.4l.2.3.1.3v.2l-.1.2-.2.2-.1.2-.7.7zm-2.8-.1v.6l-.2.2h-.2l.2-.5v-.3zm-.6-.4v.2h-1.6v-.2l1-1.6h.2l-.2.5-.7 1zm-.3-1.6v2.4h-.3V155zm-1.6 2.1v.3h-1.5v-.3l.7-.8.3-.3v-.7h-.6l-.1.2v.2h-.4l.1-.3q0-.2.3-.3l.4-.1h.4l.2.3.1.3v.2l-.1.2-.3.4-.7.7zm-3.5.1.5-1.6h.3l-.6 2-.2.3-.4.2h-.1v-.3h.2l.1-.1.1-.2zm-.3-1.6.4 1.4.1.3h-.2l-.6-1.7zm-.9 1.4v-1l-.2-.1h-.5v.2h-.4v-.2l.2-.1.3-.2h.6l.2.3v1.3l.1.1h-.3zm0-.7v.2h-.5l-.2.1v.5h.5l.1-.2.1-.1.1.1v.2l-.2.1-.2.1h-.5q-.2 0-.2-.2v-.5l.1-.1.3-.2zm-3.8-1.3h.3l.8 2 .7-2h.3l-1 2.4h-.2zm-.1 0h.3v2.4h-.3zm2 0h.3v2.4h-.3z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "ax",
    width: 380,
    height: 13,
    x: 60,
    y: 150,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _use26 || (_use26 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#av"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#ax)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#616467",
    d: "M439.7 162.2v-.3H60v.5h379.7z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "az",
    width: 380,
    height: 12,
    x: 60,
    y: 162,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _use27 || (_use27 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ay"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#az)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M129.4 161.7H60v12.2h69.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4285f4",
    d: "m97.2 168.2.4-1.3h.2v.5l-.4 1.3H97zM97 167l.2 1.3v.5H97l-.4-1.8zm1.2 1.3.3-1.3h.4l-.5 1.8h-.3zm-.3-1.3.3 1.3v.5h-.1l-.4-1.3-.1-.5zm-2.2 1.7h-.4l-.4-.5v-.8l.1-.3.3-.1.3-.1h.3l.3.2.1.3v.5H95v-.3h1v-.2l-.2-.1h-.4l-.1.3v.6l.4.2.2-.1q.2 0 .2-.2l.2.3-.1.1-.2.1zm-1.6-1.4v1.4h-.4v-1.8h.4zm.5-.4v.4h-.4v.2l-.1.2H94v-.3l.1-.3.2-.2zm-1.6 1h.3v.4l-.4.3H92l-.3-.2-.2-.4v-1l.2-.3.3-.2.4-.1.5.1.3.3.1.4H93v-.2l-.2-.2h-.5l-.2.1v1.3l.2.2h.5l.1-.2zm-2.7.6.5-1.6h.5l-.7 2v.2l-.2.1-.2.1h-.4v-.3h.3l.1-.2zm-.2-1.6.4 1.3v.4l-.2.1-.6-1.8zm-1.6-.7v2.5H88v-2.5zm1 .7-.7.9-.4.4-.1-.3.3-.4.5-.6zm-.4 1.8-.5-.9.3-.2.7 1zm-1.8-.7-.1-.2H87l-.2-.1-.3-.2-.3-.1-.1-.2v-.3l.2-.4.2-.2h.8l.3.3.1.4h-.4v-.2l-.2-.1h-.6v.4l.2.1.2.1.4.1.2.2.2.4v.3l-.2.2-.3.1a1 1 0 0 1-1-.1l-.2-.2v-.4h.4v.2l.1.2h.6l.1-.1zm-2.3.7h-.4l-.2-.3-.2-.2v-.8l.2-.3.2-.1.3-.1h.4l.2.2.2.3v.5h-1.4v-.3h1v-.2l-.2-.1h-.4l-.1.3v.6l.4.2.3-.1.2-.2.2.3-.2.1-.2.1zm-1.6-.5V167h.4v1.8h-.4zm0-.3h.2v.3l-.2.3-.2.1h-.7l-.1-.3V167h.4v1.2l.1.1h.4v-.2zm-1.5-1.7v2.5h-.4v-2.5zm-1.6 1.4h-.6v-.3h.7l.1-.1v-.4l-.1-.1h-.6v2h-.4v-2.4h1.1l.3.2.1.2v.5q0 .2-.2.2zm0 1h-.8l.2-.3h.8v-.2l.1-.1v-.2l-.1-.1h-.7v-.4h.6v.1l.4.1.2.2v.6l-.3.3zm-1.2.1v.3h-1.5v-.3zm-2.6-2.4v2.4H76v-2.4zm.9 1v.4h-1v-.4zm.1-1v.4h-1.2v-.4zm-2.8.4-.7 2h-.4l.8-2.4h.3zm.6 2-.7-2v-.4h.3l.8 2.4zm0-1v.4H74v-.3zm-2.3.3-.1-.2h-.2l-.2-.1-.3-.2-.3-.1-.1-.2-.1-.3.2-.4.3-.2h.8l.3.3.1.4H73v-.2l-.2-.1h-.6v.4l.2.1.2.1.4.1.2.2.2.4v.3l-.2.2-.3.1a1 1 0 0 1-1-.1l-.2-.2v-.4h.4v.2l.1.2h.6l.1-.1zm-2.2-1.7h.5v1.6l-.1.4-.3.3h-1l-.3-.3v-2h.4v1.8l.2.2h.4q.2 0 .2-.2zm-1.5 2.4v.3h-1.5v-.3zm-2.1-2.4v.3l-.4.1-.4.4v1l.1.1.1.1h.4l.1-.2v-.5l-.2-.1h-.3l-.2.3h-.2v-.3l.2-.2.2-.2h.6l.2.2.1.3v.6l-.2.3-.2.1h-.7l-.2-.2-.2-.3v-1l.3-.4.3-.3zm-1.5 2v.4h-1.5v-.3l.7-.8.2-.3.1-.2v-.3l-.1-.1h-.4l-.1.1v.2H64l.1-.3.3-.3.4-.1h.4l.3.3v.8l-.2.2-.2.2-.5.5zm-2.4-2v2.4H63v-1.9l-.6.2v-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.7 161.7h-44.3v12.2h44.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e1e1e1",
    d: "M138.4 166.6v2.3h-.3v-2.3zm1 1v.3h-1v-.2zm.1-1v.3h-1.2v-.3zm-2.7.2-.8 2.1h-.3l.9-2.3h.2zm.6 2.1-.7-2v-.3h.2l.8 2.3zm0-.8v.2H136v-.2zm-2.2.3v-.2l-.1-.1-.2-.1-.3-.1-.3-.1-.2-.2-.2-.1v-.3l.2-.4.2-.2h.8l.3.3v.4h-.2v-.3l-.3-.1h-.5l-.2.1v.3l.1.2h.2l.2.1.4.2.2.1.1.2v.5l-.1.2-.3.1h-.6l-.3-.1-.2-.2-.1-.3h.3v.2l.2.1h.8zm-2.1-1.8h.3v1.6l-.1.4-.3.3h-.9l-.3-.3v-2h.2v1.9l.3.2h.5l.2-.2.1-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218 161.7h-44.3v12.2H218z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e1e1e1",
    d: "m195 168.3.5-1.4h.2v.3l-.5 1.5h-.2zm-.2-1.4.3 1.5v.3h-.1l-.5-1.8zm1.3 1.5.4-1.5h.3l-.5 1.8h-.2zm-.4-1.5.5 1.4v.4h-.2l-.4-1.5zm-2.1 1.8h-.4l-.4-.5v-.8l.2-.3.5-.2h.3l.3.2.1.3v.5H193v-.3h1v-.2l-.1-.2h-.3l-.3.1-.1.2v.6l.1.2.2.1h.4l.2-.2.2.2-.1.1-.2.1zm-1.6-1.5v1.5h-.3v-1.8h.3zm.6-.3v.3h-.4v.1l-.2.1v.2h-.1v-.2l.1-.3.2-.2zM191 168h.3l-.1.3-.3.3h-.8l-.3-.2-.2-.3v-1.2l.2-.3q0-.2.3-.2l.4-.1h.4l.3.4.1.4h-.3v-.3l-.3-.2h-.5l-.2.2-.1.2v1.2l.3.2h.5l.2-.2zm-3.4.5.5-1.6h.3l-.7 2-.2.3-.1.1h-.3v-.2h.2v-.1l.2-.2zm-.4-1.6.5 1.4v.3h-.2l-.6-1.7zm-1.5-.7v2.5h-.3v-2.5zm1 .7-.7.8-.4.5v-.3l.3-.4.5-.6zm-.2 1.8-.6-.9.1-.2.8 1zm-1.8-.7-.1-.2h-.2q0-.2-.3-.2l-.3-.1-.2-.1-.2-.2v-.3l.2-.4.3-.2h.7l.3.4.1.3h-.3v-.2l-.2-.2h-.6l-.2.1v.4h.1l.2.2h.2l.4.2.2.1.2.2v.5l-.2.2-.3.1h-.9l-.2-.3v-.3h.2v.2l.2.1.2.1h.5l.1-.1zm-3.2.7h-.3l-.4-.5-.1-.4v-.4l.2-.3.6-.2h.3l.2.2.1.3v.5H181v-.3h1v-.2l-.2-.2h-.2l-.4.1v.2l-.1.3v.3l.1.2.2.1h.5l.2-.2.1.2v.1l-.3.1zm-1.5-.4v-1.4h.3v1.8h-.3zm0-.4h.2v.3l-.2.3-.2.1h-.5l-.3-.3V167h.2v1.2l.1.2h.5l.2-.2zm-1.6-1.7v2.5h-.3v-2.5zm-1.5 1.4h-.6v-.3h.8l.1-.2v-.4h-.1l-.3-.1h-.4v2h-.4v-2.3h1.1l.3.2.1.2v.5l-.2.2h-.3zm0 1h-.7l.1-.2h.8l.2-.2v-.4l-.2-.2h-.7v-.3h.6l.1.1.3.1.2.2v.7l-.3.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.4 161.7H218v12.2h44.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e1e1e1",
    d: "M225.2 166.6v.3h-.4l-.2.2-.2.3v1l.1.2h.2l.1.1h.2l.2-.1v-.8l-.2-.1h-.4l-.2.2v.2h-.2v-.3l.2-.2.3-.2h.5l.2.3.1.2v.6l-.1.2-.2.2h-.7l-.2-.2-.2-.3v-.9l.2-.5.4-.3zm-1.5 2.1v.2h-1.5v-.2l.8-.8.2-.3v-.7h-.6l-.1.1v.3h-.4l.1-.4.3-.2.4-.1h.4l.2.3.1.3v.2l-.1.2-.2.2-.1.2-.7.7zm-2.4-2.1v2.3h-.3v-2l-.6.3v-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.7 161.7h-44.3v12.2h44.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#28333d",
    d: "M281.3 165h-13.8a2.8 2.8 0 1 0 0 5.6h13.8a2.8 2.8 0 1 0 0-5.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a8c3cf",
    d: "M280.8 167.6v1.3h-.3v-1.6h.2zm-.1.4h-.1v-.3l.2-.2.4-.2h.2l.2.1.1.2v1.3h-.2v-1.3h-.2l-.1-.1h-.2l-.2.2v.1zm-2.1.1v-.3l.2-.3.3-.2h.6l.2.2.2.3v.6l-.2.3-.2.2h-.6l-.3-.2-.1-.3zm.3 0v.2l.1.2.2.2h.4l.1-.2.1-.2v-.6l-.2-.2h-.2l-.4.2v.4m-.8-.8v1.6h-.2v-1.6zm-.3-.4h.3v.2h-.2zm-.3.4v.2h-.9v-.2zm-.6-.4h.3v1.7h.2v.3h-.3l-.2-.1zm-1 1.8.2-.1v-.2h.3v.3l-.6.2h-.3l-.2-.2-.2-.3v-.6l.2-.3.2-.2h.6l.3.5h-.2v-.1l-.2-.2h-.4l-.1.2-.1.2v.6l.2.2zm-1.5-.2v-1.2h.3v1.6h-.3zm0-.3h.2v.3l-.1.2-.2.2h-.5l-.2-.1-.1-.2v-1.3h.2v1.2l.1.1h.1l.1.1h.3l.1-.3zm-1.7.4v-2h.3v2.3h-.3zm-1-.5v-.6q.2 0 .3-.2h.5l.2.2.1.2.1.3v.5l-.2.2-.2.2h-.5l-.2-.2-.1-.3zm.2 0v.2l.1.2.1.2h.4l.2-.2v-.9l-.4-.1-.3.2v.2zm-2 0v-.3l.1-.3.3-.2h.6l.2.2.2.3v.6l-.2.3-.2.2h-.6l-.3-.2-.1-.3zm.2 0v.2l.1.2.2.2h.2l.3-.2.1-.2v-.6l-.2-.2h-.4l-.2.2v.4m-1.1-.6v1.4h-.2v-1.6h.2zm.5-.2v.2h-.3l-.2.3v.1-.4l.2-.2zm-1.8.7h-.6v-.2h.8l.2-.2v-.4l-.2-.2h-.8v1.9h-.2v-2.2h.8l.4.1.2.3.1.3v.4l-.3.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351 161.7h-44.3v12.2H351z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#29562b",
    d: "M318.7 165h-6.8a2.8 2.8 0 1 0 0 5.6h6.8a2.8 2.8 0 1 0 0-5.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#66e56c",
    d: "M318.6 168.8h-.3l-.2-.2-.1-.2v-.7l.1-.2.5-.2h.2l.2.2.1.2v.4h-1v-.2h.8v-.2l-.1-.2h-.4l-.1.1-.1.2v.6l.2.2h.4l.2-.2.2.1-.2.2h-.1zm-1.6-.3.5-1.2h.2l-.5 1.5h-.2zm-.3-1.2.4 1.3v.2h-.1l-.5-1.5zm-.5 0v1.5h-.3v-1.5zm-.3-.4h.2v.2zm-.4.4v.2h-.8v-.2zm-.5-.4h.3v1.6h.2v.3h-.3l-.1-.2zm-1.1 1.6h.2l.1-.1v-.2h.3v.3l-.3.1-.3.1h-.3l-.2-.2-.1-.3v-.6l.1-.2.2-.2h.6l.2.2.1.3h-.2l-.1-.2h-.1l-.2-.1h-.2l-.1.1v.2l-.1.2v.4l.2.1zm-1.7-1.6-.6 1.8h-.3l.7-2h.2zm.6 1.8-.7-1.8v-.2h.2l.7 2zm0-.8v.3h-1.2v-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.4 161.7H351v12.2h44.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e1e1e1",
    d: "M372.8 167.3v1.4h-.3v-1.8h.2zm-.1.4h-.1l.2-.6.2-.1.3-.1h.2l.2.1v.2l.1.3v1.2h-.3v-1.4l-.1-.1h-.2l-.4.1v.2zm-.7-.7v1.7h-.4v-1.8zm-.4-.5v-.2h.3v.2l-.1.1zm-1.6.8v1.4h-.2v-1.8h.2zm0 .4h-.1v-.3l.2-.3.5-.2h.2l.3.3v1.5h-.3v-1.4l-.1-.1h-.2l-.4.1zm-2.2.1v-.4l.2-.3.2-.1.4-.1h.3l.2.2.2.3v.8l-.2.2-.2.2h-.7l-.4-.4zm.3 0v.5l.5.1h.2l.1-.1.1-.2v-.8l-.2-.1h-.5l-.1.1-.1.2zm-1.8.9h-.5v-.3h.5l.5-.1.2-.3v-.9l-.1-.3-.2-.2h-.9v-.3h.6l.4.1.3.2.2.4v1l-.5.6zm-.3-2.4v2.4h-.3v-2.4zm-2.3 2.2.5-1.6h.3l-.7 2-.2.3-.4.1v-.2h.2v-.1l.2-.2zm-.4-1.6.5 1.4v.3h-.1l-.7-1.7zm-1.1 1.8h-.4l-.4-.5v-.8l.2-.3.5-.2h.4l.2.2.1.3v.5h-1.2v-.3h1l-.1-.2-.1-.2h-.3l-.3.1-.1.2v.6l.1.2.2.1h.5l.1-.2.2.2-.1.1-.2.1zm-1.5-.5-.1-.1-.3-.1h-.2l-.2-.2-.2-.1v-.2l.2-.4h.2l.2-.1h.4l.2.3.1.2h-.3v-.1l-.2-.1h-.4v.3l.1.1h.2l.4.2.2.1v.5l-.2.1-.2.1h-.6l-.3-.2v-.3h.2l.1.2.2.1h.4zm-1.7.1v-2.1h.2v2.5h-.3zm-1.2-.5v-.4l.1-.3.3-.1.2-.1h.3l.2.2.2.3v.8l-.2.3-.2.1h-.5l-.3-.2-.1-.2zm.3 0v.5h.2l.2.1h.3l.1-.2v-.9l-.2-.1h-.4l-.1.1-.1.2zm-1.8-.5v1.4h-.3v-1.8h.3zm-.1.4h-.1v-.3l.2-.3.5-.2h.2l.2.1.1.2v1.5h-.3v-1.4l-.1-.1h-.2l-.4.1zm-.7-.7v1.7h-.3v-1.8zm-.4-.5v-.2h.3v.3zm-.3 1.9v.3h-1.2v-.3zm-1.1-2v2.3h-.3v-2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.7 161.7h-44.3v12.2h44.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e1e1e1",
    d: "M417.3 167.8v.3h-1.7v-.2l1-1.6h.3l-.2.4-.7 1.1zm-.3-1.5v2.3h-.3v-2.3zm-1.6 2.1v.2h-1.5v-.2l.7-.9.2-.2.2-.2v-.4l-.2-.2h-.5l-.1.2v.3h-.4l.1-.4.3-.3h.8l.2.2v.8l-.2.2-.2.2-.6.7zm-2-1.1v.8l-.2.3-.2.2h-.5l-.4-.3-.1-.3v-1.2q0-.3.2-.3l.2-.2h.8l.1.3.1.3zm-.3.4v-1l-.1-.1h-.6l-.1.3v1.2l.1.2h.6l.1-.3zm-1.5.7v.2h-1.5v-.2l.8-.9.2-.2v-.2l.1-.2v-.2l-.2-.2h-.5l-.1.2v.3h-.4l.1-.4.3-.3h.8l.2.2.1.4v.2l-.1.2-.2.2-.1.2-.7.7zm-2.8-.1v.5l-.2.3-.2-.1.2-.5v-.2zm-.6-.5v.3h-1.6v-.2l1-1.6h.2l-.2.4-.7 1.1zm-.3-1.5v2.3h-.3v-2.3zm-1.6 2.1v.2h-1.5v-.2l.7-.9.3-.2v-.8h-.6l-.1.2v.3h-.4l.1-.4.3-.3h.8l.2.2.1.4v.2l-.1.2-.3.4-.7.7zm-3.5 0 .5-1.5h.3l-.6 2-.2.3h-.2l-.3.1v-.3h.3l.1-.2zm-.3-1.5.4 1.3.1.3-.2.1-.6-1.7zm-.9 1.4v-1.1h-.2l-.2-.1h-.2l-.1.1v.2h-.4v-.2l.2-.2.3-.1h.6l.2.2v1.3l.1.2h-.3zm0-.7v.2h-.7v.5h.5l.1-.1.1-.2.1.2v.1l-.2.2h-.7l-.2-.1v-.5l.1-.2.3-.1zm-3.8-1.3h.3l.8 1.9.7-2h.3l-1 2.4h-.2zm-.1 0h.3v2.4h-.3zm2 0h.3v2.3h-.3z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "aA",
    width: 380,
    height: 12,
    x: 60,
    y: 162,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _use28 || (_use28 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ay"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#aA)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#616467",
    d: "M439.7 173.4v-.2H60v.4h379.7z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "aC",
    width: 380,
    height: 12,
    x: 60,
    y: 173,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _use29 || (_use29 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aB"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#aC)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M129.4 173H60v12h69.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4285f4",
    d: "M106.4 178.4v.3h-1v-.3zm-.8-.5h.5v1.8h.2v.4h-.4l-.2-.2v-2m-1.5.5.3.5.3-.5h.5l-.5.8.5.9h-.5l-.3-.6-.3.6h-.5l.5-.9-.5-.8zm-1.4 1.7h-.3l-.5-.5v-.8l.2-.2.3-.2h.6q.2 0 .2.2l.2.2v.5h-1.3v-.2h1l-.1-.3h-.1l-.2-.1-.3.1v.8l.2.1h.4l.2-.1.2.2-.2.2h-.2zm-1.2-2.3v2.3h-.4l-1-1.6v1.6h-.5v-2.3h.5l1 1.6v-1.6zm-2.2.6v.3h-1v-.3zm-.8-.5h.5v1.8h.3v.4h-.5l-.2-.2zm-2.1 1.3v-.3q0-.2.2-.3l.2-.2h.7q.2 0 .3.2l.1.3.1.3v.4l-.2.3-.3.2H97l-.2-.2-.2-.3zm.4 0v.4l.2.1h.4l.2-.3v-.4l-.1-.2-.3-.1-.3.1v.2zm-.8-.3v.9l-.1.1-.3.2h-.9l-.3-.3-.2-.3v-1.1l.2-.4.3-.2h.9l.3.3.1.4h-.4v-.2l-.2-.2H95l-.2.2v.2l-.1.3v.5l.1.3.2.1h.6v-.5h-.4v-.3zm-2.9 1.2H93l-.4-.5-.1-.3v-.5l.2-.2.3-.2h.6l.3.2.1.2v.5h-1.3v-.2h1l-.1-.3h-.1l-.2-.1-.3.1v.8l.2.1h.4l.2-.1.2.2-.1.2h-.3zm-3-.5.5-1.8h.2v.4l-.5 1.9h-.2zm-.3-1.8.4 1.8v.5H90l-.5-2.3zm1.5 1.8.4-1.8h.4l-.5 2.3h-.3zm-.4-1.8.5 1.8v.5h-.2l-.5-2v-.3zm-1.6 2.2v.4H88v-.3zm-2.3.1h-.4a1 1 0 0 1-.5-.8v-.5l.2-.2.3-.2h.6l.3.2.1.2v.5h-1.3v-.2h1v-.3h-.2l-.2-.1-.3.1v.8l.2.1h.4l.2-.1.2.2-.1.2h-.2zm-1.9-.3h.2l.1-.2v-.1h.5l-.1.3-.3.2-.3.1H85l-.2-.2-.2-.3v-.7q0-.2.2-.3l.2-.2h.7l.3.2v.4h-.3v-.2l-.2-.1h-.3l-.1.1-.1.2v.6zm-2.1-1.1v1.4h-.4v-1.7h.3zm0 .5v-.4l.2-.3.5-.2h.2l.2.2v.2l.1.3v1h-.4v-1.2l-.1-.1h-.2l-.3.1zm-1.2.5v-.8l-.1-.1-.1-.1h-.3l-.1.2h-.5v-.2l.2-.2.3-.1h.6l.2.2.1.3v1l.1.2H82zm0-.7v.3h-.5l-.2.1v.3h.5l.1-.2.2.2-.1.1-.1.2-.4.1h-.3l-.2-.2-.1-.3v-.2l.2-.2.2-.1zm-1.5-1.5v2.5H80v-2.5zm-1.3 2.1v-.9l-.1-.1h-.3l-.1.2h-.5v-.2l.2-.2.3-.1h.6l.3.2v1.3l.1.2h-.4zm0-.7v.3h-.4l-.2.1v.3h.5l.1-.2.2.2-.2.3-.4.1h-.3l-.2-.2-.1-.3v-.2l.2-.2.2-.1h.7m-2.2 0h-.5v-.3h.7l.2-.3v-.2h-.2l-.2-.1h-.4v2h-.4v-2.3h1.1l.3.1.2.2v.6l-.3.1-.3.1zm0 1h-.7l.2-.3h.8v-.1l.1-.2v-.2l-.1-.1h-.7v-.4h.6l.1.2h.3l.2.2v.7l-.3.2zm-2.8-.3.3-1.3h.3v.4l-.5 1.3h-.2zm-.2-1.3.2 1.3v.4H74l-.5-1.7zm1.2 1.3.2-1.3h.5l-.5 1.7h-.3zm-.3-1.3.3 1.3v.4H75l-.3-1.3-.1-.4zm-2.2 1.7h-.4a1 1 0 0 1-.5-.8v-.5l.2-.2.3-.2h.6l.3.2.1.2v.5H72v-.2h1l-.1-.3h-.1l-.2-.1-.3.1v.8l.2.1h.4l.2-.1.2.2-.1.2H73zm-1.3-2.3v2.3H71l-1-1.6v1.6h-.5v-2.3h.5l1 1.6v-1.6zm-2.1 2.2v.4h-1.5v-.3zm-1.7-2.2v.2l-.9 2h-.4l.9-2H66v-.2zm-1.9 2v.3h-1.5v-.3l.7-.8.2-.3.1-.1v-.4l-.1-.1h-.4l-.1.2v.2H64l.1-.4.3-.3h.8l.3.2v.8l-.2.2-.2.2-.5.6zm-2.4-2.1v2.4H63v-1.9l-.6.2v-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.7 173h-44.3v12h44.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e1e1e1",
    d: "m150.1 180.3-.3-.1-.4-.4-.1-.4v-.4l.2-.3.6-.2h.3l.2.2.1.3v.4h-1.2v-.2h1v-.2l-.2-.2h-.6v.3l-.1.3v.3l.1.1.4.2h.3l.2-.2.2.1-.2.2-.2.1zm-1.8-.3h.2l.2-.1v-.2h.3l-.1.3-.6.3-.3-.1-.3-.2-.1-.3v-.7l.1-.3.3-.2h.7l.2.3.1.3h-.3l-.2-.3h-.4l-.2.1v.9l.2.2zm-2.3-1.1v1.3h-.2v-1.7h.2zm0 .4v-.3l.2-.3.5-.2h.2l.2.1v.2l.1.3v1.1h-.3V179l-.1-.1h-.6zm-1 .7v-1.1l-.2-.2h-.4l-.1.1v.2h-.4v-.2l.2-.2h.2l.3-.1h.4l.2.2v1.3l.1.2h-.3zm0-.8v.2h-.7v.2l-.1.1v.2h.1l.2.1h.3l.1-.2v-.2l.2.2v.1l-.4.3h-.5l-.2-.2-.1-.2v-.3l.2-.2h.3l.3-.1zm-1.6-1.4v2.4h-.3v-2.4zm-1.1 2.2v-1.1l-.2-.2h-.4v.1l-.1.2h-.3v-.2l.2-.2h.2l.3-.1h.3l.2.2.1.3v1.2h-.2zm0-.8v.2h-.6l-.1.2v.3l.3.1h.2l.2-.2v-.2l.2.2-.1.1-.1.2-.2.1h-.6l-.2-.2v-.5l.1-.2h.3l.3-.1zm-2.3-.1h-.5v-.2h.7l.2-.2v-.4l-.1-.1h-.7v2h-.4V178h1.1l.3.1.1.2v.6l-.2.2h-.3zm0 1.1h-.6l.1-.2h.8l.2-.2v-.5l-.2-.1h-.7v-.3h.7l.3.2.2.2v.6l-.3.3zm-3.7-.2.4-1.5h.2v.3l-.5 1.4h-.2zm-.3-1.5.4 1.4v.3h-.2l-.5-1.7zm1.3 1.4.4-1.4h.3l-.5 1.7h-.2zm-.3-1.4.4 1.4v.3h-.1l-.5-1.4v-.3zm-2.2 1.8-.4-.1-.4-.4v-.8l.2-.3.5-.2h.4l.2.2.1.3v.4h-1.2v-.2h1v-.2l-.2-.2h-.6v.3l-.1.3v.3l.1.1.4.2.4-.2.2.1-.1.2-.2.1zm-1.3-2.4v2.3h-.3l-1.2-1.8v1.8h-.3V178h.3l1.2 1.8V178z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218 173h-44.3v12H218z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e1e1e1",
    d: "M194.4 178.5v.2h-1v-.2zm-.6-.5h.3v1.8l.1.1h.2v.3h-.4l-.1-.2-.1-.2zm-1.6.5.4.6.4-.6h.3l-.5.8.6.9h-.4l-.4-.7-.4.7h-.3l.6-.9-.6-.8zm-1.2 1.7h-.4l-.4-.5v-.8l.2-.2.2-.2h.6l.3.2.1.2v.5h-1.3v-.2h1v-.3l-.1-.2h-.5l-.1.1-.1.2v.6l.1.2.4.2h.3l.1-.3.2.2-.1.1-.2.2zm-1.3-2.3v2.3h-.3l-1.2-1.8v1.8h-.3v-2.3h.3l1.2 1.8v-1.8zm-3.1.6v.2h-1v-.2zm-.6-.5h.3v1.8l.1.1h.2v.3h-.4l-.1-.2zm-2.1 1.3v-.3l.1-.3.3-.2h.6l.3.2.1.3v.7l-.1.3-.6.2h-.3l-.3-.2-.1-.3zm.2 0v.3l.1.2.2.1h.4l.2-.1v-.9l-.4-.2-.4.2zm-.8-.3v.9l-.4.3h-.8l-.5-.6-.1-.5v-.6l.2-.4.3-.2h.9l.2.3.2.3h-.3l-.1-.2-.2-.2h-.6l-.2.2v.3l-.1.3v.6l.2.2.2.2h.7v-.6h-.5v-.3zm-3.7 1.2h-.3l-.4-.5-.1-.3v-.5l.2-.2.3-.2h.6l.2.2.1.2v.5H179v-.2h1v-.3l-.2-.2h-.4l-.2.1v.2l-.1.3v.3l.1.2.4.2h.3l.2-.3.1.2v.1q-.2 0-.3.2zm-3-.7.5-1.6h.2l-.1.6-.5 1.7h-.2zm-.4-1.6.3 1.5.1.8h-.2l-.6-2.3zm1.7 1.5.4-1.5h.3l-.6 2.3h-.2zm-.5-1.5.4 1.6.2.7h-.3l-.4-1.7-.2-.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.4 173H218v12h44.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e1e1e1",
    d: "m225.6 177.9-1 2.2h-.3l1-2H224v-.3zm-1.9 2.1v.2h-1.5v-.2l.8-.9.2-.2v-.8h-.6l-.1.2v.3h-.4l.1-.4.3-.3h.8l.2.2.1.4v.2l-.1.2-.2.2-.1.2-.7.7zm-2.4-2.1v2.3h-.3v-2l-.6.2v-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.7 173h-44.3v12h44.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1e3820",
    d: "M277.6 176.2h-10a2.8 2.8 0 1 0 0 5.6h10a2.8 2.8 0 1 0 0-5.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a8e6a0",
    d: "M277.5 180.1h-.3l-.4-.4v-.8l.1-.2.3-.2h.5l.2.2.2.2v.5h-1.2v-.3h1l-.1-.2-.1-.1-.3-.1h-.1l-.2.1v.2l-.1.3v.3l.1.1.2.2h.4l.2-.2.2.1-.2.2h-.2zm-1.7-.2.4-1.4h.3l-.6 1.6h-.1zm-.4-1.4.5 1.4v.2h-.2l-.6-1.6zm-.6 0v1.6h-.2v-1.6zm-.3-.4h.3v.2h-.2zm-.3.4v.2h-.9v-.2zm-.6-.4h.3v1.7h.3v.3h-.4l-.2-.1zm-.8 1.8v-1h-.2l-.2-.1h-.2v.1l-.1.1h-.3v-.1l.2-.2.2-.1h.5l.2.2.1.3v1.1h-.2zm0-.7v.2h-.6l-.1.2v.4h.2l.4-.2v-.1h.2v.2l-.2.2h-.2l-.2.1h-.3l-.2-.2v-.5l.2-.1.2-.1h.6m-2 .9h-.3l-.4-.4v-.8l.2-.2.2-.2h.6l.2.2.1.2v.5h-1.2v-.3h1v-.2l-.2-.1-.2-.1-.3.1-.1.2v.7l.2.2h.5l.2-.2.1.1-.1.2h-.2zm-1.4-1.4v1.4h-.3v-1.6h.3zm.5-.2v.2h-.3l-.1.1-.1.2v.1h-.1v-.4l.2-.2zm-1.5.9h.3l-.1.4-.3.2-.4.1h-.3l-.3-.2-.2-.4v-1l.2-.3.3-.2h.7q.2 0 .3.3l.1.3h-.3v-.2l-.2-.2h-.5q-.2 0-.2.2l-.1.2v1.1l.3.1.2.1h.3l.2-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351 173h-44.3v12H351z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#29562b",
    d: "M318.7 176.2h-6.8a2.8 2.8 0 1 0 0 5.6h6.8a2.8 2.8 0 1 0 0-5.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#66e56c",
    d: "M318.6 180h-.3l-.2-.2-.1-.2v-.7l.1-.2.5-.2h.2l.2.2.1.2v.4h-1v-.2h.8v-.2l-.1-.1h-.5l-.1.2v.7l.2.1h.4l.2-.2.2.2-.2.1-.1.1zm-1.6-.2.5-1.3h.2l-.5 1.5h-.2zm-.3-1.3.4 1.3v.2h-.1l-.5-1.5zm-.5 0v1.5h-.3v-1.5zm-.3-.4.1-.1h.1v.2zm-.4.3v.2h-.8v-.2zm-.5-.3h.3v1.6h.2v.2h-.3l-.1-.1zm-1.1 1.6h.2l.1-.1v-.2h.3v.3l-.3.2h-.6l-.2-.2-.1-.2v-.6l.1-.3.2-.1h.6q.2 0 .2.2l.1.2h-.2l-.1-.1-.1-.1h-.5v.3l-.1.1v.5h.2zm-1.7-1.6-.6 1.8h-.3l.7-2h.2zm.6 1.8-.7-1.8v-.2h.2l.7 2zm0-.7v.2h-1.2v-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.4 173H351v12h44.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e1e1e1",
    d: "M369.7 178.8v1.4h-.3v-1.7h.3zm.6-.3v.3h-.4l-.2.2v.2h-.1v-.3l.1-.2.4-.2zm-2.9.9v-.4l.2-.3.6-.2.6.2.2.3v.7l-.2.3-.6.3-.3-.1-.3-.2-.1-.3zm.3 0v.2l.2.2.1.2h.2l.4-.2v-.2l.1-.2v-.3l-.1-.2-.4-.2h-.2l-.1.2-.1.2zm-.5-.9v.2h-1v-.2zm-.7-.4h.3v1.8l.1.1h.2v.2h-.4l-.1-.1v-2m-1 1.9v-1.1l-.1-.2h-.4l-.2.1v.2h-.3v-.2l.2-.2h.2l.3-.1h.3l.2.2.1.3v1.2h-.2zm0-.8v.2h-.6l-.1.2v.3h.1l.2.1h.2l.2-.2v-.2l.2.2v.1l-.2.2-.2.1h-.6l-.2-.2v-.5l.2-.2h.2l.3-.1zm-2.2-.1h-.6v-.2h.8l.1-.2v-.4l-.1-.1h-.7v2h-.3V178h1.1l.2.1.1.2.1.3v.3l-.3.2h-.3zm0 1.1h-.7l.2-.2h.7l.2-.2v-.5l-.1-.1h-.7v-.3h.6l.3.2.2.2v.6l-.3.3zm-3.3-1.3v1.3h-.3v-1.7h.3zm0 .4h-.2v-.3l.2-.3.5-.2h.3l.1.1.1.2v1.4h-.2V179l-.2-.1h-.5zm-1.1.7v-1.1l-.1-.2h-.4l-.2.1v.2h-.3v-.2l.2-.2h.2l.3-.1h.3l.2.2.1.3v1.2h-.2zm0-.8v.2h-.6l-.1.2v.3l.3.1h.2l.2-.2v-.2l.2.2v.1l-.4.3h-.6l-.2-.2v-.2l.2-.5h.2l.3-.1zm-1.5-1.4v2.4h-.3v-2.4zm-1.1 2.2v-1.1l-.2-.2h-.4l-.1.1v.2h-.4v-.2l.2-.2h.2l.3-.1h.3l.3.2v1.3l.1.2h-.3zm0-.8v.2h-.7v.2l-.1.1v.2h.1l.2.1.4-.2v-.2l.2.2v.1l-.2.2-.2.1h-.5l-.2-.2-.1-.2.2-.5h.2l.4-.1zm-2-1.3v2.3h-.3V178zm.8 0v.3h-1.8v-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.7 173h-44.3v12h44.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e1e1e1",
    d: "M417.3 179v.3h-1.7v-.2l1-1.6h.3l-.2.5-.7 1zm-.3-1.5v2.3h-.3v-2.3zm-1.6 2.1v.3h-1.5v-.3l.7-.8.2-.3.2-.2v-.4l-.2-.1h-.5l-.1.2v.2h-.4l.1-.4.3-.2.4-.1h.4l.2.3v.7l-.2.2-.2.2-.6.7zm-2-1.1v.8l-.2.4-.2.1h-.5l-.4-.3-.1-.2V178l.2-.3.2-.2h.6l.2.1.1.2.1.3zm-.3.4v-.9l-.1-.2h-.6l-.1.3v1.3l.1.1.1.1h.4l.1-.1.1-.3zm-1.5.7v.3h-1.5v-.3l.8-.8.2-.3v-.2l.1-.2v-.2l-.2-.1h-.5l-.1.2v.2h-.4l.1-.4.3-.2.4-.1h.4l.2.3.1.3v.2l-.1.2-.2.2-.1.2-.7.7zm-2.8-.1v.5q0 .2-.2.3l-.2-.1.2-.5v-.2zm-.6-.5v.3h-1.6v-.2l1-1.6h.2l-.2.5-.7 1zm-.3-1.5v2.3h-.3v-2.3zm-1.6 2.1v.3h-1.5v-.3l.7-.8.3-.3v-.7h-.6l-.1.2v.2h-.4l.1-.4.3-.2.4-.1h.4l.2.3.1.3v.2l-.1.2-.3.4-.7.7zm-3.5.1.5-1.6h.3l-.6 2-.2.3-.2.1h-.3v-.2h.2l.1-.1.1-.2zm-.3-1.6.4 1.4.1.3h-.2l-.6-1.7zm-.9 1.5v-1.1l-.2-.1h-.5v.2h-.4v-.2l.2-.2h.3l.2-.1h.4l.2.2v1.4l.1.1h-.3zm0-.8v.2h-.7v.5l.2.1h.3l.1-.2.1-.1.1.1v.2l-.2.1-.7.1q-.2 0-.2-.2v-.5l.1-.2h.3l.3-.1zm-3.8-1.3h.3l.8 2 .7-2h.3l-1 2.3h-.2zm-.1 0h.3v2.4h-.3zm2 0h.3v2.3h-.3z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "aD",
    width: 380,
    height: 12,
    x: 60,
    y: 173,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _use30 || (_use30 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aB"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#aD)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#616467",
    d: "M439.7 184.6v-.2H60v.5h379.7z"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 6.2,
    x2: 12.4,
    y1: 10.3,
    y2: 3.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4285f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ea4335"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 19.1,
    x2: 19.1,
    y1: 3.7,
    y2: 9.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ea4335"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbbc04"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 3.8,
    x2: 61.7,
    y1: 37.9,
    y2: 44.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4285f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ea4335"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbbc04"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 56.6,
    x2: 181,
    y1: 7.4,
    y2: 23.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4285f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ea4335"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbbc04"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 56.6,
    x2: 181,
    y1: 7.4,
    y2: 23.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4285f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ea4335"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbbc04"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 56.6,
    x2: 181,
    y1: 7.4,
    y2: 23.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4285f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ea4335"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbbc04"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: 56.6,
    x2: 181,
    y1: 7.4,
    y2: 23.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4285f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ea4335"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbbc04"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: 56.6,
    x2: 181,
    y1: 7.4,
    y2: 23.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4285f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ea4335"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbbc04"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x1: 56.6,
    x2: 181,
    y1: 7.4,
    y2: 23.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4285f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ea4335"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbbc04"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    x1: 56.6,
    x2: 181,
    y1: 7.4,
    y2: 23.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4285f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ea4335"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbbc04"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    x1: 56.6,
    x2: 181,
    y1: 7.4,
    y2: 23.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4285f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ea4335"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbbc04"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "v",
    x1: 56.6,
    x2: 181,
    y1: 7.4,
    y2: 23.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4285f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ea4335"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbbc04"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "w",
    x1: 56.6,
    x2: 181,
    y1: 7.4,
    y2: 23.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4285f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ea4335"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbbc04"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "x",
    x1: 56.6,
    x2: 181,
    y1: 7.4,
    y2: 23.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4285f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ea4335"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbbc04"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "y",
    x1: 56.6,
    x2: 181,
    y1: 7.4,
    y2: 23.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4285f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ea4335"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbbc04"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "z",
    x1: 56.6,
    x2: 181,
    y1: 7.4,
    y2: 23.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4285f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ea4335"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbbc04"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "A",
    x1: 56.6,
    x2: 181,
    y1: 7.4,
    y2: 23.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4285f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ea4335"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbbc04"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "B",
    x1: 56.6,
    x2: 181,
    y1: 7.4,
    y2: 23.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4285f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ea4335"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbbc04"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "C",
    x1: 56.6,
    x2: 181,
    y1: 7.4,
    y2: 23.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4285f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ea4335"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbbc04"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D",
    x1: 56.6,
    x2: 181,
    y1: 7.4,
    y2: 23.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4285f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ea4335"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbbc04"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "E",
    x1: 56.6,
    x2: 181,
    y1: 7.4,
    y2: 23.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4285f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ea4335"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbbc04"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "F",
    x1: 56.6,
    x2: 326.9,
    y1: 29.7,
    y2: 99.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4285f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ea4335"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbbc04"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aa",
    x1: 334.2,
    x2: 442.7,
    y1: 28.4,
    y2: 95.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4285f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ea4335"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbbc04"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ak",
    x1: 55.3,
    x2: 313.3,
    y1: 98.4,
    y2: 333.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4285f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ea4335"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbbc04"
  })), /*#__PURE__*/React.createElement("path", {
    id: "k",
    fill: "#fff",
    d: "M444.4 0H60.9v15h383.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "G",
    fill: "#fff",
    d: "M68.4 47.6h-3.7v3.3h3.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "J",
    fill: "#fff",
    d: "M122 47.6h-3.8v3.3h3.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "M",
    fill: "#fff",
    d: "M175.5 47.6h-3.7v3.3h3.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "P",
    fill: "#fff",
    d: "M229.1 47.6h-3.7v3.3h3.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "S",
    fill: "#fff",
    d: "M282.7 47.6h-3.8v3.3h3.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "V",
    fill: "#fff",
    d: "M68.4 72.4h-3.7v3.3h3.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ab",
    fill: "#fff",
    d: "M339 42.2h100.7v11.3H338.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ae",
    fill: "#fff",
    d: "M339 53.5h100.7v11.2H338.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ah",
    fill: "#fff",
    d: "M339 64.7h100.7V76H338.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ap",
    fill: "#fff",
    d: "M60 128.4h379.7v11.3H60z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "as",
    fill: "#fff",
    d: "M60 139.7h379.7v11.2H60z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "av",
    fill: "#fff",
    d: "M60 151h379.7v11.2H60z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ay",
    fill: "#fff",
    d: "M60 162.2h379.7v11.2H60z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aB",
    fill: "#fff",
    d: "M60 173.4h379.7v11.2H60z"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "h",
    width: 27.4,
    height: 17.1,
    x: 1.8,
    y: 18.2,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.303597 0 0 0 0 0.303597 0 0 0 0 0.303597 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_103_63262"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_103_63262",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "am",
    width: 31.8,
    height: 18.4,
    x: 388.7,
    y: 99.1,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_103_63262"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_103_63262",
    result: "effect2_dropShadow_103_63262"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect2_dropShadow_103_63262",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect3_innerShadow_103_63262"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 450,
    height: 253,
    fill: "#fff",
    rx: 8
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "Z",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ao",
    transform: "scale(0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTourGraphic3);
export default __webpack_public_path__ + "static/media/Tour-Graphic-3.2dec5d5ff9020b6efed0fab765a8d38b.svg";
export { ForwardRef as ReactComponent };